$(document).ready(function () {
  let productNavSlider = $(".product-nav-slider");
  let productThumbSlider = $(".product-thumb-slider");

  if (
    productNavSlider.length > 0 &&
    !productNavSlider.hasClass("slick-initialized") &&
    productThumbSlider.length > 0 &&
    !productThumbSlider.hasClass("slick-initialized")
  ) {
    // The two sliders used to be bound with slick's `asNavFor` + `focusOnSelect`.
    // That behaviour auto-scrolls the thumb strip to keep the clicked thumb
    // visible — which feels "jumpy" because the strip reorders under the
    // cursor. The new design keeps the thumb strip in a fixed order and only
    // moves it when the user uses the up/down arrows (or clicks beyond the
    // current viewport).
    //
    // Implementation: initialise both sliders standalone, then manually bind
    // thumb clicks to `slickGoTo` on the main slider. Arrows control the
    // thumb strip's own scroll; clicks on visible thumbs do NOT move the
    // strip, only the main image.
    productNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      // Dots always enabled at the JS level — visibility is then gated
      // via CSS so they appear only on mobile (where the thumbnail strip
      // is hidden, so the dots become the "more images available"
      // affordance). Slick's `responsive` option doesn't reliably create
      // / destroy dots on resize, so the always-on-then-CSS-hide pattern
      // is more robust than a breakpoint-specific init.
      dots: true,
      fade: false,
      infinite: false,
      speed: 300,
      prevArrow:
        '<button type="button" class="nav-prev-arrow" aria-label="Previous image"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1L1 9L9 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="nav-next-arrow" aria-label="Next image"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L9 9L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });

    // Vertical thumbs on the left for desktop/tablet; horizontal strip below
    // the main image on mobile.
    var useVerticalThumbs = window.matchMedia("(min-width: 768px)").matches;

    productThumbSlider.slick({
      // Mobile shows ~4 thumbs across an ~360-400px viewport (each thumb
      // is 81px including its 7px L/R padding → ~95px outer width). The
      // old setting of 8 was unrealistic and pushed slick into a degenerate
      // "all slides visible / nothing to scroll" state on small screens.
      slidesToShow: useVerticalThumbs ? 5 : 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      speed: 300,
      centerMode: false,
      // Explicit width on each thumb (set in CSS) means we don't need
      // variableWidth — slick computes slide width from slidesToShow / list
      // width, which is more predictable for swipe distance + arrow paging.
      variableWidth: false,
      vertical: useVerticalThumbs,
      verticalSwiping: useVerticalThumbs,
      swipe: true,
      touchMove: true,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 7L7 1L1 7" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    });

    // Manual click sync — changes the main image, and auto-scrolls the thumb
    // strip by one step when the user clicks the LAST-visible (or FIRST-
    // visible) thumb. That way any click on an interior thumb keeps the row
    // stationary, but clicking the edge advances it to reveal the next set.
    productThumbSlider.on("click", ".main-product__slider-media", function () {
      if ($(this).hasClass("slick-cloned")) return; // defensive (no clones with infinite:false)
      var index = $(this).data("slick-index");
      if (typeof index !== "number") return;

      productNavSlider.slick("slickGoTo", index);

      var $active = productThumbSlider.find(".main-product__slider-media.slick-active");
      var firstVisible = $active.first().data("slick-index");
      var lastVisible = $active.last().data("slick-index");
      var total = productThumbSlider.find(".main-product__slider-media").length;

      if (index === lastVisible && index < total - 1) {
        productThumbSlider.slick("slickNext");
      } else if (index === firstVisible && index > 0) {
        productThumbSlider.slick("slickPrev");
      }
    });

    // Active-thumb highlight. Paints the currently-shown image's thumb with
    // the active state, but never scrolls the strip to reveal it.
    function setActiveThumb(index) {
      productThumbSlider
        .find(".main-product__slider-media")
        .removeClass("is-active-thumb");
      productThumbSlider
        .find('.main-product__slider-media[data-slick-index="' + index + '"]')
        .addClass("is-active-thumb");
    }
    productNavSlider.on("afterChange", function (event, slick, currentSlide) {
      setActiveThumb(currentSlide);
    });
    setActiveThumb(0);

    // Slick measures container width at init time. On mobile the gallery
    // sits inside a `display: flex; flex-direction: column` wrapper whose
    // children's cross-axis (=width) sometimes hasn't fully settled by
    // the time `$(document).ready` fires (especially with web fonts or
    // late-loading CSS in flight). When that happens slick records each
    // slide as 0px wide, the main image collapses (`padding-top: 100%` of
    // 0 = 0 height), and the gallery looks broken until the user clicks
    // next/prev — which forces slick to re-layout.
    //
    // Fix: re-call `setPosition` once layout is guaranteed to be settled.
    // - rAF after init handles the common case (next paint frame).
    // - window.load handles the slow-load case (images / fonts pending).
    // - 250ms safety net handles the rare case where neither has resolved
    //   the measurement yet (some Safari iOS edge cases).
    function refreshSlidersPosition() {
      if (productNavSlider.hasClass("slick-initialized")) {
        productNavSlider.slick("setPosition");
      }
      if (productThumbSlider.hasClass("slick-initialized")) {
        productThumbSlider.slick("setPosition");
      }
    }
    requestAnimationFrame(refreshSlidersPosition);
    $(window).on("load", refreshSlidersPosition);
    setTimeout(refreshSlidersPosition, 250);
  }

  // add click event on bespoke color change
  $('input[name="bespoke-option"]').on("change", function () {
    let bespokeOptionValue = $('input[name="bespoke-option"]:checked').val();
    if (bespokeOptionValue === "yes") {
      $(".main-product__customise-wrapper.hex_color_option_wrapper").show();
      $(".color_selection_options_wrapper").hide();
    } else {
      $(".main-product__customise-wrapper.hex_color_option_wrapper").hide();
      $(".color_selection_options_wrapper").show();
    }
  });

  const logoWizardState = {
    enabled: false,
    currentStepIndex: 0,
    completedItems: [],
    queuedSizes: [],
    isAddingAdditionalItem: false,
    isSubmissionComplete: false,
    currentDesignExcluded: false,
    $customiseSelection: $(),
    $designSteps: $(),
    $sizeStep: $(),
    $sizeRowsContainer: $(),
    quantitySelections: [],
    $quantityStep: $(),
    $quantityList: $(),
    $reviewStep: $(),
    $detailsStep: $(),
    $volumeInfoBar: $(),
    $backButton: $(),
    $nextButton: $(),
    $progressCurrent: $(),
    $progressTotal: $(),
    $progressBarFill: $(),
    $progressDots: $(),
    $summaryList: $(),
    $summaryHelpText: $(),
    $continueDetailsButton: $(),
    $queuedSizeList: $(),
    /* v3 flow (23-Sep-2026): index of the step to jump back to after an
       "Edit" from the details summary, or null when navigating normally. */
    returnToIndex: null,
    $generateProxy: $(),
    $band: $(),
    $helpMenu: $(),
  };

  /* v3 wizard copy (23-Sep-2026 redesign) — the band title/sub-line per step
     type. Signed off by Jack; sentence case except the Title Case H2. */
  const LMW_STEP_META = {
    location: ["Location", "Where Will It Go?", "This decides how we finish the edges of your mat."],
    size: ["Size", "How Big Does It Need To Be?", "Pick which way round, then enter or choose a size."],
    quantity: ["Quantity", "How Many Mats?", "The more you order, the lower the price per mat."],
    upload: ["Your logo", "Upload Your Logo", "Any format is fine — our designers tidy it up for print at no charge."],
    details: ["Details", "Last Step — Your Details", "Submit and your proof is generated instantly, ready to edit and finalise."],
  };

  function getWizardStepType($step) {
    if (!$step || !$step.length) return "";
    if (logoWizardState.$detailsStep.length && $step.is(logoWizardState.$detailsStep)) return "details";
    if ($step.find(".main-product__backing-option").length) return "location";
    if ($step.find(".main-product__size-option").length) return "size";
    if ($step.find(".main-product__quantity-option").length) return "quantity";
    if ($step.find(".main-product__upload-option").length) return "upload";
    return "";
  }

  function hasReturnTarget() {
    return logoWizardState.returnToIndex !== null && logoWizardState.returnToIndex !== undefined;
  }

  /* In-step interaction events (23-Sep-2026). Pushed to the GTM dataLayer;
     posthog-init.liquid mirrors every push into PostHog, so one call serves
     both. The step-view / complete / proof events stay where they are
     (snippets/lm-form-tracking.liquid and the submit handler). */
  function lmwTrack(eventName, props) {
    try {
      const DL = (window.dataLayer = window.dataLayer || []);
      const $root = $(".main-product__customise-selection").first();
      const allSteps = logoWizardState.enabled ? getWizardSteps() : [];
      /* Same names as lm-form-tracking.liquid's lm_step_name so the two
         event families join up in PostHog. */
      const stepNames = { upload: "upload_logo", details: "contact_details" };
      const rawType = allSteps.length
        ? getWizardStepType($(allSteps[logoWizardState.currentStepIndex]))
        : "";
      const stepType = stepNames[rawType] || rawType;
      DL.push(
        Object.assign(
          {
            event: eventName,
            lm_product_handle: safeTrim($root.attr("data-product-handle") || ""),
            lm_step_name: stepType,
          },
          props || {}
        )
      );
    } catch (e) {
      /* analytics must never break the form */
    }
  }

  /* Default background colour follows the logo (23-Sep-2026, Jack). The
     Background colour step is no longer shown, so the swatch that ends up
     checked decides the instant proof's mat colour. eq-custom.js samples the
     uploaded file and fires `lmw:logo-brightness`; a dark logo (mean
     luminance of its opaque pixels < 0.45) gets the lightest low-saturation
     swatch available (a light grey), anything else — and no logo — gets the
     first swatch (the default, black on the indoor mats). The customer can
     still change it in the proof editor. Swatch hex values come from the
     radio `value`s the colour step already renders. */
  const LMW_DARK_LOGO_THRESHOLD = 0.45;

  function hexToRgb(hex) {
    const clean = safeTrim(hex).replace("#", "");
    const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
    if (!/^[0-9a-f]{6}$/i.test(full)) return null;
    return {
      r: parseInt(full.slice(0, 2), 16),
      g: parseInt(full.slice(2, 4), 16),
      b: parseInt(full.slice(4, 6), 16),
    };
  }

  function pickBackgroundSwatchForLogo(info) {
    const $swatches = $('input[name="background-color-swatch"]').not("#background-custom-colour");
    if (!$swatches.length) return;
    let $target = $swatches.first();

    if (info && typeof info.luminance === "number" && info.luminance < LMW_DARK_LOGO_THRESHOLD) {
      let best = null;
      let bestLum = -1;
      let bestAny = null;
      let bestAnyLum = -1;
      $swatches.each(function () {
        const rgb = hexToRgb(this.value);
        if (!rgb) return;
        const lum = (0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b) / 255;
        const max = Math.max(rgb.r, rgb.g, rgb.b);
        const min = Math.min(rgb.r, rgb.g, rgb.b);
        const sat = max ? (max - min) / max : 0;
        if (lum > bestAnyLum) { bestAnyLum = lum; bestAny = this; }
        if (sat <= 0.2 && lum > bestLum) { bestLum = lum; best = this; }
      });
      const chosen = best || bestAny;
      if (chosen) $target = $(chosen);
    }

    if (!$target.is(":checked")) {
      $target.prop("checked", true).trigger("change");
    }
    logoWizardState.autoBackgroundName = safeTrim($target.attr("data-color-name")) || safeTrim($target.val());
    if (info && typeof info.luminance === "number") {
      lmwTrack("lm_mat_colour_auto", {
        lm_colour: logoWizardState.autoBackgroundName,
        lm_dark_logo: info.luminance < LMW_DARK_LOGO_THRESHOLD,
        lm_logo_luminance: Math.round(info.luminance * 100) / 100,
      });
    }
  }

  document.addEventListener("lmw:logo-brightness", function (e) {
    pickBackgroundSwatchForLogo(e && e.detail ? e.detail : null);
    if (logoWizardState.enabled && logoWizardState.$summaryList && logoWizardState.$summaryList.length) {
      updateWizardSummary();
    }
    /* AFTER the swatch is picked, never before: the mat colour is part of the
       cache key, so prewarming with the wrong one spends an Atlas call nobody
       uses and leaves the customer the full wait anyway. */
    prewarmLogoSprite();
  });

  /* CLEAN THE LOGO WHILE THE CUSTOMER IS STILL TYPING (23-Sep-2026).

     The Atlas flatten is what a proof waits for: measured live across five real
     uploads, 27.4-32.5s cold against 1.2-2.0s on replay. Over the seven days to
     23-Sep the median proof took 39.8s and the 90th percentile 69.2s, against
     the 95s client timeout below — which is where "We couldn't reach the proof
     service" came from. Running the flatten here means the submit replays a
     sprite that is already cleaned and pinned.

     It can hit because this wizard asks in the right order: location, then
     orientation and size, then quantity, THEN the logo. The cache key is
     (logo bytes, colour, quality, print trim size) and by this point every part
     of it is settled — including the colour, which `pickBackgroundSwatchForLogo`
     has just chosen from the logo's own brightness.

     Fire-and-forget by design. The endpoint answers 200 with a reason for
     anything it declines and never blocks; a failure here must not cost the
     customer their upload step, and a miss simply means the submit flattens as
     it does today. */
  function prewarmLogoSprite() {
    try {
      const logoUrl = safeTrim($(".main-product__uploaded-file-url").val());
      if (!logoUrl) return;
      const design = buildCurrentDesignItem() || {};
      fetch(LOGO_PREWARM_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        /* The submission sends `size` blank for a custom mat and carries the
           dimensions instead; the trim is built the same way server-side, so
           this must match or the key will not. */
        body: JSON.stringify({
          logoUrl: logoUrl,
          matSize: safeTrim(design.customWidth ? "" : design.size),
          customWidth: safeTrim(design.customWidth),
          customLength: safeTrim(design.customLength),
          orientation: safeTrim(design.orientation) || "landscape",
          showRubberBorder: !isMatwellLocationSelected(),
          backgroundColor: safeTrim(design.backgroundColor || design.color),
        }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {
      /* Never let a prewarm affect the form. */
    }
  }

  function safeTrim(value) {
    if (value === undefined || value === null) {
      return "";
    }
    return String(value).trim();
  }

  function getCustomDimensionsLabel() {
    const width = safeTrim($('input[name="width"]').val());
    const length = safeTrim($('input[name="length"]').val());
    if (!width || !length) {
      return "";
    }
    return `${width}cm x ${length}cm`;
  }

  function getCustomSizeDisplayText() {
    const dimensionsLabel = getCustomDimensionsLabel();
    return dimensionsLabel
      ? `Custom Size (${dimensionsLabel})`
      : "Need a custom size?";
  }

  function isCustomOptionElement($option) {
    if (!$option || !$option.length) {
      return false;
    }
    const optionText = safeTrim($option.attr("data-text") || $option.text()).toLowerCase();
    return optionText.indexOf("custom") > -1 || optionText.indexOf("bespoke") > -1;
  }

  function isCustomSelectionForSizeSelect($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return false;
    }
    const $activeOption = $sizeSelect
      .find(".cw-product-bundle__variant-options .cw-product-bundle__variant-option.active-status")
      .first();
    if ($activeOption.length > 0) {
      return isCustomOptionElement($activeOption);
    }
    const selectedText = safeTrim(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    ).toLowerCase();
    return selectedText.indexOf("custom") > -1 || selectedText.indexOf("bespoke") > -1;
  }

  function normalizeComparableLabel(value) {
    return safeTrim(value).toLowerCase().replace(/\s+/g, " ");
  }

  function resolveSizeSelectMatchedOption($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return $();
    }

    const $options = $sizeSelect.find(
      ".cw-product-bundle__variant-options .cw-product-bundle__variant-option"
    );
    if ($options.length === 0) {
      return $();
    }

    const selectedDisplayText = normalizeComparableLabel(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    );
    const selectedHiddenValue = normalizeComparableLabel(
      $sizeSelect.find('input[type="hidden"]').val()
    );

    let $matchedOption = $();

    if (selectedHiddenValue) {
      $matchedOption = $options.filter(function () {
        const $option = $(this);
        const optionDataText = normalizeComparableLabel($option.attr("data-text"));
        const optionLabelText = normalizeComparableLabel(
          $option.find(".cw-product-bundle__option-text").first().text() || $option.text()
        );
        const optionDisplayText = normalizeComparableLabel($option.attr("data-display-text"));
        return (
          selectedHiddenValue === optionDataText ||
          selectedHiddenValue === optionLabelText ||
          selectedHiddenValue === optionDisplayText
        );
      }).first();
    }

    if ($matchedOption.length === 0 && selectedDisplayText) {
      $matchedOption = $options.filter(function () {
        const $option = $(this);
        const optionDataText = normalizeComparableLabel($option.attr("data-text"));
        const optionLabelText = normalizeComparableLabel(
          $option.find(".cw-product-bundle__option-text").first().text() || $option.text()
        );
        const optionDisplayText = normalizeComparableLabel($option.attr("data-display-text"));
        return (
          selectedDisplayText === optionDataText ||
          selectedDisplayText === optionLabelText ||
          selectedDisplayText === optionDisplayText
        );
      }).first();
    }

    return $matchedOption;
  }

  function resolveSizeSelectVariantId($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return "";
    }

    const activeVariantId = safeTrim(
      $sizeSelect
        .find(".cw-product-bundle__variant-options .cw-product-bundle__variant-option.active-status")
        .first()
        .attr("data-variant-id")
    );
    if (activeVariantId) {
      return activeVariantId;
    }

    const persistedVariantId = safeTrim($sizeSelect.attr("data-selected-variant-id"));
    if (persistedVariantId) {
      return persistedVariantId;
    }

    const $matchedOption = resolveSizeSelectMatchedOption($sizeSelect);
    if ($matchedOption.length > 0) {
      return safeTrim($matchedOption.attr("data-variant-id"));
    }

    return "";
  }

  function isCustomSizeSelectedOnSizeSelect($sizeSelect) {
    if (!$sizeSelect || !$sizeSelect.length) {
      return false;
    }

    const persistedCustomFlag = safeTrim($sizeSelect.attr("data-selected-is-custom-size")).toLowerCase();
    if (persistedCustomFlag === "true") {
      return true;
    }
    if (persistedCustomFlag === "false") {
      return false;
    }

    const $matchedOption = resolveSizeSelectMatchedOption($sizeSelect);
    if ($matchedOption.length > 0) {
      return isCustomOptionElement($matchedOption);
    }

    return isCustomSelectionForSizeSelect($sizeSelect);
  }

  /* customPriceHandler() lives OUTSIDE this ready scope (page-global) yet
     calls updateCustomSizeLabels() at the end of calculatePrice — a
     pre-existing ReferenceError on every custom-size keystroke that
     silently aborted the tail of calculatePrice. Expose it (23-Sep-2026). */
  window.updateCustomSizeLabels = function () {
    return updateCustomSizeLabels();
  };

  function updateCustomSizeLabels() {
    const dimensionsLabel = getCustomDimensionsLabel();
    const customDisplayText = dimensionsLabel
      ? `Custom Size (${dimensionsLabel})`
      : "Custom size";

    $(".main-product__size-option .cw-product-bundle__variant-option--custom-size").each(function () {
      const $option = $(this);
      const $optionText = $option.find(".cw-product-bundle__option-text").first();
      if ($optionText.length > 0) {
        $optionText.text(customDisplayText);
      }
      $option.attr("data-display-text", customDisplayText);
    });

    $(".main-product__size-option .cw-product-bundle__variant-select").each(function () {
      const $sizeSelect = $(this);
      if (!isCustomSelectionForSizeSelect($sizeSelect)) {
        return;
      }
      const $selectedText = $sizeSelect
        .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text")
        .first();
      if ($selectedText.length > 0) {
        $selectedText.text(customDisplayText);
      }
    });
  }

  function escapeHtml(value) {
    return safeTrim(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function isMatwellLocationSelected() {
    return $("#location-option-2").is(":checked");
  }

  /* Recessed (borderless) mats are cut oversize so they can be trimmed to fit
     the matwell: production adds 3cm to BOTH the width and the length. The
     custom-size hero used to promise "your exact measurements" regardless of
     location, which was wrong for a recess (team review, 17-Sep-2026). */
  const MATWELL_TRIM_ALLOWANCE_CM = 3;

  function getCustomSizeSubCopy() {
    return isMatwellLocationSelected()
      ? `Enter your recess size — we add ${MATWELL_TRIM_ALLOWANCE_CM}cm to the width and length so the mat can be trimmed to fit.`
      : "Made to your exact measurements — our most popular choice.";
  }

  function syncCustomSizeSubCopy() {
    $(".main-product__size-option .cw-product-bundle__custom-sub").text(getCustomSizeSubCopy());
  }

  function updateMatwellDependentUI() {
    const isMatwell = isMatwellLocationSelected();
    const $colorPickerWrap = $(".main-product__color-picker-cta-wrap");
    const $customColourSwatch = $("#background-custom-colour");
    const $sizeNote = $(".logo-mat-wizard__matwell-size-note");
    const $colorSwatches = $('input[name="background-color-swatch"]');
    const $fallbackSwatch = $colorSwatches.not($customColourSwatch).first();

    if ($sizeNote.length) {
      $sizeNote.toggle(isMatwell);
    }

    syncCustomSizeSubCopy();
    /* Limits, readout ("Made … so it can be trimmed") and the diagram border
       all follow the location. */
    if (typeof refreshCustomSizeUI === "function") {
      refreshCustomSizeUI();
    }

    if ($colorPickerWrap.length) {
      $colorPickerWrap.toggle(!isMatwell);
    }

    if ($customColourSwatch.length) {
      $customColourSwatch.prop("disabled", isMatwell);
      if (isMatwell && $customColourSwatch.is(":checked") && $fallbackSwatch.length) {
        $fallbackSwatch.prop("checked", true).trigger("change");
      }
    }

    $("#backgroundCustomColourTrigger, #backgroundCustomColourInput, #backgroundCustomColourHex").prop(
      "disabled",
      isMatwell
    );
  }

  function parseCurrencyAmount(value) {
    const rawValue = safeTrim(value);
    if (!rawValue) {
      return null;
    }
    const normalized = rawValue.replace(/[^0-9.\-]/g, "");
    if (!normalized) {
      return null;
    }
    const parsedValue = parseFloat(normalized);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  function parsePercentAmount(value) {
    const rawValue = safeTrim(value);
    if (!rawValue) {
      return null;
    }
    const normalized = rawValue
      .replace(/save/gi, "")
      .replace(/[^0-9.\-]/g, "");
    if (!normalized) {
      return null;
    }
    const parsedValue = parseFloat(normalized);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  function parseQuantityValue(value) {
    const rawValue = safeTrim(value);
    if (!rawValue) {
      return null;
    }
    const parsedValue = parseFloat(rawValue.replace(/[^0-9.\-]/g, ""));
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  function roundToTwo(value) {
    if (!Number.isFinite(value)) {
      return null;
    }
    return Math.round(value * 100) / 100;
  }

  function formatMoneyAmount(value) {
    if (!Number.isFinite(value)) {
      return "";
    }
    const amountInPence = Math.round(value * 100);
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(amountInPence);
    }
    return `£${value.toFixed(2)}`;
  }

  function getQuantityDiscountTiers() {
    const tierMap = { 2: 0, 3: 0, 4: 0 };
    [2, 3, 4].forEach((tierQty) => {
      const tierRaw = safeTrim(
        $(
          `.main-product__quantity-option .cw-product-bundle__variant-option[data-selected-qty="${tierQty}"]`
        ).attr("data-save-percentage")
      );
      const tierPercent = parsePercentAmount(tierRaw);
      tierMap[tierQty] = tierPercent !== null ? tierPercent : 0;
    });
    return tierMap;
  }

  function getDiscountPercentForQty(quantity, tiers) {
    if (quantity >= 4) {
      return tiers[4] || 0;
    }
    if (quantity === 3) {
      return tiers[3] || 0;
    }
    if (quantity === 2) {
      return tiers[2] || 0;
    }
    return 0;
  }

  const INSTANT_PROOF_API_URL =
    window.logoMatInstantProofEndpoint ||
    "https://process-fm-logomat-designs.azurewebsites.net/api/proofs/create";
  /* Cleaning the logo is the whole of the proof wait, so it starts the moment
     the customer picks their file rather than when they submit. See
     `prewarmLogoSprite`. */
  const LOGO_PREWARM_API_URL =
    window.logoMatPrewarmEndpoint ||
    "https://process-fm-logomat-designs.azurewebsites.net/api/logos/prewarm";
  /* Must exceed the server's WHOLE-REQUEST budget with margin. If the browser
     gives up before the server answers, the customer sees the manual-fallback
     message while a finished proof goes unseen.

     Raised 65000 -> 95000 on 17-Sep-2026, ahead of the server move from a 45s
     AI budget / 60s whole-request budget to 75s / 90s. 95s clears the new 90s
     server ceiling by 5s.

     ORDERING: this client change must be LIVE BEFORE the server budgets are
     raised. Raise the server first and every request between 65s and the new
     server ceiling is abandoned by the page, so customers get an error instead
     of the classic-renderer proof they get today.

     Why the headroom is needed: an Atlas logo render measures ~28-31s, and some
     paths make two sequential calls plus our own compose, ~63s in total. Under
     the old 45s AI budget anything past 45s silently downgraded to the
     lower-quality classic renderer (15% of recent proofs).

     PROOF_OVERLAY_CEILING_MS below tracks the server whole-request budget and
     must be re-checked whenever this value moves. */
  const INSTANT_PROOF_CLIENT_TIMEOUT_MS = parseInt(
    window.logoMatInstantProofClientTimeoutMs || "95000",
    10
  );

  function normalizeInstantProofOutcome(rawResponse, fallbackStatus) {
    const raw = rawResponse || {};
    const normalizedStatus = safeTrim(raw.instantProofStatus || fallbackStatus || "failed").toLowerCase();
    const isSuccess = normalizedStatus === "success";
    const resolvedProofMode =
      safeTrim(raw.proofMode || (isSuccess ? "instant" : "manual")).toLowerCase() ||
      (isSuccess ? "instant" : "manual");

    return {
      instantProofStatus: normalizedStatus,
      proofMode: resolvedProofMode,
      requiresManualReview:
        typeof raw.requiresManualReview === "boolean"
          ? raw.requiresManualReview
          : !isSuccess,
      proofId: safeTrim(raw.proofId),
      proofUrl: safeTrim(raw.proofUrl),
      proofImageUrl: safeTrim(raw.proofImageUrl || raw.previewImageUrl),
      draftOrderId: safeTrim(raw.draftOrderId),
      draftOrderInvoiceUrl: safeTrim(raw.draftOrderInvoiceUrl),
      renderDurationMs:
        raw.renderDurationMs !== undefined && raw.renderDurationMs !== null
          ? parseInt(raw.renderDurationMs, 10)
          : null,
      errorCode: safeTrim(raw.errorCode || (isSuccess ? "" : normalizedStatus)),
      errorMessage: safeTrim(raw.message || raw.errorMessage),
      rawStatus: safeTrim(raw.status).toLowerCase(),
    };
  }

  /* Marketing consent — read from Shopify's Customer Privacy API
     (populated by Consentmo, which writes consent into Shopify's
     consent state). STRICTLY READ-ONLY: this never sets or modifies
     consent, it only reports what the visitor has already chosen.

     Resolution order (per the enquiry-database spec):
       1. Explicit `currentVisitorConsent().marketing` when it is an
          unambiguous "yes" or "no".
       2. If that's blank, fall back to `marketingAllowed()`.
       3. If the API is missing → source "shopify_customer_privacy_unavailable".
       4. If the API throws → source "shopify_customer_privacy_error".
     In cases 3/4 we default `allowed` to false (fail-closed: never
     claim consent we couldn't confirm).

     Returns a normalised object the ProofCreate payload spreads into
     its consent fields; the Function App maps them to Dataverse
     cr174_marketingconsent. */
  function getShopifyMarketingConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) {
        return {
          allowed: false,
          source: "shopify_customer_privacy_unavailable",
          shopifyMarketing: "",
          shopifyAllowed: false,
          consentId: ""
        };
      }

      // Raw explicit visitor consent for marketing: "yes" | "no" | ""
      var explicit = "";
      try {
        var visitorConsent = cp.currentVisitorConsent && cp.currentVisitorConsent();
        explicit = (visitorConsent && visitorConsent.marketing) || "";
      } catch (e) { explicit = ""; }

      // marketingAllowed() boolean (fallback signal)
      var allowedBool = false;
      try {
        allowedBool = !!(cp.marketingAllowed && cp.marketingAllowed());
      } catch (e) { allowedBool = false; }

      // consentId() — audit context only
      var consentId = "";
      try {
        consentId = (cp.consentId && cp.consentId()) || "";
      } catch (e) { consentId = ""; }

      var allowed;
      var source;
      if (explicit === "yes") {
        allowed = true;
        source = "shopify_current_visitor_consent";
      } else if (explicit === "no") {
        allowed = false;
        source = "shopify_current_visitor_consent";
      } else {
        allowed = allowedBool;
        source = "shopify_marketing_allowed";
      }

      return {
        allowed: allowed,
        source: source,
        shopifyMarketing: explicit,
        shopifyAllowed: allowedBool,
        consentId: consentId
      };
    } catch (e) {
      return {
        allowed: false,
        source: "shopify_customer_privacy_error",
        shopifyMarketing: "",
        shopifyAllowed: false,
        consentId: ""
      };
    }
  }

  /* ——— VAT display mode (31-Jul-2026) ———
     fm-vat.js owns the site's ex/inc price display. THREE signals switch it to
     inc-VAT — `incl_vat=true` (the parameter Google Shopping / PMax feed URLs
     carry to satisfy "show the actual price"), a `gclid` on any Google Ads
     click, and utm_source=google + utm_medium=cpc — and the choice then
     persists for the session in sessionStorage.

     So the URL parameter is NOT a reliable signal at submit time: the customer
     may be several pages past the landing URL, and two of the three signals
     never involve `incl_vat` at all. `window.fmVatMode` is the single resolved
     value every signal collapses into, mirrored on <html data-vat-mode> as a
     fallback for the case where this runs before fm-vat.js has set the global.

     Display only. Every money value in the payload stays EX-VAT regardless of
     this; the proof page uses the mode to decide how to PRESENT them, so the
     customer sees prices on the same basis they were browsing in. */
  function getVatDisplayMode() {
    let mode = safeTrim(window.fmVatMode);
    if (!mode && document.documentElement) {
      mode = safeTrim(document.documentElement.getAttribute("data-vat-mode"));
    }
    return mode.toLowerCase() === "inc" ? "inc" : "ex";
  }

  /* Read the EX-VAT price for a size select, whatever the display mode.
     The option renderer writes `data-ex-price` / `data-inc-price` onto the
     selected-price span alongside the display text, for standard sizes
     (Liquid-rendered `data-price` / `data-price-inc`) and for custom sizes
     (computed in the custom-size handler). The attribute is untouched by the
     ex/inc toggle, so it is the safe thing to read — `.text()` is whatever the
     customer is currently being shown.

     Falls back to the visible text when the attribute is missing, which is
     also correct in the default ex mode. */
  function readExVatPriceFromSizeSelect($sizeSelect) {
    if (!$sizeSelect || $sizeSelect.length === 0) {
      return "";
    }
    const $price = $sizeSelect
      .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
      .first();
    if ($price.length === 0) {
      return "";
    }
    return safeTrim($price.attr("data-ex-price")) || safeTrim($price.text());
  }

  function buildInstantProofRequestPayload(customerData, primaryDesign, designItems, designItemsObject) {
    const primaryDesignObject =
      Array.isArray(designItemsObject) && designItemsObject.length > 0
        ? designItemsObject[0]
        : null;
    const quantityValue = normalizeQuantityValue(
      (primaryDesignObject && primaryDesignObject.quantityValue) ||
        parseQuantityValue(primaryDesign.quantity) ||
        parseQuantityValue(customerData["Quantity Value"]) ||
        parseQuantityValue(customerData["Quantity"]) ||
        1
    );
    const variantIdValue = safeTrim(
      (primaryDesignObject && primaryDesignObject.productVariantId) ||
        primaryDesign.productVariantId ||
        customerData["Product Variant Id"] ||
        ""
    );
    /* Resolve product_id with the same priority order as variant_id —
       per-design-item field first, then primary design, then customerData
       (kept as a hatch for any future call-site that pre-populates the
       customer dictionary). */
    const productIdValue = safeTrim(
      (primaryDesignObject && primaryDesignObject.productId) ||
        primaryDesign.productId ||
        customerData["Product Id"] ||
        ""
    );
    const productHandleValue = safeTrim(
      (primaryDesignObject && primaryDesignObject.productHandle) ||
        primaryDesign.productHandle ||
        customerData["Product Handle"] ||
        ""
    );
    /* Ex-VAT money values for the payload. These come from the design item's
       `*Ex` strings, captured off the price element's `data-ex-price` attribute
       instead of its display text, so they are the same whichever way the
       customer is browsing. Falls back to the display-basis field when the
       attribute was missing — correct in the default ex mode, and no worse than
       the previous behaviour otherwise. */
    const unitPriceExValue = parseCurrencyAmount(
      (primaryDesignObject &&
        (primaryDesignObject.productPriceEx || primaryDesignObject.productPrice)) ||
        primaryDesign.productPriceEx ||
        primaryDesign.productPrice
    );
    const discountedUnitPriceExValue = parseCurrencyAmount(
      (primaryDesignObject &&
        (primaryDesignObject.totalPriceEx || primaryDesignObject.totalPrice)) ||
        primaryDesign.totalPriceEx ||
        primaryDesign.totalPrice
    );
    const lineTotalExValue =
      discountedUnitPriceExValue !== null && quantityValue !== null
        ? roundToTwo(discountedUnitPriceExValue * quantityValue)
        : null;

    /* Read marketing consent fresh from Shopify's Customer Privacy API
       at payload-build time (read-only — see getShopifyMarketingConsent). */
    const marketingConsent = getShopifyMarketingConsent();
    /* Meta CAPI signals — read directly from the helper
       (`assets/lm-meta-lead-fields.js`) at payload-build time so the
       values are fresh from browser state, not stale from an earlier
       customerData snapshot. Returns empty object if helper missing.
       Lands in Dataverse cr174_fbc / cr174_fbp / cr174_useragent /
       cr174_eventsourceurl. client_ip is captured server-side from
       request headers in postdata.php and ProofCreate. */
    let metaCapiFields = {};
    try {
      if (typeof window.fmGetMetaLeadFields === 'function') {
        metaCapiFields = window.fmGetMetaLeadFields() || {};
      }
    } catch (e) { /* helper missing — leads still submit without Meta fields */ }
    return {
      // Canonical payload expected by instant proof API
      logo_url: safeTrim(primaryDesign.imageUrl || customerData["Image URL"]),
      background_color: safeTrim(
        primaryDesign.backgroundColor || customerData["Background Color"] || primaryDesign.color
      ),
      size: safeTrim(primaryDesign.customWidth ? "" : primaryDesign.size),
      custom_width: safeTrim(primaryDesign.customWidth),
      custom_length: safeTrim(primaryDesign.customLength),
      orientation: safeTrim(primaryDesign.orientation || customerData["Orientation"] || "landscape"),
      company_name: safeTrim(customerData["Company Name"] || "Customer"),
      quantity: quantityValue,
      source_type: "shopify_wizard",

      /* ——— Pricing basis (31-Jul-2026) ———
         `price_basis` states what the money fields in this payload mean, so the
         proof page never has to assume. It is always ex-VAT: the site default,
         and what Dataverse stores regardless of traffic source.

         `display_vat_mode` is the customer's DISPLAY preference, resolved from
         every inc-VAT signal fm-vat.js knows about (see getVatDisplayMode) —
         "inc" for Shopping / PMax / Ads traffic, "ex" otherwise. The proof page
         should add VAT for presentation when this is "inc", and must NOT add it
         when this is "ex". Previously the page hard-coded "ex" and added VAT to
         a figure that was sometimes already inc-VAT, double-charging it.

         `vat_rate` travels with the values so the rate lives in one place
         instead of being hard-coded as ×1.2 at each consumer. */
      price_basis: "ex_vat",
      display_vat_mode: getVatDisplayMode(),
      vat_rate: 0.2,
      unit_price_ex_vat: unitPriceExValue,
      discounted_unit_price_ex_vat: discountedUnitPriceExValue,
      line_total_ex_vat: lineTotalExValue,
      /* product_id sent direct from the page (rendered into a data-*
         attribute on the wizard form root) so the Function App can skip
         the variant→product lookup and use this value as authoritative.
         The lookup mis-classified outdoor/circular variants as the indoor
         parent product when the canonical-normalise table was stale; this
         removes the guess. `product_handle` is included for clearer logs. */
      product_id: productIdValue,
      product_handle: productHandleValue,

      // Location / backing for custom-mat border logic in the Function
      Backing: safeTrim(customerData["Backing"] || primaryDesign.backing || ""),

      // Marketing consent — read-only from Shopify Customer Privacy API
      // (Consentmo-backed). Multiple key spellings so the ProofCreate
      // Function App picks up whichever it maps; all resolve to the
      // same value. Lands in Dataverse cr174_marketingconsent.
      marketing_consent: marketingConsent.allowed,
      marketingConsent: marketingConsent.allowed,
      "Marketing Consent": marketingConsent.allowed ? "true" : "false",
      "Marketing Consent Source": marketingConsent.source,
      "Shopify Marketing Consent": marketingConsent.shopifyMarketing,
      "Shopify Marketing Allowed": marketingConsent.shopifyAllowed ? "true" : "false",
      "Shopify Consent ID": marketingConsent.consentId,

      // Marketing attribution — forwarded so Dataverse can classify PAID_SEARCH vs ORGANIC
      gclid: safeTrim(customerData["gclid"] || ""),
      msclkid: safeTrim(customerData["msclkid"] || ""),
      utm_source: safeTrim(customerData["utm_source"] || ""),
      utm_medium: safeTrim(customerData["utm_medium"] || ""),
      utm_campaign: safeTrim(customerData["utm_campaign"] || ""),

      // Meta CAPI signals — see metaCapiFields declaration above
      fbc: safeTrim(metaCapiFields.fbc || ""),
      fbp: safeTrim(metaCapiFields.fbp || ""),
      user_agent: safeTrim(metaCapiFields.user_agent || ""),
      event_source_url: safeTrim(metaCapiFields.event_source_url || ""),

      // Compatibility/additional context fields for traceability
      Firstname: safeTrim(customerData["Firstname"]),
      Surname: safeTrim(customerData["Surname"]),
      Email: safeTrim(customerData["Email"]),
      Phone: safeTrim(customerData["Phone Normalized"] || customerData["Phone"]),
      "Product Variant Id": variantIdValue,
      "Product Id": productIdValue,
      "Product Handle": productHandleValue,
      "Proof Mode": "instant",
      "Instant Proof Eligible": true,
      "Requires Manual Review": false,
      "Design Item Count": designItems.length,
      "Design Items": JSON.stringify(designItems),
      "Design Items Object": designItemsObject,
      "Quantity Value": quantityValue,
    };
  }

  function getPrimarySizeSelect() {
    if (logoWizardState.$sizeRowsContainer.length > 0) {
      return logoWizardState.$sizeRowsContainer
        .find(".logo-mat-wizard__size-row .cw-product-bundle__variant-select")
        .first();
    }
    return $(".main-product__size-option .cw-product-bundle__variant-select").first();
  }

  function getSelectedSizeValue() {
    const $sizeSelect = getPrimarySizeSelect();
    if ($sizeSelect.length === 0) {
      return "";
    }
    return safeTrim(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    );
  }

  function isCustomSizeSelection() {
    return isCustomSelectionForSizeSelect(getPrimarySizeSelect());
  }

  function resolveCurrentVariantId() {
    const variantRaw = $(".data-variant-selector").text();
    if (!variantRaw) {
      return "";
    }

    let variantData = [];
    try {
      variantData = JSON.parse(variantRaw);
    } catch (error) {
      return "";
    }

    const selectedOptions = $(".product-set-variant").find(
      "input[type=radio]:checked"
    );
    const selectedOptionValues = [];

    selectedOptions.map((i, elm) => {
      selectedOptionValues.push($(elm).val());
    });

    const currentVariant = variantData.find((variant) =>
      variant.options.every(
        (value, index) => value === selectedOptionValues[index]
      )
    );

    return currentVariant && currentVariant.id ? currentVariant.id : "";
  }

  function buildCurrentDesignItem() {
    const $primarySizeSelect = getPrimarySizeSelect();
    const backingValue = safeTrim($('input[name="select-backing"]:checked').val());
    const orientationValue = safeTrim(
      $('input[name="select-orientation"]:checked').val()
    );
    const selectedSizeValue = getSelectedSizeValue();
    const customWidth = safeTrim($('input[name="width"]').val());
    const customLength = safeTrim($('input[name="length"]').val());
    const selectedProductPriceValue = safeTrim(
      $primarySizeSelect
        .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
        .first()
        .text()
    );
    /* Display-independent twin of the above (31-Jul-2026). */
    const selectedProductPriceExValue = readExVatPriceFromSizeSelect($primarySizeSelect);
    const selectedSizeOptionVariantId = resolveSizeSelectVariantId($primarySizeSelect);
    const selectedProductQuantityValue = safeTrim(
      $(".main-product__quantity-option")
        .find(".cw-product-bundle__variant-selected")
        .attr("currentqty")
    );
    const discountPercentageValue = safeTrim(
      $(".main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-save-percentage"
        )
        .text()
    );
    const totalPriceValue = safeTrim(
      $(".main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
        )
        .text()
    );
    const selectedColorValue = safeTrim(
      $(".main-product__color-option").find('input[name="color-swatch"]:checked').val()
    );
    const selectedBgColorValue = safeTrim(
      $(".main-product__color-option")
        .find('input[name="background-color-swatch"]:checked')
        .attr("data-color-name")
    );
    const bespokeOptionValue = safeTrim(
      $('input[name="bespoke-option"]:checked').val()
    );

    const uploadedFileUrlInput = $(".main-product__uploaded-file-url");
    const imagePreviewElement = $(".main-product__upload-preview img");
    let imageUrl = "";

    if (uploadedFileUrlInput.length > 0 && safeTrim(uploadedFileUrlInput.val())) {
      imageUrl = safeTrim(uploadedFileUrlInput.val());
    } else if (imagePreviewElement.length > 0) {
      imageUrl = safeTrim(imagePreviewElement.attr("src"));
    }

    /* Resolution chain for the customer's chosen background colour.
       Order matters — the highest-fidelity source wins:

         1. Bespoke text input (#color-option-input) when the bespoke-yes
            radio is selected. That input takes Pantone refs / RGB / hex /
            colour names typed by the customer when they have a brand-spec
            colour to specify.

         2. Currently-checked swatch's friendly name (data-color-name) for
            preset swatches, OR the swatch's `value` attribute (the actual
            hex) for the custom-colour swatch specifically. The custom
            swatch's data-color-name is hardcoded to "Custom Colour" in
            markup and is updated to the actual hex by the picker commit
            handler in main-product.liquid; we still prefer `value` here
            as a defence-in-depth so even if the data-color-name update
            ever fails, the hex flows through.

         3. Defensive fallback to the FIRST preset swatch's data-color-name
            or value — guarantees the payload never carries an empty
            background_color even when the form state is unexpected
            (hidden swatches, JS errors clobbering attributes, etc.).
            Outdoor/circular templates render no swatches at all, so this
            falls through to "" and the call-site below skips the proof
            endpoint entirely (no colour by design — see the gate earlier
            in this function).
    */
    let backgroundColorValue = "";
    if (bespokeOptionValue === "yes") {
      backgroundColorValue = safeTrim($("#color-option-input").val());
    }
    /* Force-manual "describe your colour" free text (Select Background Colour
       step, when the `force_manual_designs` theme setting is on). Treated
       exactly like a typed HEX/Pantone — it overrides the preset swatch but
       yields to an explicit bespoke entry above. Only present in manual mode. */
    if (!backgroundColorValue) {
      var manualColourValue = safeTrim($("#backgroundManualColour").val());
      if (manualColourValue) {
        backgroundColorValue = manualColourValue;
      }
    }
    if (!backgroundColorValue) {
      var $checkedSwatch = $('input[name="background-color-swatch"]:checked').first();
      if ($checkedSwatch.length > 0) {
        var dataName = safeTrim($checkedSwatch.attr("data-color-name"));
        var swatchValue = safeTrim($checkedSwatch.val());
        /* For the custom-colour swatch, the `value` attribute is the actual
           hex (set by the picker commit). data-color-name is also synced
           there but we belt-and-braces with `value` for the custom case. */
        if ($checkedSwatch.attr("id") === "background-custom-colour") {
          backgroundColorValue = swatchValue || dataName;
        } else {
          backgroundColorValue = dataName || swatchValue;
        }
      }
    }
    if (!backgroundColorValue) {
      var $firstSwatch = $('input[name="background-color-swatch"]').first();
      if ($firstSwatch.length > 0) {
        backgroundColorValue =
          safeTrim($firstSwatch.attr("data-color-name")) ||
          safeTrim($firstSwatch.val()) ||
          "";
      }
    }

    /* Read the product identity from the wizard form's data-* attributes
       (rendered by sections/main-product.liquid). Falls back to empty when
       the section isn't on the page (e.g. non-logo-mat product templates),
       which is fine — the payload builder treats it as optional. */
    var $wizardRoot = $(".main-product__customise-selection").first();
    var productId = safeTrim($wizardRoot.attr("data-product-id") || "");
    var productHandle = safeTrim($wizardRoot.attr("data-product-handle") || "");

    const item = {
      location: backingValue,
      orientation: orientationValue,
      size: selectedSizeValue,
      customWidth: isCustomSizeSelectedOnSizeSelect($primarySizeSelect) ? customWidth : "",
      customLength: isCustomSizeSelectedOnSizeSelect($primarySizeSelect) ? customLength : "",
      productPrice: selectedProductPriceValue,
      productPriceEx: selectedProductPriceExValue,
      quantity: selectedProductQuantityValue,
      discountPercentage: discountPercentageValue,
      totalPrice: totalPriceValue,
      color: selectedColorValue,
      backgroundColor: backgroundColorValue,
      bespokeColor: bespokeOptionValue,
      imageUrl: imageUrl,
      productVariantId: selectedSizeOptionVariantId || resolveCurrentVariantId(),
      /* New (06-May-2026): product_id sent direct from the page so the
         Function App's canonical_normalize doesn't have to derive it from
         variant_id alone. The previous derivation was mapping outdoor
         variants to the indoor parent product because the lookup table
         didn't reflect the outdoor/circular product registrations. */
      productId: productId,
      productHandle: productHandle,
    };

    return item;
  }

  function isSizePlaceholderValue(sizeValue) {
    const normalizedValue = safeTrim(sizeValue).toLowerCase();
    return (
      !normalizedValue ||
      normalizedValue === "select size" ||
      normalizedValue === "select an option"
    );
  }

  function getCurrentSizeSelectionData() {
    const $sizeSelect = getPrimarySizeSelect();
    if ($sizeSelect.length === 0) {
      return null;
    }

    const selectedSizeValue = safeTrim(
      $sizeSelect.find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text").text()
    );
    if (isSizePlaceholderValue(selectedSizeValue)) {
      return null;
    }

    const selectedProductPriceValue = safeTrim(
      $sizeSelect
        .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
        .first()
        .text()
    );
    const selectedProductPriceExValue = readExVatPriceFromSizeSelect($sizeSelect);
    const selectedVariantId = resolveSizeSelectVariantId($sizeSelect);
    const isCustomSize = isCustomSizeSelectedOnSizeSelect($sizeSelect);

    return {
      size: selectedSizeValue,
      customWidth: isCustomSize ? safeTrim($('input[name="width"]').val()) : "",
      customLength: isCustomSize ? safeTrim($('input[name="length"]').val()) : "",
      productPrice: selectedProductPriceValue,
      productPriceEx: selectedProductPriceExValue,
      productVariantId: selectedVariantId || resolveCurrentVariantId(),
    };
  }

  function getSelectedSizeDataList() {
    const selections = [];
    const $rows =
      logoWizardState.$sizeRowsContainer.length > 0
        ? logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row")
        : $();

    if ($rows.length > 0) {
      $rows.each(function () {
        const $sizeSelect = $(this).find(".cw-product-bundle__variant-select").first();
        const selectedSizeValue = safeTrim(
          $sizeSelect
            .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-text")
            .text()
        );
        if (isSizePlaceholderValue(selectedSizeValue)) {
          return;
        }

        const selectedProductPriceValue = safeTrim(
          $sizeSelect
            .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
            .first()
            .text()
        );
        const selectedProductPriceExValue = readExVatPriceFromSizeSelect($sizeSelect);
        const selectedVariantId = resolveSizeSelectVariantId($sizeSelect);
        const isCustomSize = isCustomSizeSelectedOnSizeSelect($sizeSelect);

        selections.push({
          size: selectedSizeValue,
          customWidth: isCustomSize ? safeTrim($('input[name="width"]').val()) : "",
          customLength: isCustomSize ? safeTrim($('input[name="length"]').val()) : "",
          productPrice: selectedProductPriceValue,
          productPriceEx: selectedProductPriceExValue,
          productVariantId: selectedVariantId || resolveCurrentVariantId(),
        });
      });
      return selections;
    }

    const currentSelection = getCurrentSizeSelectionData();
    return currentSelection ? [currentSelection] : [];
  }

  function normalizeQuantityValue(value) {
    const parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || Number.isNaN(parsed)) {
      return 1;
    }
    return Math.max(parsed, 1);
  }

  function syncQuantitySelections(sizeCount) {
    const targetCount = Math.max(sizeCount, 0);
    const nextSelections = [];
    for (let index = 0; index < targetCount; index += 1) {
      const existingQty = logoWizardState.quantitySelections[index];
      nextSelections.push(normalizeQuantityValue(existingQty || 1));
    }
    logoWizardState.quantitySelections = nextSelections;
  }

  function getQuantityPricingForSize(sizeData, quantity) {
    const qtyValue = normalizeQuantityValue(quantity);
    const basePriceValue = parseCurrencyAmount(sizeData.productPrice);
    const safeBasePriceValue = basePriceValue !== null ? basePriceValue : 0;
    const tiers = getQuantityDiscountTiers();
    const discountPercentValue = getDiscountPercentForQty(qtyValue, tiers);
    const discountedUnitValue = roundToTwo(
      safeBasePriceValue * (1 - discountPercentValue / 100)
    );

    return {
      quantity: qtyValue,
      discountPercentValue,
      /* Team decision 17-Sep-2026: never show the discount RATE to the
         customer — the discounted per-mat price already moves, so the line just
         confirms a discount is on. The nudge banner below follows the same
         rule. */
      discountPercentageText:
        discountPercentValue > 0 ? "Multi-mat discount applied" : "",
      productPriceText: formatMoneyAmount(safeBasePriceValue),
      totalPriceText:
        discountedUnitValue !== null
          ? formatMoneyAmount(discountedUnitValue)
          : formatMoneyAmount(safeBasePriceValue),
    };
  }

  /* Quantity step — v3 (23-Sep-2026). One size per enquiry now, so this
     renders a single row card (location · size, − / n / + stepper, total for
     n mats + per-mat price) and a four-row tier ladder (1 / 2 / 3 / 4+ mats)
     showing the per-mat price at each tier — no percentages, no "save £".
     Tapping a tier sets the quantity. 10+ mats shows an amber "chat to us"
     note. Prices still come from getQuantityPricingForSize, i.e. the real
     variant price and the data-save-percentage tiers. Re-rendered on every
     change; the +/- handler in initLogoWizard keys off
     `.logo-mat-wizard__qty-row[data-qty-index]`, which the row card keeps. */
  function renderQuantityRows() {
    if (!logoWizardState.$quantityList.length) {
      return;
    }

    const sizeSelections = getSelectedSizeDataList();
    syncQuantitySelections(sizeSelections.length);
    logoWizardState.$quantityList.empty();

    if (!sizeSelections.length) {
      logoWizardState.$quantityList.append(
        '<p class="logo-mat-wizard__qty-empty">Choose a size first, then set how many mats you need.</p>'
      );
      if (logoWizardState.$volumeInfoBar.length > 0) {
        logoWizardState.$volumeInfoBar.removeClass("is-visible").hide();
      }
      return;
    }

    const sizeData = sizeSelections[0];
    const quantityValue = normalizeQuantityValue(logoWizardState.quantitySelections[0] || 1);
    const tiers = getQuantityDiscountTiers();
    const basePriceValue = parseCurrencyAmount(sizeData.productPrice) || 0;
    const unitFor = (qty) =>
      roundToTwo(basePriceValue * (1 - getDiscountPercentForQty(qty, tiers) / 100));
    const unitValue = unitFor(quantityValue);
    const totalValue = roundToTwo(unitValue * quantityValue);
    const sizeLabel = safeTrim(sizeData.customWidth)
      ? `${sizeData.customWidth} × ${sizeData.customLength} cm`
      : formatStandardSizeLabel(sizeData.size) || safeTrim(sizeData.size);
    const locationLabel = isMatwellLocationSelected()
      ? "Borderless · in a recess"
      : "Bordered · loose lay";
    const matWord = quantityValue === 1 ? "mat" : "mats";
    const tickSvg =
      '<svg width="12" height="12" viewBox="0 0 14 14" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 7.5l3 3 6-7"/></svg>';

    const tiersMarkup = [
      [1, "1 mat"],
      [2, "2 mats"],
      [3, "3 mats"],
      [4, "4+ mats"],
    ]
      .map(([tierQty, label]) => {
        const isActive = tierQty === 4 ? quantityValue >= 4 : quantityValue === tierQty;
        return `
          <button type="button" class="lmw-qty__tier${isActive ? " is-active" : ""}" data-lmw-tier="${tierQty}" aria-pressed="${isActive ? "true" : "false"}">
            <span class="lmw-qty__tick" aria-hidden="true">${tickSvg}</span>
            <span class="lmw-qty__tier-label">${label}</span>
            <span class="lmw-qty__tier-price">${formatMoneyAmount(unitFor(tierQty))}<span>+ VAT each</span></span>
          </button>`;
      })
      .join("");

    logoWizardState.$quantityList.append(`
      <div class="lmw-qty">
        <div class="lmw-qty__row logo-mat-wizard__qty-row" data-qty-index="0">
          <div class="lmw-qty__what">
            <div class="lmw-qty__loc">${escapeHtml(locationLabel)}</div>
            <div class="lmw-qty__size">${escapeHtml(sizeLabel)}</div>
          </div>
          <div class="lmw-qty__stepper">
            <button type="button" class="logo-mat-wizard__qty-button" data-action="decrease" aria-label="Decrease quantity">&minus;</button>
            <span class="lmw-qty__value logo-mat-wizard__qty-value" aria-live="polite">${quantityValue}</span>
            <button type="button" class="logo-mat-wizard__qty-button" data-action="increase" aria-label="Increase quantity">+</button>
          </div>
          <div class="lmw-qty__total">
            <div class="lmw-qty__total-label">Total for ${quantityValue} ${matWord}</div>
            <div class="lmw-qty__total-value">${formatMoneyAmount(totalValue)}<span>+ VAT</span></div>
          </div>
        </div>
        <div class="lmw-qty__tiers" role="group" aria-label="Price per mat by quantity">${tiersMarkup}</div>
        ${
          quantityValue >= 10
            ? '<div class="lmw-qty__note">Need 10 or more? <button type="button" class="lmw-qty__chat js-ch-chat-open">Chat to us</button> for our best price.</div>'
            : ""
        }
      </div>
    `);

    if (logoWizardState.$volumeInfoBar.length > 0) {
      const defaultVolumeInfoEnabled =
        safeTrim(logoWizardState.$volumeInfoBar.attr("data-default-enabled")).toLowerCase() ===
        "true";
      logoWizardState.$volumeInfoBar.toggleClass("is-visible", defaultVolumeInfoEnabled);
      if (defaultVolumeInfoEnabled) {
        logoWizardState.$volumeInfoBar.show();
      } else {
        logoWizardState.$volumeInfoBar.hide();
      }
    }
  }

  /* Tier ladder rows set the quantity directly (4+ → 4). */
  $(document).on("click", ".lmw-qty__tier", function () {
    const tierQty = parseInt($(this).attr("data-lmw-tier"), 10);
    if (!Number.isFinite(tierQty) || tierQty < 1) return;
    logoWizardState.quantitySelections[0] = tierQty;
    renderQuantityRows();
    lmwTrack("lm_qty_change", { lm_qty: tierQty, lm_source: "tier" });
  });

  function setWizardBackButtonMode(mode) {
    if (!logoWizardState.$backButton.length) {
      return;
    }
    const isStartOver = mode === "start-over";
    logoWizardState.$backButton
      .toggleClass("logo-mat-wizard__nav-button--start-over", isStartOver)
      .text(isStartOver ? "Start Over" : "Back");
  }

  function resetWizardForNewSubmission() {
    logoWizardState.isSubmissionComplete = false;
    logoWizardState.returnToIndex = null;
    setWizardBackButtonMode("back");

    const $checkoutForm = $(".secure-checkout__form");
    $checkoutForm.removeClass("form-submit-success is-submitting");
    $checkoutForm.find("input").removeClass("invalid");
    $checkoutForm.find(".error-message").hide();
    $checkoutForm.find("#firstName, #surname, #email, #company, #phone").val("");

    setInstantProofDebugMessage("");
    isCheckoutSubmitting = false;
    setCheckoutSubmitState(false);

    if (logoWizardState.$sizeRowsContainer.length > 0) {
      const $rows = logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row");
      $rows.slice(1).remove();
      const $firstSelect = logoWizardState.$sizeRowsContainer
        .children(".logo-mat-wizard__size-row")
        .first()
        .find(".cw-product-bundle__variant-select")
        .first();
      resetSizeSelectToPlaceholder($firstSelect);
      refreshSizeRowsState();
    } else {
      resetSizeSelectionToPlaceholder();
    }

    logoWizardState.quantitySelections = [];
    if (logoWizardState.$volumeInfoBar.length > 0) {
      logoWizardState.$volumeInfoBar.removeClass("is-visible").hide();
    }

    showWizardStep(0, { skipValidation: true });
  }

  function getQuantityDataForSize(sizeData, index) {
    const quantityValue = logoWizardState.quantitySelections[index] || 1;
    const pricing = getQuantityPricingForSize(sizeData, quantityValue);
    /* Run the same discount tiers over the ex-VAT base so the ex figures carry
       the quantity discount too, rather than being an undiscounted unit price
       sitting next to a discounted display one. (31-Jul-2026) */
    const exPricing = getQuantityPricingForSize(
      {
        ...sizeData,
        productPrice: safeTrim(sizeData.productPriceEx) || sizeData.productPrice,
      },
      quantityValue
    );
    return {
      quantity: String(pricing.quantity),
      discountPercentage: pricing.discountPercentageText,
      totalPrice: pricing.totalPriceText,
      productPrice: safeTrim(sizeData.productPrice) || pricing.productPriceText,
      productPriceEx: safeTrim(sizeData.productPriceEx) || exPricing.productPriceText,
      totalPriceEx: exPricing.totalPriceText,
    };
  }

  function buildDesignItemFromBaseAndSize(baseItem, sizeData, quantityData) {
    if (!baseItem || !sizeData) {
      return baseItem;
    }

    return {
      ...baseItem,
      size: safeTrim(sizeData.size),
      customWidth: safeTrim(sizeData.customWidth),
      customLength: safeTrim(sizeData.customLength),
      productPrice:
        safeTrim((quantityData && quantityData.productPrice) || sizeData.productPrice) ||
        baseItem.productPrice,
      quantity:
        safeTrim(quantityData && quantityData.quantity) || safeTrim(baseItem.quantity) || "1",
      discountPercentage:
        safeTrim(quantityData && quantityData.discountPercentage) ||
        safeTrim(baseItem.discountPercentage),
      totalPrice:
        safeTrim(quantityData && quantityData.totalPrice) ||
        safeTrim(baseItem.totalPrice) ||
        safeTrim((quantityData && quantityData.productPrice) || sizeData.productPrice),
      productPriceEx:
        safeTrim((quantityData && quantityData.productPriceEx) || sizeData.productPriceEx) ||
        baseItem.productPriceEx,
      totalPriceEx:
        safeTrim(quantityData && quantityData.totalPriceEx) ||
        safeTrim(baseItem.totalPriceEx) ||
        safeTrim((quantityData && quantityData.productPriceEx) || sizeData.productPriceEx),
      productVariantId: sizeData.productVariantId || baseItem.productVariantId,
    };
  }

  function getQueuedSizeDesignItems(baseItem) {
    const sizeSelections = getSelectedSizeDataList();
    if (!baseItem || !sizeSelections.length) {
      return [];
    }

    return sizeSelections.map((sizeData, index) =>
      buildDesignItemFromBaseAndSize(
        baseItem,
        sizeData,
        getQuantityDataForSize(sizeData, index)
      )
    );
  }

  function getWizardSummaryEntries() {
    const currentItem = buildCurrentDesignItem();
    const sizeItems = getQueuedSizeDesignItems(currentItem);

    if (!sizeItems.length) {
      if (isSizePlaceholderValue(currentItem.size)) {
        return [];
      }
      return [{ source: "current", index: 0, item: currentItem }];
    }

    return sizeItems.map((item, index) => ({
      source: "current",
      index,
      item,
    }));
  }

  function resetSizeSelectToPlaceholder($sizeSelect) {
    if ($sizeSelect.length === 0) {
      return;
    }

    $sizeSelect
      .find(".cw-product-bundle__variant-selected")
      .html(
        '<span class="cw-product-bundle__variant-text">Select Size</span><span class="cw-product-bundle__variant-price"></span>'
      );
    $sizeSelect.find('input[type="hidden"]').val("");
    $sizeSelect.find(".cw-product-bundle__variant-option").removeClass("active-status");
    $sizeSelect.find(".cw-product-bundle__variant-options").hide();
    $sizeSelect.removeClass("is-open");
    $sizeSelect.removeClass("is-custom-size-selected");
    $sizeSelect.removeAttr("data-selected-variant-id");
    $sizeSelect.removeAttr("data-selected-option-text");
    $sizeSelect.removeAttr("data-selected-option-raw-text");
    $sizeSelect.removeAttr("data-selected-is-custom-size");
    updateCustomSizeLabels();
  }

  function resetSizeSelectionToPlaceholder() {
    resetSizeSelectToPlaceholder(getPrimarySizeSelect());

    $(".custom-width-input-field").hide();
    $('input[name="width"], input[name="length"]').val("");
    $(
      ".size-error-message, .size-error-message--max, .size-error-message--required, .size-error-message-length--required, .size-error-message--min"
    ).hide();
  }

  function refreshSizeRowsState() {
    if (!logoWizardState.$sizeRowsContainer.length) {
      return;
    }

    const $sizeRows = logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row");
    const canRemoveRows = $sizeRows.length > 1;
    $sizeRows.each(function () {
      $(this)
        .find(".logo-mat-wizard__size-row-remove")
        .prop("disabled", !canRemoveRows)
        .attr("aria-disabled", canRemoveRows ? "false" : "true");
    });
  }

  function getDesignItemsForSubmission() {
    if (!logoWizardState.enabled) {
      return [buildCurrentDesignItem()];
    }

    const currentItem = buildCurrentDesignItem();
    const sizeSelections = getSelectedSizeDataList();
    if (!sizeSelections.length) {
      return isSizePlaceholderValue(currentItem.size) ? [] : [currentItem];
    }

    return sizeSelections.map((sizeData, index) =>
      buildDesignItemFromBaseAndSize(
        currentItem,
        sizeData,
        getQuantityDataForSize(sizeData, index)
      )
    );
  }

  function isDesignStepAvailable($step) {
    if (!$step || $step.length === 0) {
      return false;
    }
    if ($step.hasClass("hex_color_option_wrapper")) {
      return $('input[name="bespoke-option"]:checked').val() === "yes";
    }
    if ($step.hasClass("color_selection_options_wrapper")) {
      return $('input[name="bespoke-option"]:checked').val() !== "yes";
    }
    return true;
  }

  function getWizardSteps() {
    if (!logoWizardState.enabled) {
      return [];
    }

    const filteredDesignSteps = logoWizardState.$designSteps
      .filter(function () {
        return isDesignStepAvailable($(this));
      })
      .toArray();

    const quantitySteps = [];
    const colorSteps = [];
    const nonReorderedSteps = [];

    filteredDesignSteps.forEach((stepElement) => {
      const $step = $(stepElement);
      if ($step.find(".main-product__quantity-option").length > 0) {
        quantitySteps.push(stepElement);
        return;
      }
      if (
        $step.hasClass("color_selection_options_wrapper") ||
        $step.hasClass("hex_color_option_wrapper")
      ) {
        colorSteps.push(stepElement);
        return;
      }
      nonReorderedSteps.push(stepElement);
    });

    /* v3 flow (23-Sep-2026): Location → Size → Quantity → Upload → Details.
       The Orientation step is no longer its own step — initLogoWizard moves
       its radio cards INTO the size step — so it is dropped from this list
       (its wrapper stays in the DOM, permanently inactive). The Background
       colour step is dropped too: its swatches stay in the DOM with the first
       one checked, so buildCurrentDesignItem still resolves a background
       colour and the instant proof keeps generating; the customer picks the
       colour in the proof editor instead. */
    const orientationSteps = [];
    const backingSteps = [];
    const otherNonReorderedSteps = [];
    nonReorderedSteps.forEach((stepElement) => {
      const $step = $(stepElement);
      /* The orientation cards now live INSIDE the size step, so identify the
         (emptied) orientation wrapper by its marker class, not by the cards. */
      if (
        $step.hasClass("lmw-step-merged") ||
        ($step.find(".main-product__orientation-option").length > 0 &&
          $step.find(".main-product__size-option").length === 0)
      ) {
        orientationSteps.push(stepElement);
      } else if ($step.find(".main-product__backing-option").length > 0) {
        backingSteps.push(stepElement);
      } else {
        otherNonReorderedSteps.push(stepElement);
      }
    });
    void orientationSteps; /* merged into the size step — see above */
    void colorSteps;       /* removed from the flow — see above */
    const orderedNonReorderedSteps = [
      ...backingSteps,
      ...otherNonReorderedSteps,
    ];

    const designStepElements = [];
    let insertedPostSizeSteps = false;

    orderedNonReorderedSteps.forEach((stepElement) => {
      designStepElements.push(stepElement);

      if (!insertedPostSizeSteps) {
        const $step = $(stepElement);
        if ($step.find(".main-product__size-option").length > 0) {
          designStepElements.push(...quantitySteps);
          insertedPostSizeSteps = true;
        }
      }
    });

    if (!insertedPostSizeSteps) {
      designStepElements.push(...quantitySteps);
    }

    if (logoWizardState.$detailsStep.length > 0) {
      const detailsStep = logoWizardState.$detailsStep.get(0);
      if (detailsStep) {
        designStepElements.push(detailsStep);
      }
    }

    return designStepElements;
  }

  /* Details-step summary — v3 (23-Sep-2026). Renders the "Your selections"
     panel: logo thumbnail, one row per choice with an Edit link (which jumps
     to that step and sets returnToIndex so the primary button reads "Save &
     return"), and the Total. Hidden once the submission has completed. */
  function updateWizardSummary() {
    if (!logoWizardState.enabled) {
      return;
    }
    const $panel = logoWizardState.$summaryList;
    if (!$panel || !$panel.length) {
      return;
    }
    if (logoWizardState.isSubmissionComplete) {
      $panel.hide();
      return;
    }
    $panel.show();

    const sizeItem = getSelectedSizeDataList()[0];
    const isRecess = isMatwellLocationSelected();
    const portrait = safeTrim($('input[name="select-orientation"]:checked').val()) === "portrait";
    const quantityValue = normalizeQuantityValue(logoWizardState.quantitySelections[0] || 1);

    let sizeLabel = "—";
    let totalText = "—";
    if (sizeItem) {
      sizeLabel = safeTrim(sizeItem.customWidth)
        ? `${sizeItem.customWidth} × ${sizeItem.customLength} cm`
        : formatStandardSizeLabel(sizeItem.size) || safeTrim(sizeItem.size) || "—";
      const basePriceValue = parseCurrencyAmount(sizeItem.productPrice) || 0;
      const unitValue = roundToTwo(
        basePriceValue * (1 - getDiscountPercentForQty(quantityValue, getQuantityDiscountTiers()) / 100)
      );
      totalText = formatMoneyAmount(roundToTwo(unitValue * quantityValue));
    }

    const logoUrl = hasUploadedLogo() ? safeTrim($(".main-product__uploaded-file-url").val()) : "";
    const logoIsPdf =
      /\.pdf(\?|$)/i.test(logoUrl) || $(".main-product__upload-preview .lmw-upload__pdf").length > 0;
    let logoText = "—";
    if (logoUrl) logoText = logoIsPdf ? "Uploaded (PDF)" : "Uploaded";
    else if (isLogoDeferred()) logoText = "To follow by email";

    const rows = [
      ["Location", isRecess ? "In a recess" : "Loose lay", "Edit", "location"],
      ["Orientation", portrait ? "Portrait" : "Landscape", "Edit", "size"],
      ["Size", sizeLabel, "Edit", "size"],
      ["Quantity", String(quantityValue), "Edit", "quantity"],
      ["Logo", logoText, "Change logo", "upload"],
    ];
    /* The auto-chosen mat colour (pickBackgroundSwatchForLogo) is deliberately
       NOT listed here — Jack, 23-Sep-2026: it confused people. It still goes
       to the proof, where the customer can change it. */

    /* On phones the panel sits ABOVE the form, collapsed to a one-line header
       showing the total; tapping it opens the rows (Jack, 23-Sep-2026 — the
       stacked panel under the form was never seen). Desktop CSS shows the
       body permanently and neutralises the toggle. */
    const panelOpen = !!logoWizardState.selectionsOpen;
    $panel.toggleClass("is-open", panelOpen);
    $panel.html(`
      <button type="button" class="lmw-selections__toggle" aria-expanded="${panelOpen ? "true" : "false"}">
        <span class="lmw-selections__head">Your selections</span>
        <span class="lmw-selections__toggle-total">${escapeHtml(totalText)} <span>+ VAT</span></span>
        <span class="lmw-selections__chev" aria-hidden="true"></span>
      </button>
      <div class="lmw-selections__body">
      ${
        logoUrl && !logoIsPdf
          ? `<div class="lmw-selections__logo"><img src="${escapeHtml(logoUrl)}" alt="Your uploaded logo"></div>`
          : ""
      }
      ${rows
        .map(
          ([label, value, action, stepType]) => `
        <div class="lmw-selections__row">
          <span class="lmw-selections__k">${escapeHtml(label)}</span>
          <span class="lmw-selections__v">${escapeHtml(value)}</span>
          ${
            action
              ? `<button type="button" class="lmw-selections__edit" data-lmw-edit-step="${stepType}">${escapeHtml(action)}</button>`
              : '<span class="lmw-selections__edit lmw-selections__edit--none" aria-hidden="true"></span>'
          }
        </div>`
        )
        .join("")}
      <div class="lmw-selections__total">
        <span class="lmw-selections__k">Total</span>
        <span class="lmw-selections__total-value">${escapeHtml(totalText)} <span>+ VAT</span></span>
      </div>
      </div>
    `);
  }

  $(document).on("click", ".lmw-selections__toggle", function () {
    const $panel = $(this).closest(".lmw-selections");
    logoWizardState.selectionsOpen = !$panel.hasClass("is-open");
    $panel.toggleClass("is-open", logoWizardState.selectionsOpen);
    $(this).attr("aria-expanded", logoWizardState.selectionsOpen ? "true" : "false");
  });

  /* Custom-size limits (v3, 23-Sep-2026 — figures from Jack). Width: 200cm
     roll for bordered (loose lay) mats; 195cm roll for borderless (recess)
     mats, less the 3cm production adds, so 192cm entered. Length: 650cm for
     both (Jack, 23-Sep — the recess 697 figure was wrong). Minimum 40cm each
     way. These are also the only thing stopping a nonsense enquiry (see the
     made-to-measure guard notes), so they run live AND on Next. */
  function getCustomSizeLimits() {
    const recess = isMatwellLocationSelected();
    return {
      recess,
      minW: 40,
      minL: 40,
      maxW: recess ? 195 - MATWELL_TRIM_ALLOWANCE_CM : 200,
      maxL: 650,
    };
  }

  /* "" when both measurements are inside the limits, or when either is still
     empty (nothing to shout about yet — validateCustomSizeStep adds the
     "enter both" line on Next). */
  function getCustomSizeError(widthValue, lengthValue) {
    if (!(widthValue > 0) || !(lengthValue > 0)) {
      return "";
    }
    const lim = getCustomSizeLimits();
    if (widthValue < lim.minW || lengthValue < lim.minL) {
      return "Minimum size is 40cm on each side.";
    }
    if (widthValue > lim.maxW) {
      return lim.recess
        ? `Maximum width for a recess mat is ${lim.maxW}cm — chat to us for wider mats.`
        : `Maximum width is ${lim.maxW}cm — chat to us for wider mats.`;
    }
    if (lengthValue > lim.maxL) {
      return `Maximum length is ${lim.maxL}cm — chat to us for longer runs.`;
    }
    return "";
  }

  function setCustomSizeError(message) {
    const $error = $("[data-lmw-custom-error]");
    if (!$error.length) return;
    $error.text(message || "");
    $error.toggle(!!message);
  }

  function validateCustomSizeStep() {
    const hasCustomSizeSelection = getSelectedSizeDataList().some((item) => {
      const sizeLabel = safeTrim(item.size).toLowerCase();
      return sizeLabel.indexOf("custom") > -1 || sizeLabel.indexOf("bespoke") > -1;
    });

    if (!hasCustomSizeSelection) {
      setCustomSizeError("");
      return true;
    }

    const widthValue = parseFloat($('input[name="width"]').val());
    const lengthValue = parseFloat($('input[name="length"]').val());
    let message = getCustomSizeError(widthValue, lengthValue);
    if (!message && (!(widthValue > 0) || !(lengthValue > 0))) {
      message = "Enter both measurements to continue.";
    }
    setCustomSizeError(message);
    return !message;
  }

  /* Has the customer given us a logo? The upload widget (eq-custom.js) writes
     the hidden URL input on a successful POST to imgupload.php, so that one
     value is the single source of truth. (28-Jul-2026; the Brandfetch finder
     that used to be the second writer was removed 17-Sep-2026.) */
  function hasUploadedLogo() {
    return safeTrim($(".main-product__uploaded-file-url").val()).length > 0;
  }

  /* The stuck-picker rescue's "continue without a logo" button sets this
     flag (25-Aug-2026): the customer's photo picker wouldn't open (iOS
     stuck-picker bug) and they chose to email the file after submitting.
     Opens the upload-step gate without faking a URL — the Logo Source field
     is set to "email-later" by the click handler further down. */
  function isLogoDeferred() {
    return safeTrim($(".main-product__logo-deferred").val()) === "1";
  }

  /* Dull the Next button while the upload step has no logo, mirroring the
     "Generate Logo Mat Proof" treatment further down this file: a CLASS, not
     the disabled prop, so a click still runs validateStep and surfaces the
     inline message explaining what's needed. (28-Jul-2026) */
  function syncUploadStepGate() {
    if (!logoWizardState.enabled || !logoWizardState.$nextButton) {
      return;
    }
    const allSteps = getWizardSteps();
    const $activeStep = $(allSteps[logoWizardState.currentStepIndex]);
    const onUploadStep = $activeStep.find(".main-product__upload-option").length > 0;
    const awaitingLogo = onUploadStep && !hasUploadedLogo() && !isLogoDeferred();
    logoWizardState.$nextButton.toggleClass(
      "logo-mat-wizard__nav-button--awaiting-logo",
      awaitingLogo
    );
    if (awaitingLogo) {
      logoWizardState.$nextButton.attr("aria-disabled", "true");
    } else {
      logoWizardState.$nextButton.removeAttr("aria-disabled");
    }
    /* v3 label: the gated button says what is needed (README: "Add logo to
       continue"); otherwise Next, or "Save & return" mid-edit. */
    if (onUploadStep) {
      logoWizardState.$nextButton.text(
        awaitingLogo ? "Add logo to continue" : hasReturnTarget() ? "Save & return" : "Next"
      );
    }

    /* Clear a stale "please upload…" message the moment a logo lands, rather
       than leaving it on screen until the next Next click. */
    if (onUploadStep && !awaitingLogo) {
      $activeStep.find(".logo-mat-wizard__step-error").hide().text("");
      $activeStep.find(".main-product__upload-option").removeClass("is-error");
    }
  }

  function validateStep(stepElement) {
    const $step = $(stepElement);
    if ($step.length === 0) {
      return true;
    }

    const $error = $step.find(".logo-mat-wizard__step-error");
    $error.hide().text("");
    /* Reveal a step error even if it sits below the fold of a scrolling step
       body (e.g. the tall Size step inside the modal). Scrolls the nearest
       scroll container the minimum needed. */
    const revealStepError = function () {
      if ($error[0] && typeof $error[0].scrollIntoView === "function") {
        $error[0].scrollIntoView({ block: "nearest" });
      }
    };

    if ($step.find(".main-product__size-option").length > 0) {
      const selectedSizes = getSelectedSizeDataList();
      if (selectedSizes.length === 0) {
        $error.text("Please choose a size before continuing.").show();
        revealStepError();
        return false;
      }

      if (!validateCustomSizeStep()) {
        $error
          .text("Please check your custom dimensions before continuing.")
          .show();
        return false;
      }
    }

    if ($step.find(".main-product__quantity-option").length > 0) {
      const selectedSizes = getSelectedSizeDataList();
      if (selectedSizes.length === 0) {
        $error.text("Please choose at least one size before setting quantity.").show();
        revealStepError();
        return false;
      }
      syncQuantitySelections(selectedSizes.length);
      const hasInvalidQty = logoWizardState.quantitySelections.some(
        (qtyValue) => normalizeQuantityValue(qtyValue) < 1
      );
      if (hasInvalidQty) {
        $error.text("Please choose a valid quantity for each size.").show();
        revealStepError();
        return false;
      }
    }

    /* Upload step: a logo is required (28-Jul-2026), except when the
       stuck-picker rescue deferred it to email (25-Aug-2026). */
    const $uploadOption = $step.find(".main-product__upload-option");
    if ($uploadOption.length > 0) {
      if (!hasUploadedLogo() && !isLogoDeferred()) {
        /* Mid-upload gets its own wording. CSS already blocks the Next button
           while `.is-uploading` is set, so this only surfaces in browsers
           without `:has()` support. */
        $error
          .text(
            $uploadOption.hasClass("is-uploading")
              ? "Your logo is still uploading — one moment."
              : "Please upload your logo before continuing."
          )
          .show();
        /* v3: the dropzone border turns red as well (cleared when a logo lands). */
        if (!$uploadOption.hasClass("is-uploading")) {
          $uploadOption.addClass("is-error");
        }
        revealStepError();
        return false;
      }
    }

    if ($step.hasClass("hex_color_option_wrapper")) {
      const colorValue = safeTrim($("#color-option-input").val());
      if (!colorValue) {
        $error.text("Please enter a bespoke background colour.").show();
        revealStepError();
        return false;
      }
    }

    if ($step.find('input[name="background-color-swatch"]').length > 0) {
      const selectedBackground = $('input[name="background-color-swatch"]:checked');
      if (selectedBackground.length > 0 && selectedBackground.attr("id") === "background-custom-colour") {
        const customHexValue = safeTrim($("#backgroundCustomColourHex").val());
        if (!/^[0-9A-Fa-f]{6}$/.test(customHexValue)) {
          $error.text("Please enter a valid 6-digit hex colour before continuing.").show();
          revealStepError();
          return false;
        }
      }
    }

    return true;
  }

  function isForceManualMode() {
    return (
      safeTrim(
        logoWizardState.$customiseSelection &&
          logoWizardState.$customiseSelection.attr("data-force-manual")
      ) === "true"
    );
  }

  /* Force-manual submission: turn the green header band into a completion
     state ("Thanks — we've got your design" + all steps ticked). Called after
     showWizardStep so it isn't overwritten. */
  function renderManualCompletionBand() {
    /* Completion takeover: a class the CSS uses to hide the Back/Next nav so
       the finished state can't be navigated. Set even if the band lookup below
       bails, so nav is always hidden on a completed manual submission. */
    if (logoWizardState.$customiseSelection) {
      logoWizardState.$customiseSelection.addClass("is-manual-complete");
    }
    if (!logoWizardState.$bandTitle || logoWizardState.$bandTitle.length === 0) {
      return;
    }
    logoWizardState.$bandTitle.text("Thanks — we've got your design");
    if (logoWizardState.$bandSub && logoWizardState.$bandSub.length > 0) {
      logoWizardState.$bandSub
        .text("Your request is now with our design team.")
        .show();
    }
    logoWizardState.$customiseSelection
      .find(".logo-mat-wizard__eyebrow-step")
      .hide();
    if (logoWizardState.$progressDots && logoWizardState.$progressDots.length > 0) {
      var totalSteps = getWizardSteps().length || 0;
      var checkSvg =
        '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
      var dotsMarkup = "";
      for (var d = 0; d < totalSteps; d++) {
        dotsMarkup +=
          '<span class="logo-mat-wizard__progress-dot is-active is-done" aria-hidden="true">' +
          checkSvg +
          "</span>";
      }
      logoWizardState.$progressDots.html(dotsMarkup);
    }
    if (logoWizardState.$progressBarFill && logoWizardState.$progressBarFill.length > 0) {
      logoWizardState.$progressBarFill.css("width", "100%");
    }
  }

  function showWizardStep(index, options) {
    if (!logoWizardState.enabled) {
      return;
    }

    const config = options || {};
    const allSteps = getWizardSteps();
    if (allSteps.length === 0) {
      return;
    }

    let nextIndex = index;
    if (nextIndex < 0) {
      nextIndex = 0;
    }
    if (nextIndex > allSteps.length - 1) {
      nextIndex = allSteps.length - 1;
    }

    if (!config.skipValidation) {
      const currentStep = allSteps[logoWizardState.currentStepIndex];
      if (nextIndex > logoWizardState.currentStepIndex && !validateStep(currentStep)) {
        return;
      }
    }

    logoWizardState.currentStepIndex = nextIndex;

    logoWizardState.$designSteps.addClass("logo-mat-wizard__step--inactive");
    logoWizardState.$reviewStep.addClass("logo-mat-wizard__step--inactive");
    logoWizardState.$detailsStep.addClass("logo-mat-wizard__step--inactive");

    const activeStep = $(allSteps[logoWizardState.currentStepIndex]);
    activeStep.removeClass("logo-mat-wizard__step--inactive");

    /* Journey-card: mirror the active step's heading + subheading into the
       green header band. The per-step .main-product__select-heading is
       hidden via CSS, so this keeps the section-setting-driven copy as the
       single source of truth while showing it in the band (03-Jul-2026). */
    if (logoWizardState.$bandTitle && logoWizardState.$bandTitle.length > 0) {
      /* v3 (23-Sep-2026): band copy comes from LMW_STEP_META by step type;
         the section-setting headings are only a fallback for unknown steps. */
      const stepMeta = LMW_STEP_META[getWizardStepType(activeStep)];
      if (stepMeta) {
        logoWizardState.$bandTitle.text(stepMeta[1]);
        logoWizardState.$bandSub.text(stepMeta[2]).toggle(stepMeta[2].length > 0);
      } else {
        const $activeTitle = activeStep.find(".main-product__select-text").first();
        logoWizardState.$bandTitle.text(
          $activeTitle.length > 0 ? safeTrim($activeTitle.text()) : ""
        );
        const $activeSub = activeStep.find(".logo-mat-wizard__step-subheading").first();
        const activeSubText = $activeSub.length > 0 ? safeTrim($activeSub.text()) : "";
        logoWizardState.$bandSub.text(activeSubText).toggle(activeSubText.length > 0);
      }
    }

    const isDetailsStep = activeStep.is(logoWizardState.$detailsStep);
    const isLastStep = logoWizardState.currentStepIndex === allSteps.length - 1;

    /* Back: on step 1 it is kept in the layout but invisible (README: "so
       layout doesn't shift"). After an Edit from the summary it reads
       "Back" but returns to the details step — see the click handler. */
    logoWizardState.$backButton.removeClass("logo-mat-wizard__nav-button--hidden");
    if (logoWizardState.isSubmissionComplete) {
      setWizardBackButtonMode("start-over");
      logoWizardState.$backButton.removeClass("logo-mat-wizard__nav-button--invisible");
    } else {
      setWizardBackButtonMode("back");
      logoWizardState.$backButton.toggleClass(
        "logo-mat-wizard__nav-button--invisible",
        logoWizardState.currentStepIndex === 0 && !hasReturnTarget()
      );
    }

    /* Primary button: Next on steps 1–4 ("Save & return" while an Edit from the
       summary is pending; the upload gate may relabel it "Add logo to
       continue" in syncUploadStepGate). On the details step the Next button
       hides and the footer shows the Generate proxy instead — the REAL submit
       button stays inside .secure-checkout__form (all submit/progress JS and
       CSS is scoped to the form) but is hidden by CSS; the proxy just clicks
       it and mirrors its state (v3, 23-Sep-2026). */
    void isLastStep;
    if (isDetailsStep) {
      logoWizardState.$nextButton.addClass("logo-mat-wizard__nav-button--hidden");
    } else {
      logoWizardState.$nextButton.removeClass("logo-mat-wizard__nav-button--hidden");
      logoWizardState.$nextButton.text(hasReturnTarget() ? "Save & return" : "Next");
    }
    if (isDetailsStep && !logoWizardState.isSubmissionComplete) {
      logoWizardState.$customiseSelection.addClass("lmw-details-active");
      logoWizardState.$generateProxy.removeClass("logo-mat-wizard__nav-button--hidden");
    } else {
      logoWizardState.$customiseSelection.removeClass("lmw-details-active");
      logoWizardState.$generateProxy.addClass("logo-mat-wizard__nav-button--hidden");
    }
    if (isDetailsStep) {
      updateWizardSummary();
      /* Kick off intl-tel-input (and its utils.js download) now rather than
         on first focus, so the validator is normally in place by the time
         the customer presses Generate. */
      try {
        if (typeof ensureIntlTelInput === "function") ensureIntlTelInput();
      } catch (e) {
        /* phone field not on this template, or not initialised yet */
      }
    }

    logoWizardState.$progressCurrent.text(logoWizardState.currentStepIndex + 1);
    logoWizardState.$progressTotal.text(allSteps.length);
    if (logoWizardState.$progressBarFill.length > 0) {
      const progressPercent =
        allSteps.length > 1
          ? (logoWizardState.currentStepIndex / (allSteps.length - 1)) * 100
          : allSteps.length === 1
          ? 100
          : 0;
      logoWizardState.$progressBarFill.css("width", `${progressPercent}%`);
    }
    if (logoWizardState.$progressDots.length > 0) {
      const totalSteps = allSteps.length;

      /* v3 stepper (23-Sep-2026): plain 16px dots on a 6px track — done
         (solid gold), current (white with gold ring), upcoming (dark green
         with a faint ring). No numbers or ticks inside. `is-active` kept for
         older CSS. */
      const currentStepIdx = logoWizardState.currentStepIndex;
      const dotsMarkup = Array.from({ length: totalSteps }, (_, dotIndex) => {
        let stateClass = "";
        if (dotIndex < currentStepIdx) {
          stateClass = " is-active is-done";
        } else if (dotIndex === currentStepIdx) {
          stateClass = " is-active is-current";
        }
        return `<span class="logo-mat-wizard__progress-dot${stateClass}" aria-hidden="true"></span>`;
      }).join("");
      logoWizardState.$progressDots.html(dotsMarkup);
    }

    const isQuantityStep = activeStep.find(".main-product__quantity-option").length > 0;
    if (isQuantityStep) {
      renderQuantityRows();
    }
    if (!isQuantityStep && logoWizardState.$volumeInfoBar.length > 0) {
      logoWizardState.$volumeInfoBar.removeClass("is-visible").hide();
    }

    /* Runs last — showWizardStep has just reset the Next button's text and
       hidden state, so the gate styling is applied on top of a clean button. */
    syncUploadStepGate();
    if (typeof logoWizardState.updateScrollCue === "function") {
      requestAnimationFrame(logoWizardState.updateScrollCue);
    }
  }

  function initLogoWizard() {
    // Was: only ran on body.pg-eq-custom-product. The body class is
    // `pg-{{ template.suffix }}` (set in layout/eq-theme.liquid), so this
    // check excluded every OTHER logo-mat template — schools (suffix
    // eq-custom-schools), outdoor (eq-custom-outdoor-logo-mat), circular,
    // hotel, restaurant, motorcycle, racing-team. They all share the same
    // main-product.liquid section + the wizard markup, but with the gate
    // tightly coupled to `eq-custom-product`, the wizard never received
    // `.is-wizard-ready`, and CSS kept it `visibility: hidden`. Result:
    // the form vanished on every non-default logo-mat template.
    //
    // Loosened to ANY `pg-eq-custom-` prefix so all logo-mat templates
    // share the same wizard initialisation. If a specific template needs
    // the wizard suppressed, do it via a more specific check downstream
    // rather than at the top-level gate.
    const bodyClass = ($("body").attr("class") || "");
    if (!/\bpg-eq-custom-/.test(bodyClass)) {
      return;
    }

    const $customiseSelection = $(".main-product__customise-selection").first();
    const $checkout = $("#secure-checkout");
    if ($customiseSelection.length === 0 || $checkout.length === 0) {
      return;
    }

    const $designSteps = $customiseSelection
      .children(".main-product__customise-wrapper")
      .not(".logo-mat-wizard__review-step, .logo-mat-wizard__details-step");

    if ($designSteps.length === 0) {
      return;
    }

    logoWizardState.enabled = true;
    logoWizardState.$customiseSelection = $customiseSelection;
    logoWizardState.$designSteps = $designSteps;
    logoWizardState.$volumeInfoBar = $customiseSelection.children(".volume-info-bar");

    logoWizardState.$customiseSelection.addClass("logo-mat-wizard is-wizard-ready lmw-v3");
    $(".main-product__right").addClass("logo-mat-wizard-ready");

    logoWizardState.$designSteps.addClass("logo-mat-wizard__step");

    /* v3 (23-Sep-2026): orientation lives inside the Size step as block
       "1. Which way round?". Move the radio cards (same inputs, same names —
       nothing downstream changes) and mark the emptied wrapper so CSS can be
       sure it never shows. getWizardSteps drops it from the flow. */
    (function mergeOrientationIntoSizeStep() {
      const $orientationStep = logoWizardState.$designSteps
        .filter(function () {
          return $(this).find(".main-product__orientation-option").length > 0;
        })
        .first();
      const $sizeStepEl = logoWizardState.$designSteps
        .filter(function () {
          return $(this).find(".main-product__size-option").length > 0;
        })
        .first();
      if (!$orientationStep.length || !$sizeStepEl.length) return;
      const $orientationOption = $orientationStep.find(".main-product__orientation-option").first();
      const $sizeBlock = $sizeStepEl.find(".main-product__select-block").first();
      if (!$orientationOption.length || !$sizeBlock.length) return;
      const $wrap = $(
        '<div class="lmw-orientation"><p class="lmw-block-label">1. Which way round?</p></div>'
      );
      $wrap.append($orientationOption);
      $sizeBlock.prepend($wrap);
      $orientationStep.addClass("lmw-step-merged");
    })();

    /* v3 location-card copy (signed off in the handoff). Display text only —
       the radio `value`s (what the payload sends as "location") still come
       from the section settings. */
    (function applyLocationCardCopy() {
      const copy = {
        "location-option-1": ["Loose lay", "Sits on top of your floor with a rubber border."],
        "location-option-2": ["In a recess (matwell)", "Sits inside a matwell, without a rubber border."],
      };
      Object.keys(copy).forEach(function (id) {
        const $spans = $("#" + id)
          .siblings("label")
          .find(".main-product__select-option-text span");
        if ($spans.length >= 1) $spans.eq(0).text(copy[id][0]);
        if ($spans.length >= 2) $spans.eq(1).text(copy[id][1]);
      });
    })();

    const wizardHelpHeading = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-heading")
    );
    const wizardHelpText = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-text")
    );
    const wizardHelpPhone = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-phone")
    );
    const wizardHelpEmail = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-help-email")
    );
    const wizardHelpPhoneHref = wizardHelpPhone.replace(/[^0-9+]/g, "");
    void wizardHelpHeading;
    void wizardHelpText;
    /* v3 (23-Sep-2026): the Need-help footer block is gone. Help now lives in
       the band as a "Need a hand?" pill that opens a popover with WhatsApp /
       Call / Email — see buildHelpMenuMarkup + the pill handlers below. The
       phone/email still come from the section settings via data-wizard-help-*. */
    const wizardHelpEmailResolved = wizardHelpEmail || "logomats@firstmats.co.uk";
    const wizardHelpPhoneResolved = wizardHelpPhone || "0121 702 1659";
    const wizardHelpPhoneHrefResolved = wizardHelpPhoneHref || "+441217021659";
    /* wa.me wants the international number with no "+" or leading zero. */
    const wizardWhatsAppNumber = (function () {
      let digits = wizardHelpPhoneHrefResolved.replace(/[^0-9]/g, "");
      if (digits.indexOf("0") === 0) digits = "44" + digits.slice(1);
      return digits || "441217021659";
    })();

    const $quantityStep = logoWizardState.$designSteps
      .filter(function () {
        return $(this).find(".main-product__quantity-option").length > 0;
      })
      .first();
    logoWizardState.$quantityStep = $quantityStep;

    if (logoWizardState.$volumeInfoBar.length > 0 && $quantityStep.length > 0) {
      $quantityStep
        .find(".main-product__select-block")
        .first()
        .append(logoWizardState.$volumeInfoBar.addClass("logo-mat-wizard__volume-info"));
      logoWizardState.$volumeInfoBar.hide();
    }

    if ($quantityStep.length > 0) {
      const $quantityHeading = $quantityStep.find(".main-product__select-heading").first();
      if ($quantityHeading.length > 0) {
        const $quantityHeadingText = $quantityHeading.find(".main-product__select-text").first();
        if ($quantityHeadingText.length > 0) {
          $quantityHeadingText.text("Select Quantity");
        }

        let $quantitySubheading = $quantityHeading.find(".logo-mat-wizard__step-subheading").first();
        if ($quantitySubheading.length === 0) {
          $quantitySubheading = $('<p class="logo-mat-wizard__step-subheading"></p>');
          $quantityHeading.append($quantitySubheading);
        }
        if ($quantitySubheading.parent().hasClass("logo-mat-wizard__heading-row")) {
          $quantityHeading.append($quantitySubheading);
        }
        $quantitySubheading.text("Choose how many mats you need.");
      }

      const $quantityBlock = $quantityStep.find(".main-product__select-block").first();
      if ($quantityBlock.find(".logo-mat-wizard__quantity-list").length === 0) {
        $quantityBlock.prepend('<div class="logo-mat-wizard__quantity-list" aria-live="polite"></div>');
      }
      logoWizardState.$quantityList = $quantityBlock.find(".logo-mat-wizard__quantity-list").first();
      $quantityStep.find(".main-product__quantity-option, .custom-width-input-field--qty").hide();

      $quantityStep.on("click", ".logo-mat-wizard__qty-button", function () {
        const rowIndex = parseInt($(this).closest(".logo-mat-wizard__qty-row").attr("data-qty-index") || "-1", 10);
        if (Number.isNaN(rowIndex) || rowIndex < 0) {
          return;
        }
        const action = safeTrim($(this).attr("data-action")).toLowerCase();
        const currentQty = normalizeQuantityValue(logoWizardState.quantitySelections[rowIndex] || 1);
        logoWizardState.quantitySelections[rowIndex] =
          action === "decrease"
            ? Math.max(currentQty - 1, 1)
            : currentQty + 1;
        renderQuantityRows();
        lmwTrack("lm_qty_change", {
          lm_qty: logoWizardState.quantitySelections[rowIndex],
          lm_source: "stepper",
        });
      });
    }

    logoWizardState.$designSteps.each(function () {
      if ($(this).find(".logo-mat-wizard__step-error").length === 0) {
        $(this)
          .find(".main-product__customise-block")
          .first()
          .append('<p class="logo-mat-wizard__step-error" style="display:none;"></p>');
      }
    });

    const $sizeStep = logoWizardState.$designSteps
      .filter(function () {
        return $(this).find(".main-product__size-option").length > 0;
      })
      .first();
    logoWizardState.$sizeStep = $sizeStep;
    if ($sizeStep.length > 0) {
      const $sizeOption = $sizeStep.find(".main-product__size-option").first();
      const removeButtonMarkup = `
        <button type="button" class="logo-mat-wizard__size-row-remove" aria-label="Remove size">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 3h6l1 2h4v2H4V5h4l1-2zm-1 6h2v9H8V9zm4 0h2v9h-2V9zm4 0h2v9h-2V9zM6 20h12l1-12H5l1 12z"></path>
          </svg>
        </button>
      `;

      let $sizeRows = $sizeOption.children(".logo-mat-wizard__size-rows").first();
      if ($sizeRows.length === 0) {
        $sizeRows = $('<div class="logo-mat-wizard__size-rows"></div>');
        const $initialSelect = $sizeOption
          .children(".cw-product-bundle__variant-select")
          .first()
          .addBack()
          .filter(".cw-product-bundle__variant-select")
          .first();

        if ($initialSelect.length > 0) {
          const $firstRow = $('<div class="logo-mat-wizard__size-row"></div>');
          $firstRow.append($initialSelect);
          $firstRow.append($(removeButtonMarkup));
          $sizeRows.append($firstRow);
        }
        $sizeOption.prepend($sizeRows);
      } else {
        $sizeRows.children(".logo-mat-wizard__size-row").each(function () {
          if ($(this).find(".logo-mat-wizard__size-row-remove").length === 0) {
            $(this).append($(removeButtonMarkup));
          }
        });
      }

      logoWizardState.$sizeRowsContainer = $sizeRows;

      /* The "Add another size" button that used to sit under the size list was
         removed 17-Sep-2026 (team review): one size per enquiry. The size-row
         wrapper, per-row remove control and the multi-row plumbing below are
         kept as-is so the quantity/summary/submission code that walks
         `.logo-mat-wizard__size-row` is untouched — there is simply never more
         than one row now. */

      $sizeOption.on("click", ".logo-mat-wizard__size-row-remove", function () {
        const $sizeRow = $(this).closest(".logo-mat-wizard__size-row");
        const $allRows = logoWizardState.$sizeRowsContainer.children(".logo-mat-wizard__size-row");
        if ($allRows.length <= 1) {
          resetSizeSelectToPlaceholder($sizeRow.find(".cw-product-bundle__variant-select").first());
        } else {
          $sizeRow.remove();
        }
        refreshSizeRowsState();
        showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
      });

      refreshSizeRowsState();
    }

    logoWizardState.$customiseSelection
      .find(".main-product__checkout")
      .addClass("logo-mat-wizard__legacy-cta");

    /* ---------------------------------------------------------------------
       Journey-card header band (03-Jul-2026 re-skin). A single green
       gradient band at the top of the wizard card carrying an eyebrow
       ("Free Design Tool · Step N of N"), the ACTIVE step's title +
       subheading (mirrored from the step in showWizardStep so per-step
       section settings stay authoritative), and the segmented stepper.
       Replaces the old loose step-counter pill + intro heading + thin
       progress bar (both hidden via CSS). $progressCurrent/$progressTotal/
       $progressBarFill/$progressDots still point at live nodes so the
       rest of the wizard code is unchanged. */
    const wizardLogoUrl = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-logo")
    );
    const wizardLogoMarkup = wizardLogoUrl
      ? `<img class="logo-mat-wizard__band-logo" src="${escapeHtml(wizardLogoUrl)}" alt="First Mats" width="372" height="68" decoding="async">`
      : '<span class="logo-mat-wizard__band-logo logo-mat-wizard__band-logo--text">First Mats</span>';
    const chatIconSvg =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.2L4 21l1.8-4.6A8 8 0 1 1 21 12z"/></svg>';
    const $wizardBand = $(`
      <div class="logo-mat-wizard__band">
        <div class="logo-mat-wizard__band-top">
          ${wizardLogoMarkup}
          <div class="logo-mat-wizard__help">
            <button type="button" class="logo-mat-wizard__help-pill" aria-haspopup="true" aria-expanded="false">${chatIconSvg}<span>Need a hand?</span></button>
            <div class="logo-mat-wizard__help-menu" hidden>
              <a class="logo-mat-wizard__help-item" data-help-channel="whatsapp" href="https://wa.me/${wizardWhatsAppNumber}" target="_blank" rel="noopener">
                <span class="logo-mat-wizard__help-icon logo-mat-wizard__help-icon--whatsapp"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.6 7.2L4 21l1.8-4.6A8 8 0 1 1 21 12z"/></svg></span>
                <span class="logo-mat-wizard__help-text">WhatsApp us<span class="logo-mat-wizard__help-sub">Fastest reply, 9–5 Mon–Fri</span></span>
              </a>
              <a class="logo-mat-wizard__help-item" data-help-channel="call" href="tel:${escapeHtml(wizardHelpPhoneHrefResolved)}">
                <span class="logo-mat-wizard__help-icon logo-mat-wizard__help-icon--call"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.8 2z"/></svg></span>
                <span class="logo-mat-wizard__help-text">Call us<span class="logo-mat-wizard__help-sub">${escapeHtml(wizardHelpPhoneResolved)}</span></span>
              </a>
              <a class="logo-mat-wizard__help-item" data-help-channel="email" href="mailto:${escapeHtml(wizardHelpEmailResolved)}">
                <span class="logo-mat-wizard__help-icon logo-mat-wizard__help-icon--email"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#173729" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg></span>
                <span class="logo-mat-wizard__help-text">Email us<span class="logo-mat-wizard__help-sub">${escapeHtml(wizardHelpEmailResolved)}</span></span>
              </a>
            </div>
          </div>
        </div>
        <div class="logo-mat-wizard__eyebrow">
          <span class="logo-mat-wizard__eyebrow-step" aria-live="polite">Step <strong class="logo-mat-wizard__progress-current">1</strong> of <strong class="logo-mat-wizard__progress-total">5</strong></span>
        </div>
        <h2 class="logo-mat-wizard__band-title"></h2>
        <p class="logo-mat-wizard__band-sub"></p>
        <div class="logo-mat-wizard__progress-bar" aria-hidden="true">
          <span class="logo-mat-wizard__progress-bar-fill"></span>
          <div class="logo-mat-wizard__progress-dots"></div>
        </div>
      </div>
    `);
    logoWizardState.$customiseSelection.prepend($wizardBand);
    logoWizardState.$band = $wizardBand;
    logoWizardState.$helpMenu = $wizardBand.find(".logo-mat-wizard__help-menu");

    /* "Need a hand?" popover. WhatsApp + email carry the selections so far
       (one per line) so the team can pick the enquiry up mid-way. Rebuilt on
       every open, closed on any pointerdown outside it. */
    function buildHelpMessage() {
      const isRecess = isMatwellLocationSelected();
      const orientation = safeTrim($('input[name="select-orientation"]:checked').val()) === "portrait" ? "Portrait" : "Landscape";
      const sizeItem = getSelectedSizeDataList()[0];
      let sizeText = "not chosen yet";
      if (sizeItem) {
        sizeText = safeTrim(sizeItem.customWidth)
          ? `${sizeItem.customWidth} × ${sizeItem.customLength} cm`
          : safeTrim(sizeItem.size);
      }
      const qty = normalizeQuantityValue(logoWizardState.quantitySelections[0] || 1);
      let logoText = "not yet";
      if (hasUploadedLogo()) {
        const fileInput = document.querySelector(".main-product__upload-file-input");
        const fileName = fileInput && fileInput.files && fileInput.files[0] ? fileInput.files[0].name : "";
        logoText = fileName ? `uploaded (${fileName})` : "uploaded";
      }
      return [
        "Hi First Mats, I need a hand with a logo mat.",
        `Location: ${isRecess ? "In a recess" : "Loose lay"}`,
        `Orientation: ${orientation}`,
        `Size: ${sizeText}`,
        `Quantity: ${qty}`,
        `Logo: ${logoText}`,
      ].join("\n");
    }
    function setHelpMenuOpen(open) {
      logoWizardState.$helpMenu.prop("hidden", !open);
      $wizardBand.find(".logo-mat-wizard__help-pill").attr("aria-expanded", open ? "true" : "false");
    }
    $wizardBand.on("click", ".logo-mat-wizard__help-pill", function () {
      const willOpen = logoWizardState.$helpMenu.prop("hidden");
      if (willOpen) {
        const message = buildHelpMessage();
        logoWizardState.$helpMenu
          .find('[data-help-channel="whatsapp"]')
          .attr("href", `https://wa.me/${wizardWhatsAppNumber}?text=${encodeURIComponent(message)}`);
        logoWizardState.$helpMenu
          .find('[data-help-channel="email"]')
          .attr(
            "href",
            `mailto:${wizardHelpEmailResolved}?subject=${encodeURIComponent("Logo mat enquiry")}&body=${encodeURIComponent(message)}`
          );
      }
      setHelpMenuOpen(willOpen);
      if (willOpen) lmwTrack("lm_help_open");
    });
    $wizardBand.on("click", ".logo-mat-wizard__help-item", function () {
      lmwTrack("lm_help_channel", { lm_channel: safeTrim($(this).attr("data-help-channel")) });
    });
    $(document).on("pointerdown", function (e) {
      if (logoWizardState.$helpMenu.prop("hidden")) return;
      if ($(e.target).closest(".logo-mat-wizard__help").length === 0) setHelpMenuOpen(false);
    });

    logoWizardState.$progressCurrent = $wizardBand.find(".logo-mat-wizard__progress-current");
    logoWizardState.$progressTotal = $wizardBand.find(".logo-mat-wizard__progress-total");
    logoWizardState.$progressBarFill = $wizardBand.find(".logo-mat-wizard__progress-bar-fill");
    logoWizardState.$progressDots = $wizardBand.find(".logo-mat-wizard__progress-dots");
    logoWizardState.$bandTitle = $wizardBand.find(".logo-mat-wizard__band-title");
    logoWizardState.$bandSub = $wizardBand.find(".logo-mat-wizard__band-sub");

    const detailsHeading =
      safeTrim(
        logoWizardState.$customiseSelection.attr("data-wizard-details-heading")
      ) || "Where shall we send your free design?";
    /* Empty subheading → no subheading rendered (the conditional below
       skips the <p> when this is blank). Hardcoded fallback removed
       03-Jun-2026 — the contact step now leads with just the
       "Where shall we send your free design?" headline, which tested
       better at reducing drop-off than the prior two-line treatment. */
    const detailsSubheading = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-details-subheading")
    );
    const detailsTooltip = safeTrim(
      logoWizardState.$customiseSelection.attr("data-wizard-details-tooltip")
    );
    const detailsTooltipMarkup = detailsTooltip
      ? `<button type="button" class="logo-mat-wizard__heading-tooltip" title="${escapeHtml(
          detailsTooltip
        )}" aria-label="${escapeHtml(detailsTooltip)}">?</button>`
      : "";
    const detailsSubheadingMarkup = detailsSubheading
      ? `<p class="logo-mat-wizard__step-subheading">${escapeHtml(detailsSubheading)}</p>`
      : "";

    const $detailsStep = $(`
      <div class="main-product__customise-wrapper logo-mat-wizard__details-step logo-mat-wizard__step">
        <div class="main-product__customise-block">
          <div class="main-product__select-heading">
            <span class="main-product__select-count"></span>
            <div class="logo-mat-wizard__heading-row">
              <span class="main-product__select-text">${escapeHtml(detailsHeading)}</span>
              ${detailsTooltipMarkup}
            </div>
            ${detailsSubheadingMarkup}
          </div>
          <div class="main-product__select-block">
            <div class="logo-mat-wizard__checkout-slot"></div>
          </div>
        </div>
      </div>
    `);

    logoWizardState.$customiseSelection.append($detailsStep);
    logoWizardState.$reviewStep = $();
    logoWizardState.$detailsStep = $detailsStep;
    logoWizardState.$summaryList = $();
    logoWizardState.$summaryHelpText = $();
    logoWizardState.$continueDetailsButton = $();
    /* Help block is now appended ONCE to the wizard container after
       the navigation (see further down). The previous per-step
       `appendWizardNeedHelp($detailsStep)` call has been removed —
       leaving it in place threw a ReferenceError that killed wizard
       initialisation and made the form render as one long page.
       (03-Jun-2026.) */

    $checkout
      .appendTo($detailsStep.find(".logo-mat-wizard__checkout-slot"))
      .addClass("logo-mat-wizard__inline-checkout")
      .show();

    const $wizardCheckoutForm = $detailsStep.find(".secure-checkout__form").first();
    if ($wizardCheckoutForm.length > 0) {
      $wizardCheckoutForm
        .find(".secure-checkout__title")
        .text(detailsHeading || "Enter Details");
      $wizardCheckoutForm
        .find(".secure-checkout__information p")
        .text(detailsSubheading || "Enter your contact details so we can send you over your proof");

      const $wizardFillData = $wizardCheckoutForm.find(".secure-checkout__fill-data").first();
      const $firstNameField = $wizardCheckoutForm.find("#firstName").closest(".secure-checkout__field");
      const $surnameField = $wizardCheckoutForm.find("#surname").closest(".secure-checkout__field");
      const $emailField = $wizardCheckoutForm.find("#email").closest(".secure-checkout__field");
      const $companyField = $wizardCheckoutForm.find("#company").closest(".secure-checkout__field");
      const $phoneField = $wizardCheckoutForm.find("#phone").closest(".secure-checkout__field");

      /* v3 field order (23-Sep-2026): First + Last side by side, Email full
         width, Phone + Company side by side. Same inputs/ids — the validators
         and payload are untouched. */
      if ($wizardFillData.length > 0) {
        $wizardFillData.append($firstNameField, $surnameField, $emailField, $phoneField, $companyField);
      }
      /* Phone and Company each on their own line (Jack, 23-Sep-2026) — only
         First + Last share a row. */
      $firstNameField.add($surnameField)
        .removeClass("secure-checkout__full")
        .addClass("secure-checkout__half");
      $emailField.add($phoneField).add($companyField)
        .removeClass("secure-checkout__half")
        .addClass("secure-checkout__full");

      $firstNameField.find(".secure-checkout__label").text("First name");
      $surnameField.find(".secure-checkout__label").text("Last name");
      $emailField.find(".secure-checkout__label").text("Email");
      $phoneField.find(".secure-checkout__label").text("Phone");
      $companyField.find(".secure-checkout__label").text("Company");
      $wizardCheckoutForm.find("#firstName, #surname, #email, #company, #phone").attr("placeholder", "");
      $wizardCheckoutForm.find(".secure-checkout__button").text("Generate my instant proof");

      /* Instant-proof callout — key messaging, sits under the fields. */
      if ($wizardFillData.length > 0 && $wizardCheckoutForm.find(".lmw-proof-callout").length === 0) {
        $wizardFillData.after(`
          <div class="lmw-proof-callout">
            <span class="lmw-proof-callout__icon" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="#173729"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg></span>
            <span class="lmw-proof-callout__text">
              <span class="lmw-proof-callout__title">Your proof is generated instantly after you submit.</span>
              <span class="lmw-proof-callout__sub">Edit and finalise your design on the next page.</span>
            </span>
          </div>
        `);
      }
    }

    /* "Your selections" panel (right column on desktop, stacked on mobile).
       Filled by updateWizardSummary every time the details step shows. */
    const $selectionsPanel = $('<aside class="lmw-selections" aria-label="Your selections"></aside>');
    $detailsStep.find(".main-product__select-block").first().append($selectionsPanel);
    logoWizardState.$summaryList = $selectionsPanel;

    const $wizardNav = $(`
      <div class="logo-mat-wizard__navigation">
        <button type="button" class="logo-mat-wizard__nav-button logo-mat-wizard__nav-button--back">Back</button>
        <button type="button" class="logo-mat-wizard__nav-button logo-mat-wizard__nav-button--next">Next</button>
        <button type="button" class="logo-mat-wizard__nav-button logo-mat-wizard__nav-button--generate logo-mat-wizard__nav-button--hidden">Generate my instant proof</button>
      </div>
    `);
    logoWizardState.$customiseSelection.append($wizardNav);
    logoWizardState.$wizardNav = $wizardNav;

    /* Scroll cue for phones (23-Sep-2026, Jack). iOS Safari cannot style the
       real scrollbar — it only appears while scrolling — so a styled one was
       no cue at all. This draws our own rail on the right of the step body
       (thumb sized/positioned from scrollTop) plus a fade above the footer,
       both hidden once the step is scrolled to its end or fits without
       scrolling. Geometry is refreshed on scroll, on step change and on a slow
       tick (content height changes as sizes expand / quantities render). CSS
       shows these only under 768px. */
    const $scrollRail = $(
      '<div class="lmw-scroll-rail" aria-hidden="true" hidden><div class="lmw-scroll-rail__thumb"></div></div>'
    );
    const $scrollFade = $('<div class="lmw-scroll-fade" aria-hidden="true" hidden></div>');
    logoWizardState.$customiseSelection.append($scrollRail, $scrollFade);

    function updateScrollCue() {
      const card = logoWizardState.$customiseSelection[0];
      if (!card || !card.classList.contains("is-lmw-modal")) {
        $scrollRail.prop("hidden", true);
        $scrollFade.prop("hidden", true);
        return;
      }
      const stepEl = card.querySelector(".logo-mat-wizard__step:not(.logo-mat-wizard__step--inactive)");
      if (!stepEl) {
        $scrollRail.prop("hidden", true);
        $scrollFade.prop("hidden", true);
        return;
      }
      const maxScroll = stepEl.scrollHeight - stepEl.clientHeight;
      if (maxScroll < 8) {
        $scrollRail.prop("hidden", true);
        $scrollFade.prop("hidden", true);
        return;
      }
      const cardRect = card.getBoundingClientRect();
      const stepRect = stepEl.getBoundingClientRect();
      const railTop = stepRect.top - cardRect.top + 6;
      const railHeight = Math.max(0, stepRect.height - 12);
      const thumbHeight = Math.max(28, railHeight * (stepEl.clientHeight / stepEl.scrollHeight));
      const progress = Math.min(1, Math.max(0, stepEl.scrollTop / maxScroll));
      const thumbTop = (railHeight - thumbHeight) * progress;
      $scrollRail.prop("hidden", false).css({ top: railTop + "px", height: railHeight + "px" });
      $scrollRail.find(".lmw-scroll-rail__thumb").css({ height: thumbHeight + "px", transform: `translateY(${thumbTop}px)` });
      const atEnd = progress > 0.98;
      $scrollFade
        .prop("hidden", atEnd)
        .css({ bottom: cardRect.bottom - stepRect.bottom + "px" });
    }
    logoWizardState.updateScrollCue = updateScrollCue;
    logoWizardState.$customiseSelection[0].addEventListener("scroll", updateScrollCue, true);
    $(window).on("resize orientationchange", updateScrollCue);
    setInterval(updateScrollCue, 400);
    logoWizardState.$backButton = $wizardNav.find(".logo-mat-wizard__nav-button--back");
    logoWizardState.$nextButton = $wizardNav.find(".logo-mat-wizard__nav-button--next");
    logoWizardState.$generateProxy = $wizardNav.find(".logo-mat-wizard__nav-button--generate");

    /* Footer proxy for the real "Generate" button (which stays inside the
       form for the submit/progress code). Its incomplete/submitting states
       are mirrored onto the proxy by updateGenerateButtonState and
       setCheckoutSubmitState. */
    logoWizardState.$generateProxy.on("click", function () {
      $(".secure-checkout__form .secure-checkout__button").first().trigger("click");
    });

    /* Next / Back honour a pending "Edit from summary" target: Next validates
       the current step then jumps back to the details step; Back returns
       there without validating. Either way the target is consumed. */
    logoWizardState.$nextButton.on("click", function () {
      const allSteps = getWizardSteps();
      const currentStep = allSteps[logoWizardState.currentStepIndex];
      if (!validateStep(currentStep)) {
        return;
      }
      const target = hasReturnTarget()
        ? logoWizardState.returnToIndex
        : logoWizardState.currentStepIndex + 1;
      logoWizardState.returnToIndex = null;
      showWizardStep(target, { skipValidation: true });
    });

    logoWizardState.$backButton.on("click", function () {
      if (logoWizardState.isSubmissionComplete) {
        resetWizardForNewSubmission();
        return;
      }
      const target = hasReturnTarget()
        ? logoWizardState.returnToIndex
        : logoWizardState.currentStepIndex - 1;
      logoWizardState.returnToIndex = null;
      showWizardStep(target, { skipValidation: true });
    });

    /* "Edit" / "Change logo" links in the details summary (rendered by
       updateWizardSummary). data-step-type names the step to open. */
    logoWizardState.$customiseSelection.on("click", "[data-lmw-edit-step]", function (e) {
      e.preventDefault();
      const wantedType = safeTrim($(this).attr("data-lmw-edit-step"));
      const allSteps = getWizardSteps();
      let targetIndex = -1;
      let detailsIndex = -1;
      allSteps.forEach(function (stepEl, index) {
        const type = getWizardStepType($(stepEl));
        if (type === wantedType && targetIndex === -1) targetIndex = index;
        if (type === "details") detailsIndex = index;
      });
      if (targetIndex === -1 || detailsIndex === -1) return;
      lmwTrack("lm_summary_edit", { lm_edit_step: wantedType });
      logoWizardState.returnToIndex = detailsIndex;
      showWizardStep(targetIndex, { skipValidation: true });
    });

    /* Dull the "Generate Logo Mat Proof" button until the required contact
       fields are completed (03-Jul-2026). Uses a CLASS, not the disabled
       prop, so it doesn't collide with the submit-in-progress state, and a
       click while incomplete still runs the existing per-field validation
       (which tells the user exactly what's missing). The check is deliberately
       a touch looser than the submit validator (basic email pattern, phone
       non-empty) so it never blocks a genuinely valid submission. */
    function updateGenerateButtonState() {
      var $btn = $(".secure-checkout__form .secure-checkout__button");
      if (!$btn.length) return;
      var firstName = safeTrim($("#firstName").val());
      var surname = safeTrim($("#surname").val());
      var company = safeTrim($("#company").val());
      var email = safeTrim($("#email").val());
      var phone = safeTrim($("#phone").val());
      var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      var complete = !!(firstName && surname && company && emailOk && phone);
      $btn.toggleClass("logo-mat-wizard__gen-incomplete", !complete);
      logoWizardState.$generateProxy.toggleClass("logo-mat-wizard__gen-incomplete", !complete);
    }
    $(document).on(
      "input change",
      "#firstName, #surname, #company, #email, #phone",
      updateGenerateButtonState
    );
    updateGenerateButtonState();

    /* Keep the upload-step gate in step with the logo state (28-Jul-2026).
       eq-custom.js sets `.value` directly on upload and on remove without
       dispatching anything — hence the file-input listener and the slow
       safety-net interval as belt-and-braces. */
    $(document).on(
      "input change",
      ".main-product__uploaded-file-url",
      syncUploadStepGate
    );
    $(document).on("change", ".main-product__upload-file-input", function () {
      /* The upload POSTs async — the URL lands a moment later. Poll for 10s,
         stopping early once the logo is through. */
      let attempts = 0;
      const poll = setInterval(function () {
        attempts++;
        syncUploadStepGate();
        if (attempts >= 50 || hasUploadedLogo()) {
          clearInterval(poll);
        }
      }, 200);
    });
    $(document).on("click", ".main-product__upload-remove", function () {
      /* eq-custom.js clears the URL synchronously on this same click. */
      setTimeout(syncUploadStepGate, 0);
    });
    setInterval(syncUploadStepGate, 1000);

    /* Stuck-picker rescue: "continue without a logo" (25-Aug-2026). Only
       rendered inside `.lm-upload-rescue` (main-product.liquid), which
       eq-custom.js reveals after two dead picker taps — see the rescue
       comment there. Marks the logo as deferred-to-email so the upload-step
       gate opens, then moves the customer straight on; chasing the file by
       email is the team's job, not another hurdle in the form. */
    $(document).on("click", ".js-lm-defer-logo", function () {
      $(".main-product__logo-deferred").val("1");
      /* Logo Source for Dataverse. The rescue only shows when no logo has been
         uploaded, so nothing real is overwritten here; a later successful
         upload sets "upload" (eq-custom.js) and wins. */
      $(".main-product__uploaded-logo-source").val("email-later");
      $("#statusMessage")
        .text("No problem — we'll ask for your logo by email after you send the form.")
        .removeClass("is-error is-uploading")
        .addClass("is-success");
      $(".lm-upload-rescue").prop("hidden", true);
      syncUploadStepGate();
      if (logoWizardState.enabled && logoWizardState.$nextButton) {
        logoWizardState.$nextButton.trigger("click");
      }
    });

    $(document).on(
      "change",
      'input[name="bespoke-option"], input[name="background-color-swatch"], input[name="select-orientation"], input[name="select-backing"], input[name="width"], input[name="length"], #color-option-input, #backgroundCustomColourInput, #backgroundCustomColourHex',
      function () {
        if (logoWizardState.enabled) {
          showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
        }
      }
    );

    $(document).on(
      "click",
      ".main-product__size-option .cw-product-bundle__variant-option, .main-product__quantity-option .cw-product-bundle__variant-option",
      function () {
        if (logoWizardState.enabled) {
          showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
        }
      }
    );

    /* Defensive open for the "Enquire by Email" button in the wizard's
     Need Help block (03-Jun-2026). The anchor's default `mailto:`
     activation was being suppressed somewhere — couldn't find a clear
     culprit, but the symptom was: clicking the button did nothing.
     Programmatically setting `window.location` ignores any prior
     `event.preventDefault()` from upstream delegated handlers and forces
     the browser to open the user's mail handler.

     `closest()` ensures clicks that land on the inner SVG/<span> still
     resolve to the anchor. We don't call preventDefault here — letting
     the native handling fire too is harmless (the second navigation
     attempt is a no-op once the first opens the mail app). */
  $(document).on("click", ".logo-mat-wizard__need-help-btn--email", function (e) {
    const href = (this.getAttribute && this.getAttribute("href")) || "";
    if (href.indexOf("mailto:") === 0) {
      try {
        window.location.href = href;
      } catch (err) {
        /* swallow — native default will still fire */
      }
    }
  });

  $(document).on("click", ".logo-mat-wizard__size-help-toggle", function () {
      const $toggle = $(this);
      const targetId = safeTrim($toggle.attr("aria-controls"));
      if (!targetId) {
        return;
      }
      const $panel = $(`#${targetId}`);
      if ($panel.length === 0) {
        return;
      }
      const isExpanded = $toggle.attr("aria-expanded") === "true";
      $toggle.attr("aria-expanded", isExpanded ? "false" : "true");
      $panel.prop("hidden", isExpanded);
    });

    /* Intro / "start" screen (03-Jul-2026): a pre-step green panel that gives
       users a clear starting action. If present (`[data-lmw-intro]`), the
       wizard opens on it (class `is-intro` hides the band/steps/nav/help via
       CSS); clicking "Start my free design" reveals step 1. Not counted as a
       wizard step — $designSteps only picks up `.main-product__customise-wrapper`. */
    const $introScreen = logoWizardState.$customiseSelection.find("[data-lmw-intro]").first();
    if ($introScreen.length > 0) {
      logoWizardState.$customiseSelection.addClass("is-intro");

      /* Pop-out / modal wizard (10-Jul-2026): the intro panel stays inline on
         the product page; clicking "Start" lifts the SAME wizard card into a
         centred modal (backdrop + scroll-lock) for more space + focus. Closing
         (×, backdrop, or Esc) returns it to the inline intro teaser. The form
         markup/flow is unchanged — this only repositions the card. */
      const $card = logoWizardState.$customiseSelection;
      const $body = $("body");
      let $backdrop = null;
      let lastFocusedEl = null;

      function closeWizardModal() {
        $card.removeClass("is-lmw-modal").removeAttr("role").removeAttr("aria-modal");
        $body.removeClass("lmw-modal-open");
        if ($backdrop) {
          $backdrop.remove();
          $backdrop = null;
        }
        $(document).off("keydown.lmwModal");
        $card.addClass("is-intro");
        logoWizardState.returnToIndex = null;
        showWizardStep(0, { skipValidation: true });
        if (lastFocusedEl && typeof lastFocusedEl.focus === "function") {
          try { lastFocusedEl.focus(); } catch (e) {}
        }
      }

      function openWizardModal() {
        lastFocusedEl = document.activeElement;
        $backdrop = $('<div class="lmw-modal-backdrop"></div>')
          .appendTo($body)
          .on("click", closeWizardModal);
        $body.addClass("lmw-modal-open");
        $card
          .removeClass("is-intro")
          .addClass("is-lmw-modal")
          .attr({ role: "dialog", "aria-modal": "true" });
        if ($card.find(".lmw-modal-close").length === 0) {
          $(
            '<button type="button" class="lmw-modal-close" aria-label="Close design tool">&times;</button>'
          )
            .appendTo($card)
            .on("click", closeWizardModal);
        }
        $(document).on("keydown.lmwModal", function (e) {
          if (e.key === "Escape" || e.keyCode === 27) closeWizardModal();
        });
        showWizardStep(0, { skipValidation: true });
        $card.scrollTop(0);
      }

      logoWizardState.closeWizardModal = closeWizardModal;

      $introScreen.on("click", "[data-lmw-intro-start]", function (e) {
        e.preventDefault();
        openWizardModal();
      });
    }

    showWizardStep(0, { skipValidation: true });
  }




  // New js start here 28-04-25
  let productCusNavSlider = $(".js-product-cus-nav-slider");
  let productCusThumbSlider = $(".js-product-cus-thumb-slider");

  if (
    productCusNavSlider.length > 0 &&
    !productCusNavSlider.hasClass("slick-initialized") &&
    productCusThumbSlider.length > 0 &&
    !productCusThumbSlider.hasClass("slick-initialized")
  ) {
    productCusNavSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: false,
      infinite: true,
      speed: 500,
      asNavFor: ".js-product-cus-thumb-slider", // corrected selector
    });

    productCusThumbSlider.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: ".js-product-cus-nav-slider", // corrected selector
      arrows: true,
      dots: false,
      infinite: true,
      centerMode: false,
      focusOnSelect: true,
      variableWidth: false,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide">' +
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7 1L1 7L7 13" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>",
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide">' +
        '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 13L7 7L1 1" stroke="#222329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>",
    });
  }
  // New js start here 28-04-25

  $(".main-product__quantity-option")
    .find(".cw-product-bundle__variant-option")
    .first()
    .addClass("active-status");

  $(".cw-product-bundle__variant-select").each(function (
    index,
    currentSelecter
  ) {
    // console.log("currentSelecter ", currentSelecter);

    // Skip auto-selection for the size dropdown — show "Select Size" placeholder instead
    var isSizeDropdown = $(this).closest(".main-product__size-option").length > 0;

    let minPriceOption = null;
    let minPrice = Infinity;
    let firstSelectedQty;

    $(this)
      .find(".cw-product-bundle__variant-option")
      .each(function (i, optiondata) {
        // console.log("optiondata ", optiondata);
        let optionQty = $(optiondata).attr("data-selected-qty");
        if (optionQty && i == 0) {
          firstSelectedQty = optionQty;
          // console.log("firstSelectedQty ", firstSelectedQty);

          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentQty", optionQty);
        }
        const price = parseFloat($(this).data("variant-price") / 100) || 0;

        // Check if price is 59 or above and is the lowest found so far
        if (price >= 59 && price < minPrice) {
          // console.log("price", price);
          minPrice = price;
          minPriceOption = $(this);
        }

        if (
          $(optiondata).attr("data-text").toUpperCase().indexOf("CUSTOM") > -1
        ) {
          /* Don't hide the price slot if it's already been decorated with
             the "Choose →" CTA pill (see decorateSizeOptionsForWizard
             ~L2128) — that decoration repurposes the slot rather than
             leaving it empty, and hiding it would erase the only
             interactive cue on the custom-size row. */
          const $customPriceEl = $(optiondata).find(".cw-product-bundle__option-price");
          if (!$customPriceEl.hasClass("cw-product-bundle__option-price--custom-cta")) {
            $customPriceEl.hide();
          }
        }
      });

    if (minPriceOption && !isSizeDropdown) {
      // console.log("check minprice");
      const selectedText = minPriceOption.data("text") || "";
      const selectedSavePercentage =
        minPriceOption.data("save-percentage") || "";
      const selectedPrice = minPriceOption.data("price") || "";
      const selectedVariantPrice = minPriceOption.data("variant-price") || "";
      const selectedValue = minPriceOption.text() || "";

      if (firstSelectedQty) {
        // console.log("optiondata qty ", optionQty);
      }

      // Generate HTML for the selected option display
      const selectedHtml = `
                ${
                  selectedText
                    ? `<span class="cw-product-bundle__variant-text" data-variant-price="${selectedVariantPrice}">${selectedText}</span>`
                    : ""
                }
                ${
                  selectedSavePercentage
                    ? `<span class="cw-product-bundle__variant-save-percentage ssss">${selectedSavePercentage}</span>`
                    : ""
                }
                ${
                  selectedPrice
                    ? `<span class="cw-product-bundle__variant-price demo123">${selectedPrice}</span>`
                    : ""
                }
            `;

      // Update the DOM elements with the selected option's details
      $(this).find(".cw-product-bundle__variant-selected").html(selectedHtml);
      $(this).find('input[type="hidden"]').val(selectedValue);

      // console.log("Selected option:", {
      //     text: selectedText,
      //     savePercentage: selectedSavePercentage,
      //     price: selectedPrice,
      //     variantPrice: selectedVariantPrice
      // });
      OptionsHandler(minPriceOption);
    } else {
      // console.log("No option with a price of 59 or higher found.");
    }
  });

  function decorateSizeOptionsForWizard() {
    $(".main-product__size-option .cw-product-bundle__variant-option").each(function () {
      const $option = $(this);
      const optionText = String(
        $option.attr("data-text") ||
          $option.find(".cw-product-bundle__option-text").text() ||
          ""
      );
      const optionTextLower = optionText.toLowerCase();

      if (optionTextLower.indexOf("custom") > -1) {
        $option.addClass("cw-product-bundle__variant-option--custom-size");
        /* Replace the empty hidden price slot with a "Choose →" CTA pill
           so the row reads as a clear interactive choice rather than a
           passive footer banner. The pill sits in the same grid-area
           ("price") that displays £XX.XX on standard rows, so the row's
           visual rhythm matches the rest of the dropdown. CSS:
           `.cw-product-bundle__option-price--custom-cta` (see
           eq-product-style.css). */
        const $priceSlot = $option
          .find(".cw-product-bundle__option-price")
          .first();
        if ($priceSlot.length && $priceSlot.find(".cw-product-bundle__custom-cta").length === 0) {
          $priceSlot
            .addClass("cw-product-bundle__option-price--custom-cta")
            .show()
            .html(
              '<span class="cw-product-bundle__custom-cta">' +
              '<span class="cw-product-bundle__custom-cta-text">Enter size</span>' +
              '<span class="cw-product-bundle__custom-cta-arrow" aria-hidden="true">▾</span>' +
              '</span>'
            );
        }
      }

    });

    $(".main-product__size-option .cw-product-bundle__variant-options").each(function () {
      const $list = $(this);

      /* Journey-card INLINE size list (03-Jul-2026): the CSS neutralises the
         dropdown popover so this list renders inline (always open) with the
         trigger hidden. Custom hero FIRST, a divider before the standard
         sizes, and non-popular "extra" sizes collapsed behind an expander.
         Presentational only — tiles keep their data-* contract + click-to-
         select handler. */
      const $customSizeOption = $list
        .children(".cw-product-bundle__variant-option--custom-size")
        .first();
      if ($customSizeOption.length) {
        $customSizeOption.prependTo($list);

        /* Build the custom hero's inner structure once: icon square + a
           title-row (label + "Most requested" pill) + subtitle + a selected
           check. The pill/subtitle are SIBLINGS of the label, not inside it,
           so updateCustomSizeLabels()'s .text() on the label can't wipe them. */
        if (!$customSizeOption.hasClass("lmw-custom-hero-built")) {
          $customSizeOption.addClass("lmw-custom-hero-built");
          const $heroLabel = $customSizeOption
            .find(".cw-product-bundle__option-text")
            .first();
          $heroLabel.before(
            '<span class="cw-product-bundle__custom-icon" aria-hidden="true">' +
              /* Ruler glyph (17-Sep-2026) — the old corner-brackets icon read as
                 "fullscreen", not "measure". Drawn flat, then rotated 45deg. */
              '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#E9B23C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><g transform="rotate(-45 12 12)"><rect x="1.5" y="9" width="21" height="6" rx="1.5"/><path d="M6 9v3M10 9v3M14 9v3M18 9v3"/></g></svg>' +
            "</span>"
          );
          $heroLabel.wrap('<span class="cw-product-bundle__custom-titlerow"></span>');
          $heroLabel.after(
            '<span class="cw-product-bundle__custom-badge">★ Most requested</span>'
          );
          $customSizeOption
            .find(".cw-product-bundle__custom-titlerow")
            .after(
              '<span class="cw-product-bundle__custom-sub">' + escapeHtml(getCustomSizeSubCopy()) + '</span>'
            );
          $customSizeOption.append(
            '<span class="cw-product-bundle__custom-check" aria-hidden="true">' +
              '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#ffffff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
            "</span>"
          );
        }

        if ($list.children(".cw-product-bundle__size-divider").length === 0) {
          $customSizeOption.after(
            '<div class="cw-product-bundle__size-divider"><span>Or pick a standard size</span></div>'
          );
        }

        /* Move the width/length panel to sit directly under the custom hero
           (by default it lives at wrapper level, appearing below every size).
           Inserted BEFORE the divider → hero, inputs, divider, standard sizes.
           It's a single global element (there is only ever one size row). */
        const $sizeInputs = $customSizeOption
          .closest(".main-product__customise-wrapper")
          .find(".custom-width-input-field")
          .first();
        if ($sizeInputs.length) {
          $customSizeOption.after($sizeInputs);
        }
      }

      /* v3 (23-Sep-2026): every standard size is shown — no expander. The
         hero tile itself is hidden by CSS; typing in the custom inputs selects
         it programmatically (see ensureCustomSizeActive). Wrap the inputs in
         the "2. Enter your custom size" panel and add the two dashed
         switch-rows that the size-mode classes toggle. */
      if ($customSizeOption.length && $list.children(".lmw-custom-panel").length === 0) {
        const $sizeInputsNow = $list.children(".custom-width-input-field").first();
        if ($sizeInputsNow.length) {
          const $panel = $(
            '<div class="lmw-custom-panel"><p class="lmw-block-label">2. Enter your custom size</p><div class="lmw-custom-panel__box"></div></div>'
          );
          $sizeInputsNow.before($panel);
          $panel.find(".lmw-custom-panel__box").append($sizeInputsNow);
          $panel.before(
            '<button type="button" class="lmw-switch-row" data-lmw-switch="custom">Enter a custom size instead<span aria-hidden="true">\u2192</span></button>'
          );
          $panel.after(
            '<button type="button" class="lmw-switch-row" data-lmw-switch="standard">Or pick a standard size instead<span aria-hidden="true">\u2192</span></button>'
          );
        }
      }
      relabelStandardSizeOptions($list);

      /* 23-Sep-2026 (Jack): the full list ran off the bottom of the screen with
         nothing to say more sizes exist. Start collapsed to the `--popular`
         sizes (60×85, 85×115, 85×150, 115×180 — the section's popular_sizes
         setting) with a "Show N more sizes" row, at every width. Clicking a
         hidden ("extra") size opens the list. */
      const $extras = $list.children(".cw-product-bundle__variant-option--extra");
      if ($extras.length > 0 && $list.children(".lmw-size-more").length === 0) {
        $list.addClass("is-collapsed");
        $list.append(
          '<button type="button" class="lmw-size-more" aria-expanded="false">' +
            '<span class="lmw-size-more__label">Show ' + $extras.length + ' more sizes</span>' +
            '<span class="lmw-size-more__arrow" aria-hidden="true">\u2193</span>' +
          "</button>"
        );
        $list.data("lmwExtraCount", $extras.length);
      }
    });

    updateCustomSizeLabels();
  }

  function setSizeListCollapsed($list, collapsed) {
    const extraCount = $list.data("lmwExtraCount") || $list.children(".cw-product-bundle__variant-option--extra").length;
    $list.toggleClass("is-collapsed", collapsed);
    const $btn = $list.children(".lmw-size-more");
    $btn.attr("aria-expanded", collapsed ? "false" : "true");
    $btn.find(".lmw-size-more__label").text(collapsed ? `Show ${extraCount} more sizes` : "Show fewer sizes");
    $btn.find(".lmw-size-more__arrow").text(collapsed ? "\u2193" : "\u2191");
  }

  $(document).on("click", ".lmw-size-more", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $list = $(this).closest(".cw-product-bundle__variant-options");
    const expanding = $list.hasClass("is-collapsed");
    setSizeListCollapsed($list, !expanding);
    if (expanding) lmwTrack("lm_size_list_expand");
  });

  /* --- v3 size step helpers (23-Sep-2026) -------------------------------- */

  /* "60cm x 85cm" → "85 × 60 cm" (landscape: larger first) / "60 × 85 cm"
     (portrait). Display only — `data-text` (the variant label the payload and
     matcher use) is untouched; `data-display-text` mirrors the shown label so
     resolveSizeSelectMatchedOption still matches either way. */
  function formatStandardSizeLabel(dataText) {
    const match = String(dataText || "").match(/(\d+(?:\.\d+)?)\s*(?:cm)?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!match) return "";
    const a = parseFloat(match[1]);
    const b = parseFloat(match[2]);
    const portrait = safeTrim($('input[name="select-orientation"]:checked').val()) === "portrait";
    const hi = Math.max(a, b);
    const lo = Math.min(a, b);
    return portrait ? `${lo} × ${hi} cm` : `${hi} × ${lo} cm`;
  }

  function relabelStandardSizeOptions($scope) {
    const $root = $scope && $scope.length ? $scope : $(".main-product__size-option");
    $root
      .find(".cw-product-bundle__variant-option")
      .not(".cw-product-bundle__variant-option--custom-size")
      .each(function () {
        const $option = $(this);
        const label = formatStandardSizeLabel($option.attr("data-text"));
        if (!label) return;
        const $text = $option.find(".cw-product-bundle__option-text").first();
        if ($text.length) $text.text(label);
        $option.attr("data-display-text", label);
      });
  }

  /* Size mode: "custom" (typing collapses the standard list to a switch-row),
     "standard" (a picked size collapses the custom panel), or "" (both show). */
  function setSizeMode(mode) {
    const $sizeOption = $(".main-product__size-option");
    const previous = $sizeOption.hasClass("lmw-mode-custom")
      ? "custom"
      : $sizeOption.hasClass("lmw-mode-standard")
      ? "standard"
      : "";
    $sizeOption
      .removeClass("lmw-mode-custom lmw-mode-standard")
      .addClass(mode === "custom" ? "lmw-mode-custom" : mode === "standard" ? "lmw-mode-standard" : "");
    if (mode && mode !== previous) lmwTrack("lm_size_mode", { lm_mode: mode });
  }

  function ensureCustomSizeActive() {
    const $hero = $(".main-product__size-option .cw-product-bundle__variant-option--custom-size").first();
    if ($hero.length && !$hero.hasClass("active-status")) {
      $hero.trigger("click");
    }
  }

  function roundToOneDecimal(value) {
    return Math.round(value * 10) / 10;
  }

  /* Mat diagram: drawn to the entered aspect ratio (width ≤ 200, height ≤ 180,
     min width 110, ratio clamped 0.25–4), 7px dark border for a bordered mat,
     none for a recess. Numbers straight from the prototype. */
  function drawSizeDiagram() {
    const $diagram = $("[data-lmw-diagram]");
    if (!$diagram.length || $diagram.prop("hidden")) return;
    const widthValue = parseFloat($('input[name="width"]').val());
    const lengthValue = parseFloat($('input[name="length"]').val());
    const portrait = safeTrim($('input[name="select-orientation"]:checked').val()) === "portrait";
    let bw = portrait ? 120 : 200;
    let bh = portrait ? 180 : 128;
    if (widthValue > 0 && lengthValue > 0) {
      const ratio = Math.min(4, Math.max(0.25, widthValue / lengthValue));
      const k = Math.min(200 / widthValue, 180 / lengthValue);
      bw = Math.max(110, Math.min(200, widthValue * k));
      bh = Math.max(56, Math.min(180, bw / ratio));
      if (bh > 180) {
        bh = 180;
        bw = Math.max(110, bh * ratio);
      }
    }
    $diagram
      .find("[data-lmw-diagram-mat]")
      .css({ width: Math.round(bw) + "px", height: Math.round(bh) + "px" })
      .toggleClass("lmw-diagram__mat--borderless", isMatwellLocationSelected());
    $diagram.find("[data-lmw-diagram-aline]").css({ width: Math.round(bw) + "px" });
    /* The A label/line column must be exactly the mat's width, otherwise its
       min-width centres the line on a wider box and it sits off the mat
       (visible after an orientation switch to portrait — Jack, 23-Sep-2026). */
    $diagram.find(".lmw-diagram__a").css({ width: Math.round(bw) + "px" });
  }

  /* Everything under the two inputs: max attributes, the live error, the
     readout (size + recess made-size + price) and the diagram. Runs on input,
     on orientation/location change and after any mode switch. The price
     comes from `.main-product__price-value`, which customPriceHandler's
     calculatePrice (bound directly on the inputs) has already stamped. */
  function refreshCustomSizeUI() {
    const $width = $('input[name="width"]');
    const $length = $('input[name="length"]');
    if (!$width.length || !$length.length) return;
    const lim = getCustomSizeLimits();
    $width.attr("max", lim.maxW);
    $length.attr("max", lim.maxL);

    const widthValue = parseFloat($width.val());
    const lengthValue = parseFloat($length.val());
    const bothEntered = widthValue > 0 && lengthValue > 0;
    const error = getCustomSizeError(widthValue, lengthValue);
    setCustomSizeError(error);
    const valid = bothEntered && !error;

    const $calc = $("[data-lmw-custom-calc]");
    if ($calc.length) {
      if (valid) {
        $("[data-lmw-readout-size]").text(`${widthValue} × ${lengthValue} cm`);
        const $made = $("[data-lmw-readout-made]");
        if (lim.recess) {
          $made
            .text(
              `Made ${roundToOneDecimal(widthValue + MATWELL_TRIM_ALLOWANCE_CM)} × ${roundToOneDecimal(lengthValue + MATWELL_TRIM_ALLOWANCE_CM)} cm so it can be trimmed to fit`
            )
            .prop("hidden", false);
        } else {
          $made.text("").prop("hidden", true);
        }
        $calc.prop("hidden", false);
      } else {
        $calc.prop("hidden", true);
      }
    }

    const $priceCell = $("[data-lmw-custom-price]");
    if ($priceCell.length) {
      const $priceSrc = $(".main-product__price-value").first();
      const exPrice = $priceSrc.attr("data-ex-price");
      const incPrice = $priceSrc.attr("data-inc-price");
      if (valid && exPrice && incPrice) {
        const isInc = window.fmVatMode === "inc";
        $priceCell
          .find("[data-lmw-custom-price-value]")
          .attr("data-ex-price", exPrice)
          .attr("data-inc-price", incPrice)
          .text(isInc ? incPrice : exPrice);
        $priceCell.prop("hidden", false);
      } else {
        $priceCell.prop("hidden", true);
      }
    }

    drawSizeDiagram();
  }

  /* Typing makes custom the active mode (and selects the hidden custom tile so
     pricing/payload treat it as the chosen size). */
  $(document).on("input", 'input[name="width"], input[name="length"]', function () {
    const anyValue =
      safeTrim($('input[name="width"]').val()) !== "" ||
      safeTrim($('input[name="length"]').val()) !== "";
    if (anyValue) {
      ensureCustomSizeActive();
      setSizeMode("custom");
    }
    refreshCustomSizeUI();
  });
  /* The diagram opens below the inputs on focus (never above, so the fields
     don't jump), and the mouse wheel must not nudge a typed number. */
  $(document).on("focusin", 'input[name="width"], input[name="length"]', function () {
    $("[data-lmw-diagram]").prop("hidden", false);
    drawSizeDiagram();
  });
  $(document).on("wheel", 'input[name="width"], input[name="length"]', function () {
    this.blur();
  });
  /* Picking a standard size: the selection engine already clears the two
     inputs; collapse the custom panel and close the diagram. */
  $(document).on(
    "click",
    ".main-product__size-option .cw-product-bundle__variant-option:not(.cw-product-bundle__variant-option--custom-size)",
    function () {
      setSizeMode("standard");
      $("[data-lmw-diagram]").prop("hidden", true);
      refreshCustomSizeUI();
    }
  );
  /* Dashed switch-rows: clear the other selection and show both blocks again. */
  /* A hidden ("extra") size that becomes the active one opens the list. */
  $(document).on(
    "click",
    ".main-product__size-option .cw-product-bundle__variant-option--extra",
    function () {
      setSizeListCollapsed($(this).closest(".cw-product-bundle__variant-options"), false);
    }
  );

  $(document).on("click", ".lmw-switch-row", function () {
    const target = safeTrim($(this).attr("data-lmw-switch"));
    resetSizeSelectToPlaceholder(getPrimarySizeSelect());
    $('input[name="width"], input[name="length"]').val("");
    $(".main-product__size-option .cw-product-bundle__variant-price").show();
    setSizeMode("");
    $("[data-lmw-diagram]").prop("hidden", true);
    refreshCustomSizeUI();
    if (logoWizardState.enabled) {
      showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
    }
    if (target === "custom") {
      $('input[name="width"]').trigger("focus");
    }
  });
  /* Orientation drives the label order of the standard sizes and, when both
     custom measurements are in and disagree with it, swaps them. */
  $(document).on("change", 'input[name="select-orientation"]', function () {
    const $width = $('input[name="width"]');
    const $length = $('input[name="length"]');
    const widthValue = parseFloat($width.val());
    const lengthValue = parseFloat($length.val());
    const portrait = $(this).val() === "portrait";
    if (
      widthValue > 0 &&
      lengthValue > 0 &&
      ((!portrait && widthValue < lengthValue) || (portrait && widthValue > lengthValue))
    ) {
      $width.val(lengthValue);
      $length.val(widthValue);
      $width.trigger("input");
      $length.trigger("input");
    }
    relabelStandardSizeOptions();
    refreshCustomSizeUI();
  });

  /* Expander toggle for the collapsed "extra" sizes. Delegated on document;
     stopPropagation so the click never reaches the size selection/close
     handlers. */
  $(document).on("click", ".cw-product-bundle__size-expander", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $btn = $(this);
    const $list = $btn.closest(".cw-product-bundle__variant-options");
    const isCollapsed = $list.toggleClass("is-collapsed").hasClass("is-collapsed");
    $btn.attr("aria-expanded", isCollapsed ? "false" : "true");
    $btn.find(".cw-product-bundle__size-expander-sign").text(isCollapsed ? "+" : "–");
    $btn
      .find(".cw-product-bundle__size-expander-label")
      .text(isCollapsed ? "Show smaller & larger sizes" : "Hide extra sizes");
  });

  /* The "Your size" readout + inline price cell used to be a delegated input
     handler here (03-Jul / 15-Jul-2026). Superseded by refreshCustomSizeUI()
     above in the v3 rebuild (23-Sep-2026). */

  decorateSizeOptionsForWizard();

  function OptionsHandler(ele) {
    // console.log("main ele", ele, $(ele).html());
    let selectedText = $(ele).attr("data-text") || "";
    let displaySelectedText = selectedText;
    
    let selectedVariantID = Number($(ele).attr("data-variant-id"));

    if ($(".main-product__checkout-button").length > 0) {
      $(".main-product__checkout-button").attr(
        "data-variant-id",
        selectedVariantID
      );
    }

    let selectedSavePercentage = $(ele).attr("data-save-percentage") || "";
    // VAT-toggle aware (08-Jun-2026): each size option carries both the
    // ex (`data-price`) and inc (`data-price-inc`) money strings. Pick
    // the one matching the current display mode, but keep BOTH so the
    // display elements can be re-swapped if the user toggles afterward.
    let fmIncMode = (window.fmVatMode === "inc");
    let selectedPrice_ex  = $(ele).attr("data-price") || "";
    let selectedPrice_inc = $(ele).attr("data-price-inc") || selectedPrice_ex;
    let selectedPrice_02  = fmIncMode ? selectedPrice_inc : selectedPrice_ex;

    let dataWithoutMoneyPrice = $(ele).attr("data-without-monny-formate") || "";
    let selectedValue = $(ele).text();
    const isSizeDropdownOption =
      $(ele).closest(".main-product__size-option").length > 0;
    console.log('dataWithoutMoneyPrice ' + dataWithoutMoneyPrice);
    //let qtyDropText = $(".main-product__quantity-option").find(".cw-product-bundle__variant-option").first().data('text');
    let qtyDropText = $(".main-product__quantity-option")
      .find(".cw-product-bundle__variant-option.active-status")
      .data("text");

    // set first option text in qty selector
    $(".main-product__quantity-option")
      .find(
        ".cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
      )
      .text(qtyDropText);

    // set main price — write to the dedicated `.main-product__price-value`
    // span (the redesigned hero price block has 3 sibling spans:
    // label, value, vat-suffix). The old selector `.main-product__price span`
    // hit all three, replacing label + suffix with the price value.
    // Write the mode-appropriate price + refresh BOTH data attributes so
    // a later VAT toggle re-swaps correctly. The vat-suffix label
    // (.main-product__price-vat / .fm-vat-label) is handled by fm-vat.js.
    $(".main-product__price-value")
      .attr("data-ex-price", selectedPrice_ex)
      .attr("data-inc-price", selectedPrice_inc)
      .text(selectedPrice_02);

    let selectedHtml = "";

    if (isSizeDropdownOption && isCustomOptionElement($(ele))) {
      displaySelectedText = getCustomSizeDisplayText();
    }

    if (displaySelectedText) {
      selectedHtml += `<span class="cw-product-bundle__variant-text">${displaySelectedText}</span>`;
    }
    if (selectedSavePercentage) {
      selectedHtml += `<span class="cw-product-bundle__variant-save-percentage ddddd">${selectedSavePercentage}</span>`;
    }
    if (selectedPrice_02) {
      selectedHtml += `<span class="cw-product-bundle__variant-price" data-ex-price="${selectedPrice_ex}" data-inc-price="${selectedPrice_inc}" data-without-money-total="${dataWithoutMoneyPrice}" data-total-price="${selectedPrice_02}">${selectedPrice_02}</span>`;
    }

    if (isSizeDropdownOption && isCustomOptionElement($(ele))) {
      selectedValue = displaySelectedText;
    }

    $(ele)
      .closest(".cw-product-bundle__variant-select")
      .find(".cw-product-bundle__variant-selected")
      .html(selectedHtml);
    $(ele)
      .closest(".cw-product-bundle__variant-select")
      .find('input[type="hidden"]')
      .val(selectedValue);

    if (isSizeDropdownOption) {
      const $sizeVariantSelect = $(ele).closest(".cw-product-bundle__variant-select");
      const isCustomSizeOptionSelected = isCustomOptionElement($(ele));
      $(ele)
        .closest(".cw-product-bundle__variant-options")
        .find(".cw-product-bundle__variant-option")
        .removeClass("active-status");
      $(ele).addClass("active-status");
      $sizeVariantSelect.attr(
        "data-selected-variant-id",
        safeTrim($(ele).attr("data-variant-id"))
      );
      $sizeVariantSelect.attr("data-selected-option-text", safeTrim(displaySelectedText));
      $sizeVariantSelect.attr("data-selected-option-raw-text", safeTrim(selectedText));
      $sizeVariantSelect.attr(
        "data-selected-is-custom-size",
        isCustomSizeOptionSelected ? "true" : "false"
      );
      $sizeVariantSelect.toggleClass(
        "is-custom-size-selected",
        isCustomSizeOptionSelected
      );
      $sizeVariantSelect.removeClass("is-open");
      $sizeVariantSelect.find(".cw-product-bundle__variant-options").hide();
      updateCustomSizeLabels();
    } else {
      $(ele).parent().hide();
    }

    let selected_variant_option_price = parseFloat(
      $(ele).attr("data-variant-price")
    );
    if (
      !isNaN(selected_variant_option_price) &&
      selected_variant_option_price > 0
    ) {
      //   const tenPercent = (selected_variant_option_price * 1 / 100);
      const tenPercent_1 = selected_variant_option_price;

      const fifteenPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="2"]'
      ).attr("data-save-percentage");
      const fifteenPercentFormate = fifteenPercentage.replace("%", "");
      const fifteenPercent =
        (selected_variant_option_price * fifteenPercentFormate) / 100;
      const fifteenPercent_1 = selected_variant_option_price - fifteenPercent;

      const twentyPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="3"]'
      ).attr("data-save-percentage");
      const twentyPercentFormate = twentyPercentage.replace("%", "");
      const twentyPercent =
        (selected_variant_option_price * twentyPercentFormate) / 100;
      const twentyPercent_1 = selected_variant_option_price - twentyPercent;

      const thirtyPercentage = $(
        '.cw-product-bundle__variant-option[data-selected-qty="4"]'
      ).attr("data-save-percentage");
      const thirtyPercentFormate = thirtyPercentage.replace("%", "");
      const thirtyPercent =
        (selected_variant_option_price * thirtyPercentFormate) / 100;
      const thirtyPercent_1 = selected_variant_option_price - thirtyPercent;

      // let percentage_off = $(".main-product__quantity-option")
      //   .find(".cw-product-bundle__variant-save-percentage")
      //   .html();
      let percentage_off = $(".main-product__quantity-option")
        .find(".cw-product-bundle__variant-save-percentage")
        .text()
        .replace("Save", "")
        .trim();

      // if (percentage_off == "20%") {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(twentyPercent_1));
      // } else if (percentage_off == "15%") {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(fifteenPercent_1));
      // } else {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(tenPercent_1));
      // }

      // if (percentage_off == twentyPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(twentyPercent_1));
      // } else if (percentage_off == fifteenPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(fifteenPercent_1));
      // } else if (percentage_off == thirtyPercentage) {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(thirtyPercent_1));
      // } else {
      //   $(".main-product__quantity-option")
      //     .find(".cw-product-bundle__variant-price")
      //     .html(Shopify.formatMoney(tenPercent_1));
      // }

      if (percentage_off == thirtyPercent_1) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(thirtyPercent_1));
      } else if (percentage_off == twentyPercentage) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(twentyPercent_1));
      } else if (percentage_off == fifteenPercentage) {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(fifteenPercent_1));
      } else {
        $(".main-product__quantity-option")
          .find(".cw-product-bundle__variant-price")
          .html(Shopify.formatMoney(tenPercent_1));
      }

      $('.cw-product-bundle__variant-option[data-selected-qty="4"]').attr(
        "data-price",
        Shopify.formatMoney(thirtyPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="4"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(thirtyPercent_1));

      $('.cw-product-bundle__variant-option[data-selected-qty="3"]').attr(
        "data-price",
        Shopify.formatMoney(twentyPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="3"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(twentyPercent_1));

      $('.cw-product-bundle__variant-option[data-selected-qty="2"]').attr(
        "data-price",
        Shopify.formatMoney(fifteenPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="2"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(fifteenPercent_1));
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]').attr(
        "data-price",
        Shopify.formatMoney(tenPercent_1)
      );
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .find(".cw-product-bundle__option-price")
        .html(Shopify.formatMoney(tenPercent_1));
      // console.log("data234");

      let UpdatedSizePrice = $(
        ".main-product__select-dropdown.main-product__quantity-option"
      )
        .find(".cw-product-bundle__variant-option.active-status")
        .attr("data-price");
      $(".main-product__select-dropdown.main-product__quantity-option")
        .find(
          ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
        )
        .text(UpdatedSizePrice);
    }

    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    // Detect the custom-size selection via the option's data-text (stable —
    // "Custom Size (Click to enter size)") rather than the visible label, which
    // the wizard now rewrites to "Need a different size?" (no "custom" in it).
    // Legacy text check kept as a fallback.
    var $primarySizeSelect = $(
      ".main-product__size-option .cw-product-bundle__variant-select"
    ).first();
    var eleDataText = String($(ele).attr("data-text") || "").toLowerCase();
    var isCustomSizeSelected =
      eleDataText.indexOf("custom") > -1 ||
      isCustomSelectionForSizeSelect($primarySizeSelect) ||
      (selected_size_dropdown &&
        selected_size_dropdown.toLowerCase().indexOf("custom") > -1);
    if (isCustomSizeSelected) {
      $(".custom-width-input-field").show();

      $(".cw-product-bundle__variant-price").hide();
      // custom code
      // console.log("custom option", $(this).html());
      customPriceHandler(this);
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .show()
        .addClass("active-status")
        .trigger("click");
      $(
        '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
      )
        .hide()
        .removeClass("active-status");
      $(".cw-product-bundle__variant-price").hide();
      updateCustomSizeLabels();
    } else {
      $(".custom-width-input-field").hide();
      $(".cw-product-bundle__variant-price").show();
      $('input[name="width"]').val("");
      $('input[name="length"]').val("");
      $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
        .show()
        .addClass("active-status")
        .trigger("click");
      $(
        '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
      )
        .show()
        .removeClass("active-status");
      updateCustomSizeLabels();
    }

    var selected_size_dropdown = $(
      ".main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
    ).text();
    $(`[value="${selected_size_dropdown}"]`).prop("checked", true);
  }

  $(document).on("click", ".cw-product-bundle__variant-selected", function (event) {
    event.preventDefault();
    const $selected = $(this);
    const $currentSelect = $selected.closest(".cw-product-bundle__variant-select");
    const $currentOptions = $selected.siblings(".cw-product-bundle__variant-options");
    const isSizeDropdown = $selected.closest(".main-product__size-option").length > 0;

    if (isSizeDropdown) {
      const shouldOpen = !$currentSelect.hasClass("is-open");
      $(".main-product__size-option .cw-product-bundle__variant-select")
        .not($currentSelect)
        .removeClass("is-open")
        .find(".cw-product-bundle__variant-options")
        .hide();

      $(".cw-product-bundle__variant-options").not($currentOptions).hide();

      if (shouldOpen) {
        $currentSelect.addClass("is-open");
        $currentOptions.show();
      } else {
        $currentSelect.removeClass("is-open");
        $currentOptions.hide();
      }
      return;
    }

    $(".main-product__size-option .cw-product-bundle__variant-select").removeClass(
      "is-open"
    );
    $(".cw-product-bundle__variant-options").not($currentOptions).hide();
    $currentOptions.toggle();

    // custom code
    // if ($(this).find('.cw-product-bundle__variant-text').text().includes("Custom Size")) {
    //     console.log("custom");
    // } else {
    //     console.log("normal");
    // }
  });

  $(document).on(
    "click",
    ".main-product__size-option .cw-product-bundle__variant-option",
    function () {
      OptionsHandler(this);
   
    }
  );

  $('.main-product__right input[name="color-swatch"]').on(
    "change",
    function () {
      var selectedColorValue = $(
        '.main-product__right input[name="color-swatch"]:checked'
      ).val();
      $(`input[value="${selectedColorValue}"]`).prop("checked", true);
    }
  );

  $(document).on(
    "click",
    ".main-product__quantity-option .cw-product-bundle__variant-option",
    function () {
      $(
        ".main-product__quantity-option .cw-product-bundle__variant-option"
      ).removeClass("active-status");
      $(this).addClass("active-status");
     
      let selectedText = $(this).attr("data-text") || "";
      let selectedSavePercentage = $(this).attr("data-save-percentage") || "";
      let selectedPrice_03 = $(this).attr("data-price") || "";
      let selectedValue = $(this).text();
      let selectedHtml = "";
      let currentClickQty = $(this).attr("data-selected-qty");
      let fourPlusQty = $("#fourplusqty").val();
      let changeQty = $(
        ".main-product__quantity-option .cw-product-bundle__variant-selected"
      );
      if (changeQty) {
        if (selectedText == "4+ Qty") {
          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentqty", fourPlusQty);
        } else {
          $(
            ".main-product__quantity-option .cw-product-bundle__variant-selected"
          ).attr("currentqty", currentClickQty);
        }
        //$('.main-product__quantity-option .cw-product-bundle__variant-selected').attr('currentqty', currentClickQty);
      }

      if (selectedText) {
        selectedHtml += `<span class="cw-product-bundle__variant-text">${selectedText}</span>`;
      }
      if (selectedSavePercentage) {
        selectedHtml += `<span class="cw-product-bundle__variant-save-percentage qqqqq">Save ${selectedSavePercentage}</span>`;
      }
      if (selectedPrice_03) {
        selectedHtml += `<span class="cw-product-bundle__variant-price">${selectedPrice_03}</span>`;
      }
      $(this)
        .closest(".cw-product-bundle__variant-select")
        .find(".cw-product-bundle__variant-selected")
        .html(selectedHtml);
      $(this)
        .closest(".cw-product-bundle__variant-select")
        .find('input[type="hidden"]')
        .val(selectedValue);

      $(this).parent().hide();
      if (selectedText == "4+ Qty") {
        $(".custom-width-input-field--qty").show();
      } else {
        $(".custom-width-input-field--qty").hide();
      }
      // console.log("data456");
      document.querySelector(".main-product__price-value").textContent =
        selectedPrice_03;
    }
  );

  $(document).on("click", function (e) {
    if (!$(e.target).closest(".cw-product-bundle__variant-select").length) {
      $(".cw-product-bundle__variant-options").hide();
      $(".main-product__size-option .cw-product-bundle__variant-select").removeClass(
        "is-open"
      );
    }
  });

  // Guard added 01-Jul-2026: Fancybox is loaded by eq-plugins.js on standard
  // templates but not on the lean lm-social LP layout. Calling Fancybox.bind
  // unguarded threw a ReferenceError here, which aborted the rest of this
  // $(document).ready handler — including initLogoWizard() below — so the
  // wizard never received .is-wizard-ready and the funnel was stuck on step 1.
  if (typeof Fancybox !== "undefined") {
    Fancybox.bind("[data-fancybox]", {
      showClass: "checkout-form-popup",
    });
  }

  let trustedLogo = $(".trusted-logo__slider");

  if (trustedLogo.length > 0 && !trustedLogo.hasClass("slick-initialized")) {
    trustedLogo.slick({
      dots: false,
      arrows: false,
      slidesToShow: 5,
      infinite: true,
      lazyLoad: "progressive",
      speed: 3000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipeToSlide: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            speed: 8000,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            speed: 3000,
          },
        },
      ],
    });
  }

  if ($(".ideal-step .ideal-step__block-title").length > 0) {
    $(".ideal-step .ideal-step__block-title").matchHeight({
      byRow: true,
    });
  }

  initLogoWizard();
  updateMatwellDependentUI();
  $(document).on("change", 'input[name="select-backing"]', function () {
    updateMatwellDependentUI();
  });

  let formButton = $(".secure-checkout__form .secure-checkout__button");
  let isCheckoutSubmitting = false;
  const defaultSubmitButtonText = safeTrim(formButton.first().text()) || "Submit";
  const checkoutSubmitLoadingText = "Please Wait, Generating Design";
  let phoneNumberField = document.querySelector(
    ".secure-checkout__fill-data .secure-checkout__field input[type='tel']"
  );
  let iti;

  let phoneNumberInput = document.querySelector("#phone");
  let errorMsg = document.querySelector("#phoneError");
  let validMsg = document.querySelector("#validMsg");

  // Error messages mapped to error codes
  let errorMap = [
    "Please check the phone number.",
    "Please check the country code.",
    "That number looks too short.",
    "That number looks too long.",
    "Please check the phone number.",
  ];

  function reset() {
    if (phoneNumberInput && errorMsg && validMsg) {
      phoneNumberInput.classList.remove("invalid");
      errorMsg.textContent = "";
      errorMsg.style.display = "none";
      validMsg.classList.add("hide");
    } else {
      console.log("Required elements not found");
    }
  }

  let showError = (msg) => {
    phoneNumberInput.classList.add("invalid");
    errorMsg.textContent = msg;
    errorMsg.style.display = "block";
  };

  // Approved loading-screen copy (Instant AI Proof developer pack §5, verbatim).
  const checkoutStageLines = [
    "Reading your logo…",
    "Matching your colours to mat fibres…",
    "Weaving it into the mat pile…",
    "Placing it in your entrance…",
  ];
  const checkoutLongWaitLine =
    "Taking longer than usual — your proof will land by email in a few minutes. Your price is locked in.";
  /* Shown for the moment between a confirmed proof and the redirect to it. */
  const checkoutProofReadyLine = "Your proof is ready — opening it now…";
  const checkoutFacts = [
    "We colour-match to your exact HEX code — your brand book's colour, not the nearest stock shade.",
    "Rubber edges come as standard on every logo mat.",
    /* "Current lead time: 5–7 working days…" removed 23-Sep-2026 (Jack) — the
       figure was stale and a delivery promise doesn't belong on the proof
       loading screen. */
    "Prefer a round one? Circular logo mats run from 85cm to 150cm across.",
    "Chosen for nationwide roll-outs — built for entrances that see thousands of feet a day.",
    "Unlimited free revisions — nothing prints until you're happy with the proof.",
    "Sending direct to your customer? We can deliver unbranded, with no price paperwork inside.",
    "Every order carries a 100% satisfaction guarantee — if it isn't right, we make it right.",
  ];
  let checkoutLoaderTimers = [];

  function stopCheckoutLoaderCopy() {
    checkoutLoaderTimers.forEach(function (timerId) {
      clearTimeout(timerId);
    });
    checkoutLoaderTimers = [];
  }

  /* Stage lines rotate in order every 2.6s (looping); facts rotate every 3.5s
     from a shuffled start point. Two separate late-stage timers, split apart on
     17-Sep-2026 when the client timeout went to 95s: at 40s the "about 30
     seconds" hint is dropped, and only at 70s does the stage line swap to the
     long-wait message. They used to fire together at 35s, which is now inside
     the normal slow path (~63s) and would promise an email while the proof was
     still on its way to the page. */
  function startCheckoutLoaderCopy($forms) {
    stopCheckoutLoaderCopy();
    /* The overlay's stage/fact lines are written alongside the inline ones, so
       this one rotation drives both surfaces (28-Jul-2026). */
    const $stage = $forms
      .find(".secure-checkout__progress-text")
      .add($(".lmw-proof-overlay__stage"));
    const $fact = $forms
      .find(".secure-checkout__progress-fact")
      .add($(".lmw-proof-overlay__fact"));
    let stageIndex = 0;
    let factIndex = Math.floor(Math.random() * checkoutFacts.length);
    let longWait = false;
    $stage.text(checkoutStageLines[0]);
    $fact.text(checkoutFacts[factIndex]);

    const rotateStage = function () {
      if (!longWait) {
        stageIndex = (stageIndex + 1) % checkoutStageLines.length;
        $stage.text(checkoutStageLines[stageIndex]);
      }
      checkoutLoaderTimers.push(setTimeout(rotateStage, 2600));
    };
    const rotateFact = function () {
      factIndex = (factIndex + 1) % checkoutFacts.length;
      $fact.text(checkoutFacts[factIndex]);
      checkoutLoaderTimers.push(setTimeout(rotateFact, 3500));
    };
    checkoutLoaderTimers.push(setTimeout(rotateStage, 2600));
    checkoutLoaderTimers.push(setTimeout(rotateFact, 3500));
    /* 40s: drop the overlay's "about 30 seconds" hint. It is plainly wrong by
       now, but the proof is still coming, so the stage lines keep rotating and
       nothing is promised by email yet. `is-long-wait` only hides the hint
       (eq-product-style.css) — it does not change any other copy. */
    checkoutLoaderTimers.push(
      setTimeout(function () {
        $(".lmw-proof-overlay").addClass("is-long-wait");
      }, 40000)
    );
    /* 70s: past the measured worst case (~63s: two sequential renders plus our
       compose), so a request still open here is genuinely abnormal. Freeze the
       stage rotation and switch to the long-wait line, leaving 25s before the
       client gives up at 95s. */
    checkoutLoaderTimers.push(
      setTimeout(function () {
        longWait = true;
        $stage.text(checkoutLongWaitLine);
      }, 70000)
    );
  }

  function ensureCheckoutProgressUI() {
    $(".secure-checkout__form .secure-checkout__submit").each(function () {
      const $submitWrap = $(this);
      if ($submitWrap.find(".secure-checkout__progress").length > 0) {
        return;
      }

      $submitWrap.append(
        `<div class="secure-checkout__progress" role="status" aria-live="polite">
          <div class="secure-checkout__progress-track" aria-hidden="true">
            <div class="secure-checkout__progress-bar"></div>
          </div>
          <p class="secure-checkout__progress-text">${checkoutSubmitLoadingText}</p>
          <p class="secure-checkout__progress-fact" style="margin:4px 0 0;font-size:12px;opacity:.8;"></p>
        </div>`
      );
    });
  }

  ensureCheckoutProgressUI();

  /* =====================================================================
     PROOF-GENERATION OVERLAY (28-Jul-2026)
     ---------------------------------------------------------------------
     While ProofCreate runs, the inline progress line under the button was
     easy to miss and left the form looking idle for up to a minute. This
     overlays the whole window with a determinate ring + percentage so it
     always reads as "something is happening, wait".

     The percentage is driven by REAL elapsed time, not fake steps, and is
     deliberately capped below 100 until the response actually lands:
       0 → 30s   climbs to 90%   (where a single-render proof finishes)
       30 → 90s  creeps 90 → 99% (the server's whole-request budget)
       beyond    holds at 99%    (client gives up at 95s — see
                                  INSTANT_PROOF_CLIENT_TIMEOUT_MS)
     100% is only ever shown on a confirmed success, immediately before the
     redirect to the proof.

     TARGET_PCT was 95 until 17-Sep-2026. Against the 90s ceiling that left only
     4 points to spread over a full minute — the number moved once every ~15s,
     which on the slow path reads as a frozen ring, the exact failure this
     overlay exists to prevent. 90 leaves 9 points over the same span (~1 per
     6.7s) so it is always visibly climbing. The fast path just shows 90 instead
     of 95 for the instant before a confirmed success snaps it to 100.

     CEILING_MS tracks the server whole-request budget, NOT the client timeout,
     so the ring is still visibly creeping for the whole time a proof can
     plausibly still arrive, and only flatlines in the last few seconds before
     the client gives up. Left at 60s against a 95s client timeout it would sit
     frozen at 99% for 35 seconds and read as a hung page. (17-Sep-2026.)

     Appended to <body>, not inside the wizard: the modal card sets a
     `transform`, which would make it the containing block for a fixed
     child and clip it against `overflow: hidden`.

     The rotating stage lines and facts are NOT reimplemented here — the
     overlay carries mirror nodes that startCheckoutLoaderCopy writes to
     alongside the originals, so the approved copy (and the late-stage long-wait
     swap) keeps working untouched.
     ===================================================================== */
  const PROOF_OVERLAY_TARGET_MS = 30000;
  const PROOF_OVERLAY_TARGET_PCT = 90;
  const PROOF_OVERLAY_CEILING_MS = 90000;
  const PROOF_OVERLAY_CEILING_PCT = 99;
  const PROOF_OVERLAY_RING_RADIUS = 52;
  const PROOF_OVERLAY_RING_LENGTH = 2 * Math.PI * PROOF_OVERLAY_RING_RADIUS;
  let proofOverlayTimer = null;
  let proofOverlayStartedAt = 0;

  function ensureProofOverlayUI() {
    let $overlay = $(".lmw-proof-overlay");
    if ($overlay.length > 0) {
      return $overlay;
    }
    /* `hidden` matters: eq-product-script.js loads on EVERY page but
       eq-product-style.css is gated to product templates (theme.liquid), so
       the CSS that hides this cannot be relied on. The attribute makes the
       UA stylesheet hide it even with zero CSS — without it the card renders
       as raw content below the footer site-wide. (Fixed 29-Jul-2026.) */
    $overlay = $(
      `<div class="lmw-proof-overlay" hidden aria-hidden="true">
        <div class="lmw-proof-overlay__card">
          <div class="lmw-proof-overlay__ring" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-label="Generating your proof">
            <svg viewBox="0 0 120 120" aria-hidden="true">
              <circle class="lmw-proof-overlay__ring-track" cx="60" cy="60" r="${PROOF_OVERLAY_RING_RADIUS}"></circle>
              <circle class="lmw-proof-overlay__ring-fill" cx="60" cy="60" r="${PROOF_OVERLAY_RING_RADIUS}"></circle>
            </svg>
            <span class="lmw-proof-overlay__pct" aria-hidden="true"><strong class="lmw-proof-overlay__pct-value">0</strong>%</span>
          </div>
          <p class="lmw-proof-overlay__title">Generating your proof</p>
          <p class="lmw-proof-overlay__stage" role="status" aria-live="polite"></p>
          <p class="lmw-proof-overlay__hint">This usually takes about 30 seconds — please keep this window open.</p>
          <p class="lmw-proof-overlay__fact"></p>
        </div>
      </div>`
    );
    $overlay
      .find(".lmw-proof-overlay__ring-fill")
      .css({
        strokeDasharray: PROOF_OVERLAY_RING_LENGTH,
        strokeDashoffset: PROOF_OVERLAY_RING_LENGTH,
      });
    $(document.body).append($overlay);
    return $overlay;
  }

  /* Built up front so the copy rotation always has nodes to write to,
     whatever order the submit path calls things in — but only where there is
     actually a wizard to submit. This script loads site-wide, and a stray
     overlay node on the homepage/collections is exactly the bug fixed on
     29-Jul-2026. startProofOverlay() also builds it on demand, so gating
     here costs nothing. */
  if (formButton.length > 0) {
    ensureProofOverlayUI();
  }

  function proofOverlayPercentFor(elapsedMs) {
    if (elapsedMs <= 0) {
      return 0;
    }
    if (elapsedMs < PROOF_OVERLAY_TARGET_MS) {
      return (elapsedMs / PROOF_OVERLAY_TARGET_MS) * PROOF_OVERLAY_TARGET_PCT;
    }
    if (elapsedMs < PROOF_OVERLAY_CEILING_MS) {
      const spanMs = PROOF_OVERLAY_CEILING_MS - PROOF_OVERLAY_TARGET_MS;
      const spanPct = PROOF_OVERLAY_CEILING_PCT - PROOF_OVERLAY_TARGET_PCT;
      return (
        PROOF_OVERLAY_TARGET_PCT +
        ((elapsedMs - PROOF_OVERLAY_TARGET_MS) / spanMs) * spanPct
      );
    }
    return PROOF_OVERLAY_CEILING_PCT;
  }

  function renderProofOverlayPercent(percent) {
    const $overlay = $(".lmw-proof-overlay");
    if ($overlay.length === 0) {
      return;
    }
    const clamped = Math.max(0, Math.min(100, Math.round(percent)));
    $overlay.find(".lmw-proof-overlay__pct-value").text(clamped);
    $overlay.find(".lmw-proof-overlay__ring").attr("aria-valuenow", clamped);
    $overlay
      .find(".lmw-proof-overlay__ring-fill")
      .css(
        "stroke-dashoffset",
        PROOF_OVERLAY_RING_LENGTH * (1 - clamped / 100)
      );
  }

  function startProofOverlay() {
    const $overlay = ensureProofOverlayUI();
    if (proofOverlayTimer) {
      clearInterval(proofOverlayTimer);
    }
    proofOverlayStartedAt = new Date().getTime();
    $overlay.removeClass("is-long-wait is-complete").addClass("is-visible");
    $overlay.removeAttr("hidden").attr("aria-hidden", "false");
    renderProofOverlayPercent(0);
    proofOverlayTimer = setInterval(function () {
      renderProofOverlayPercent(
        proofOverlayPercentFor(new Date().getTime() - proofOverlayStartedAt)
      );
    }, 200);
  }

  /* Confirmed success: fill the ring and leave the overlay up — the caller
     redirects to the proof a moment later, so hiding it would flash the
     empty form for no reason. */
  function completeProofOverlay() {
    if (proofOverlayTimer) {
      clearInterval(proofOverlayTimer);
      proofOverlayTimer = null;
    }
    const $overlay = $(".lmw-proof-overlay");
    if ($overlay.length === 0) {
      return;
    }
    $overlay.addClass("is-complete").removeClass("is-long-wait");
    renderProofOverlayPercent(100);
    /* Stop the rotation and close the story off, rather than leaving a
       mid-process line ("Weaving it into the mat pile…") sitting at 100%. */
    stopCheckoutLoaderCopy();
    $(".lmw-proof-overlay__stage, .secure-checkout__progress-text").text(
      checkoutProofReadyLine
    );
  }

  function stopProofOverlay() {
    if (proofOverlayTimer) {
      clearInterval(proofOverlayTimer);
      proofOverlayTimer = null;
    }
    $(".lmw-proof-overlay")
      .removeClass("is-visible is-long-wait is-complete")
      .attr({ hidden: "hidden", "aria-hidden": "true" });
  }

  function setCheckoutSubmitState(isSubmitting, labelText) {
    if (formButton.length === 0) {
      return;
    }

    const $forms = formButton.closest(".secure-checkout__form");
    formButton.prop("disabled", isSubmitting);
    formButton.toggleClass("is-submitting", isSubmitting);
    $forms.toggleClass("is-submitting", isSubmitting);
    if (isSubmitting) {
      /* Overlay first: startCheckoutLoaderCopy captures its stage/fact nodes
         once, so they have to exist before it runs. */
      startProofOverlay();
      startCheckoutLoaderCopy($forms);
    } else {
      stopCheckoutLoaderCopy();
      stopProofOverlay();
      $forms.find(".secure-checkout__progress-text").text(checkoutSubmitLoadingText);
      $forms.find(".secure-checkout__progress-fact").text("");
    }
    formButton.text(isSubmitting ? labelText || checkoutSubmitLoadingText : defaultSubmitButtonText);
    /* Mirror onto the footer proxy (v3, 23-Sep-2026). */
    if (logoWizardState.$generateProxy && logoWizardState.$generateProxy.length) {
      logoWizardState.$generateProxy
        .prop("disabled", isSubmitting)
        .toggleClass("is-submitting", isSubmitting)
        .text(isSubmitting ? "Generating your proof…" : "Generate my instant proof");
    }
  }

  function setInstantProofDebugMessage(_messageText) {
    const $debugEl = $(".secure-checkout__instant-debug");
    if ($debugEl.length === 0) {
      return;
    }
    $debugEl.text("").hide();
  }

  /* ------------------------------------------------------------------
     intl-tel-input — lazy initialisation (06-Aug-2026)

     This used to run on every page load. It should not: the phone field
     lives inside `.logo-mat-wizard__details-step`, which is `display: none`
     until the visitor works through the "Design your custom logo mat"
     wizard. Measured on the logo-mats PDP, the eager call was building a
     244-item country dropdown into a hidden subtree and pulling TWO
     cross-origin resources from jsDelivr — `utils.js` and
     `flags@2x.webp` — before anything had been opened. Lighthouse also
     attributed a 41ms forced reflow to it.

     Because the field is hidden at load, initialising later is not a
     visual change: there is nothing on screen to reflow either way. The
     `.iti` wrapper simply has to exist before the step is revealed, which
     is what the IntersectionObserver below guarantees —
     `assets/eq-product-style.css:1541` (`.secure-checkout__field > .iti`)
     depends on that wrapper.

     Three triggers, deliberately overlapping, because this is the lead
     capture path and a missed init breaks form submission:
       1. IntersectionObserver — fires the moment the hidden step gains a
          box, i.e. before the visitor can interact with it.
       2. focus/pointerdown — backstop if the step is revealed while
          scrolled out of view, so the observer has not fired yet.
       3. ensureIntlTelInput() at the validation site — last line of
          defence, covers autofill and programmatic submits where neither
          of the above ran.

     The old `resetIntlTelInput()` helper was deleted rather than moved:
     it was never called from anywhere, and it referenced an undeclared
     `telInput`, so invoking it would have thrown a ReferenceError.
     ------------------------------------------------------------------ */
  function ensureIntlTelInput() {
    if (iti) return iti;
    if (!phoneNumberField || typeof window.intlTelInput !== "function") return null;
    iti = window.intlTelInput(phoneNumberField, {
      initialCountry: "gb",
      separateDialCode: true,
      formatOnDisplay: true,
      nationalMode: false,
      utilsScript:
        "https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.1/build/js/utils.js",
    });
    return iti;
  }

  if (phoneNumberField) {
    if ("IntersectionObserver" in window) {
      var itiObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            ensureIntlTelInput();
            itiObserver.disconnect();
            break;
          }
        }
      });
      itiObserver.observe(phoneNumberField);
    } else {
      ensureIntlTelInput();
    }
    phoneNumberField.addEventListener("focus", ensureIntlTelInput, { once: true });
    phoneNumberField.addEventListener("pointerdown", ensureIntlTelInput, { once: true });
  }

  // Optional: Reset validation when the input is clicked or when the flag is changed
  // phoneNumberInput.addEventListener('focus', reset);

  $(formButton).click(function (e) {
    e.preventDefault();

    if (isCheckoutSubmitting) {
      return;
    }
   
    var isValid = true;
    // Clear previous error messages and invalid class
    $(".error-message").hide();
    $(".secure-checkout__form input").removeClass("invalid");

    // First Name Validation
    let firstName = $("#firstName").val();
    if (firstName && typeof firstName === "string") {
      firstName = firstName.trim();
      let firstNameValid = /^[\p{L}\p{M} '’.\-]+$/u.test(firstName);
      if (firstNameValid) {
        $("#firstName").removeClass("invalid");
        $("#firstNameError").hide();
      } else {
        isValid = false;
        $("#firstName").addClass("invalid");
        $("#firstNameError")
          .text("First name must contain only letters.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#firstName").addClass("invalid");
      $("#firstNameError")
        .text("First name is required.")
        .css("display", "block");
    }

    // Surname Validation
    let surname = $("#surname").val();
    if (surname && typeof surname === "string") {
      surname = surname.trim();
      let surnameValid = /^[\p{L}\p{M} '’.\-]+$/u.test(surname);
      if (surnameValid) {
        $("#surname").removeClass("invalid");
        $("#surnameError").hide();
      } else {
        isValid = false;
        $("#surname").addClass("invalid");
        $("#surnameError")
          .text("Surname must contain only letters.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#surname").addClass("invalid");
      $("#surnameError").text("Surname is required.").css("display", "block");
    }

    // Company Validation
    let company = $("#company").val();
    if (company && typeof company === "string") {
      company = company.trim();
      let companyValid = /^[^<>\u0000-\u001F\u007F]+$/.test(company);
      if (companyValid) {
        $("#company").removeClass("invalid");
        $("#companyError").hide();
      } else {
        isValid = false;
        $("#company").addClass("invalid");
        $("#companyError").text("Please enter a valid company name.").css("display", "block");
      }
    } else {
      isValid = false;
      $("#company").addClass("invalid");
      $("#companyError")
        .text("Company Name is required.")
        .css("display", "block");
    }

    // Email Validation
    let email = $("#email").val();
    if (email && typeof email === "string") {
      email = email.trim();
      let emailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        email
      );
      if (emailValid) {
        $("#email").removeClass("invalid");
        $("#emailError").hide();
      } else {
        isValid = false;
        $("#email").addClass("invalid");
        $("#emailError")
          .text("Please enter a valid email address.")
          .css("display", "block");
      }
    } else {
      isValid = false;
      $("#email").addClass("invalid");
      $("#emailError")
        .text("Email address is required.")
        .css("display", "block");
    }

    reset();

    let phoneNumber = phoneNumberInput.value;
    let validMsg = document.querySelector("#validMsg");
    if (!phoneNumber || phoneNumber.trim() === "") {
      showError("Phone number is required.");
      isValid = false;
    } else {
      /* intl-tel-input is now initialised lazily (see the note at its
         definition above). By the time a visitor has typed a number the
         observer or the focus handler will have run, but this call is the
         guarantee — autofill and programmatic submits can reach here with
         `iti` still undefined, and `iti.isValidNumber()` would throw and
         silently kill the enquiry submission. */
      var itiInstance = ensureIntlTelInput();
      if (!itiInstance) {
        /* Library genuinely unavailable (blocked/failed request). Accept the
           number rather than blocking a lead on a validation step we cannot
           perform — the server still receives the raw value. */
        validMsg.classList.remove("hide");
        validMsg.textContent = "✓ Valid";
      } else if (itiInstance.isValidNumber()) {
        validMsg.classList.remove("hide");

        validMsg.textContent = "✓ Valid";
      } else {
        /* isValidNumber() is null (not false) while intl-tel-input's utils.js
           — the actual validator, fetched lazily from jsdelivr — has not
           arrived. That happened on the live v3 wizard (23-Sep-2026): a
           perfectly good "7913 919026" was refused as "Invalid number"
           because the customer reached Generate before the script did.
           Without the validator, accept any plausible 10–15 digit number
           rather than block the lead; the server gets the raw value either
           way. */
        const utilsReady =
          !!(window.intlTelInput && window.intlTelInput.utils) ||
          typeof window.intlTelInputUtils !== "undefined";
        const digitCount = String(phoneNumber).replace(/\D/g, "").length;
        if (!utilsReady && digitCount >= 10 && digitCount <= 15) {
          validMsg.classList.remove("hide");
          validMsg.textContent = "✓ Valid";
        } else {
          let errorCode = itiInstance.getValidationError();
          let msg = errorMap[errorCode] || "Please check the phone number.";
          showError(msg);
          isValid = false;
        }
      }
    }

    // If all fields are valid, submit the form
    if (isValid) {
      // Get Number with country code
      // console.log('getNumber ', iti.getNumber() );

      // Remove invalid class and hide error messages for fields that have passed validation
      $(".secure-checkout__field input").each(function () {
        let secureCheckoutInput = $(this);
        if (secureCheckoutInput.val().trim() !== "") {
          secureCheckoutInput.removeClass("invalid");
          secureCheckoutInput.siblings(".error-message").hide();
        }
      });
      // $("form").submit(); // This triggers the form submission

      const designItems = getDesignItemsForSubmission();
      const primaryDesign = designItems[0] || buildCurrentDesignItem();
      const proofMode = designItems.length > 1 ? "manual" : "instant";
      const instantProofEligible = proofMode === "instant" && designItems.length === 1;
      const requiresManualReview = !instantProofEligible;

      let customer_firstname = $("#secure-checkout").find("#firstName").val();
      let customer_surname = $("#secure-checkout").find("#surname").val();
      let customer_email = $("#secure-checkout").find("#email").val();
      let customer_phone = $("#secure-checkout").find("#phone").val();
      /* `iti &&` added 06-Aug-2026. This read `typeof iti.getNumber === "function"`,
         which does NOT guard anything — if `iti` is undefined it throws a
         TypeError before `typeof` is ever evaluated, killing the enquiry
         submission at the point where the payload is assembled. It happened to
         be unreachable while intl-tel-input was initialised eagerly on every
         load (and was already latent on any template with no phone field), but
         initialisation is now lazy, so the guard has to be real. Falls back to
         the raw field value, which is what the server received anyway. */
      const customer_phone_normalized =
        iti && typeof iti.getNumber === "function" ? iti.getNumber() : customer_phone;
      let customer_company = $("#secure-checkout").find("#company").val();

      const productPriceValue = parseCurrencyAmount(primaryDesign.productPrice);
      const discountPercentValue = parsePercentAmount(primaryDesign.discountPercentage);
      const providedDiscountedUnitPriceValue = parseCurrencyAmount(primaryDesign.totalPrice);
      const quantityValue = parseQuantityValue(primaryDesign.quantity);

      const discountedUnitPriceValue =
        providedDiscountedUnitPriceValue !== null
          ? providedDiscountedUnitPriceValue
          : productPriceValue !== null
          ? discountPercentValue !== null
            ? roundToTwo(productPriceValue * (1 - discountPercentValue / 100))
            : roundToTwo(productPriceValue)
          : null;

      const lineTotalValue =
        discountedUnitPriceValue !== null && quantityValue !== null
          ? roundToTwo(discountedUnitPriceValue * quantityValue)
          : null;

      const designItemsObject = designItems.map((item) => {
        const itemProductPriceValue = parseCurrencyAmount(item.productPrice);
        const itemDiscountPercentValue = parsePercentAmount(item.discountPercentage);
        const itemProvidedDiscountedUnitPriceValue = parseCurrencyAmount(item.totalPrice);
        const itemQuantityValue = parseQuantityValue(item.quantity);
        const itemDiscountedUnitPriceValue =
          itemProvidedDiscountedUnitPriceValue !== null
            ? itemProvidedDiscountedUnitPriceValue
            : itemProductPriceValue !== null
            ? itemDiscountPercentValue !== null
              ? roundToTwo(itemProductPriceValue * (1 - itemDiscountPercentValue / 100))
              : roundToTwo(itemProductPriceValue)
            : null;
        const itemLineTotalValue =
          itemDiscountedUnitPriceValue !== null && itemQuantityValue !== null
            ? roundToTwo(itemDiscountedUnitPriceValue * itemQuantityValue)
            : null;

        /* Ex-VAT twins of the three money values above (31-Jul-2026). Same
           maths, but seeded from the display-independent `*Ex` strings, so a
           consumer can price a multi-size design correctly whatever the
           customer was browsing in. */
        const itemProductPriceExValue = parseCurrencyAmount(
          item.productPriceEx || item.productPrice
        );
        const itemDiscountedUnitPriceExValue = (function () {
          const provided = parseCurrencyAmount(item.totalPriceEx);
          if (provided !== null) return provided;
          if (itemProductPriceExValue === null) return null;
          return itemDiscountPercentValue !== null
            ? roundToTwo(itemProductPriceExValue * (1 - itemDiscountPercentValue / 100))
            : roundToTwo(itemProductPriceExValue);
        })();
        const itemLineTotalExValue =
          itemDiscountedUnitPriceExValue !== null && itemQuantityValue !== null
            ? roundToTwo(itemDiscountedUnitPriceExValue * itemQuantityValue)
            : null;

        return {
          ...item,
          quantityValue: itemQuantityValue,
          productPriceValue: itemProductPriceValue,
          discountPercentValue: itemDiscountPercentValue,
          discountedUnitPriceValue: itemDiscountedUnitPriceValue,
          lineTotalValue: itemLineTotalValue,
          productPriceExValue: itemProductPriceExValue,
          discountedUnitPriceExValue: itemDiscountedUnitPriceExValue,
          lineTotalExValue: itemLineTotalExValue,
          sizeType: item.customWidth ? "custom" : "standard",
        };
      });
	
      let customerData = {}; // Initialize the customerData object
      let queryparameters; // Declare queryparameters outside the if block to make it accessible globally

      let currentUrl = window.location.href;
      
      // Check if the URL contains a query string
      if (currentUrl.includes("?")) {
        // Extract query string after '?'
        queryparameters = currentUrl.split("?")[1];
        console.log("queryparameters:", queryparameters);
        sessionStorage.setItem("queryparameters", queryparameters);

        // Parse query parameters into individual key-value pairs and add them to customerData
        queryparameters.split("&").forEach((param) => {
          const [key, value] = param.split("=");
          // Directly add each key-value pair to customerData
          customerData[key] = decodeURIComponent(value || ""); // Handle URL encoding
        });

        
      }

      // Now customerData contains all query parameters dynamically
      // console.log("Final customerData:", customerData);
     
      customerData["Firstname"] = customer_firstname;
      customerData["Surname"] = customer_surname;
      customerData["Email"] = customer_email;
      customerData["Phone"] = customer_phone;
      customerData["Phone Normalized"] = customer_phone_normalized;
      customerData["Company Name"] = customer_company;

      customerData["Location"] = primaryDesign.location;
      customerData["Orientation"] = primaryDesign.orientation;

      if (primaryDesign.customWidth) {
        customerData["Custom Width"] = primaryDesign.customWidth;
        customerData["Custom Length"] = primaryDesign.customLength;
      } else {
        customerData["Size"] = primaryDesign.size;
      }
      customerData["Product Price"] = primaryDesign.productPrice;
      customerData["Quantity"] = primaryDesign.quantity;
      customerData["Discount percentage"] = primaryDesign.discountPercentage;
      customerData["Total Price"] = primaryDesign.totalPrice;
      customerData["Size Type"] = primaryDesign.customWidth ? "custom" : "standard";

      if (productPriceValue !== null) {
        customerData["Unit Price Value"] = productPriceValue;
      }
      if (discountPercentValue !== null) {
        customerData["Discount Percent Value"] = discountPercentValue;
      }
      if (discountedUnitPriceValue !== null) {
        customerData["Discounted Unit Price Value"] = discountedUnitPriceValue;
      }
      if (quantityValue !== null) {
        customerData["Quantity Value"] = quantityValue;
      }
      if (lineTotalValue !== null) {
        customerData["Line Total Value"] = lineTotalValue;
      }
      customerData["Currency"] = "GBP";
      /* Display preference only — the money keys above stay ex-VAT for every
         traffic source, which is what Dataverse holds today and should keep
         holding. This records HOW the customer was seeing those prices, for the
         proof page and for attribution reporting. Needs a Dataverse column
         mapping to be stored; harmless if unmapped. (31-Jul-2026) */
      customerData["Price Basis"] = "ex_vat";
      customerData["Display VAT Mode"] = getVatDisplayMode();

      if (primaryDesign.color) {
        customerData["Color"] = primaryDesign.color;
      }

      if (primaryDesign.productVariantId) {
        customerData["Product Variant Id"] = primaryDesign.productVariantId;
      }

      if (primaryDesign.imageUrl) {
        customerData["Image URL"] = primaryDesign.imageUrl;
      }

      if (primaryDesign.backgroundColor) {
        customerData["Background Color"] = primaryDesign.backgroundColor;
      }

      customerData["Bespoke color"] = primaryDesign.bespokeColor;

      /* Logo Source — recorded on the hidden input
       * `.main-product__uploaded-logo-source` by eq-custom.js (upload /
       * remove) and the rescue handler above (defer). Values:
       *   "upload"      — customer uploaded their own file
       *   "email-later" — stuck-picker rescue: customer will email
       *                   the logo after submitting (25-Aug-2026)
       *   ""            — no logo (should not reach submission)
       * Historical value "brandfetch" came from the auto-finder that was
       * removed 17-Sep-2026; Dataverse rows before then may carry it.
       * Forwarded to postdata.php → Function App → Dataverse. */
      var $logoSource = document.querySelector(".main-product__uploaded-logo-source");
      customerData["Logo Source"] = $logoSource ? ($logoSource.value || "") : "";

      customerData["Proof Mode"] = proofMode;
      customerData["Instant Proof Eligible"] = instantProofEligible ? "true" : "false";
      customerData["Requires Manual Review"] = requiresManualReview ? "true" : "false";
      customerData["Instant Proof Status"] = instantProofEligible ? "pending" : "skipped";
      customerData["Design Item Count"] = designItems.length;
      customerData["Design Items"] = JSON.stringify(designItems);
      customerData["Design Items Object"] = designItemsObject;

      const hasLogoUrl = safeTrim(primaryDesign.imageUrl || customerData["Image URL"]) !== "";
      const hasBackgroundColor =
        safeTrim(primaryDesign.backgroundColor || customerData["Background Color"] || primaryDesign.color) !== "";
      const shouldAttemptInstantProof = instantProofEligible && hasLogoUrl && hasBackgroundColor;

      customerData["Instant Proof Attempted"] = shouldAttemptInstantProof ? "true" : "false";
      if (!shouldAttemptInstantProof) {
        if (!instantProofEligible) {
          customerData["Instant Proof Skip Reason"] = "multi_item_or_manual_mode";
        } else if (!hasLogoUrl) {
          customerData["Instant Proof Skip Reason"] = "missing_logo_url";
        } else if (!hasBackgroundColor) {
          customerData["Instant Proof Skip Reason"] = "missing_background_color";
        }
      }

      /* Meta CAPI lead fields — fbc / fbp / user_agent / event_source_url /
       * marketing_consent. Forwarded by postdata.php AND the ProofCreate
       * Function App to Dataverse columns cr174_fbc / cr174_fbp /
       * cr174_useragent / cr174_eventsourceurl / cr174_marketingconsent (0|1).
       * client_ip is captured server-side from request headers. */
      try {
        if (typeof window.fmGetMetaLeadFields === 'function') {
          var __metaFields = window.fmGetMetaLeadFields();
          customerData["fbc"] = __metaFields.fbc || '';
          customerData["fbp"] = __metaFields.fbp || '';
          customerData["user_agent"] = __metaFields.user_agent || '';
          customerData["event_source_url"] = __metaFields.event_source_url || '';
          customerData["marketing_consent"] = !!__metaFields.marketing_consent;
        }
      } catch (e) { /* helper missing — lead still submits without CAPI fields */ }

      isCheckoutSubmitting = true;
      logoWizardState.isSubmissionComplete = false;
      setInstantProofDebugMessage("");
      setCheckoutSubmitState(
        true,
        "Please Wait, Generating Design"
      );

      const submitLeadPayload = function (instantOutcome) {
        const resolvedOutcome =
          instantOutcome ||
          normalizeInstantProofOutcome(
            {
              status: shouldAttemptInstantProof ? "manual_fallback" : "skipped",
              instantProofStatus: shouldAttemptInstantProof ? "failed" : "skipped",
              proofMode: proofMode,
              requiresManualReview: requiresManualReview,
            },
            shouldAttemptInstantProof ? "failed" : "skipped"
          );

        customerData["Proof Mode"] = resolvedOutcome.proofMode || proofMode;
        customerData["Instant Proof Status"] =
          resolvedOutcome.instantProofStatus || (shouldAttemptInstantProof ? "failed" : "skipped");
        customerData["Requires Manual Review"] =
          typeof resolvedOutcome.requiresManualReview === "boolean"
            ? (resolvedOutcome.requiresManualReview ? "true" : "false")
            : (requiresManualReview ? "true" : "false");

        if (resolvedOutcome.proofId) {
          customerData["Proof ID"] = resolvedOutcome.proofId;
        }
        if (resolvedOutcome.proofUrl) {
          customerData["Proof URL"] = resolvedOutcome.proofUrl;
        }
        if (resolvedOutcome.proofImageUrl) {
          customerData["Proof Image URL"] = resolvedOutcome.proofImageUrl;
        }
        if (resolvedOutcome.draftOrderId) {
          customerData["Draft Order ID"] = resolvedOutcome.draftOrderId;
        }
        if (resolvedOutcome.draftOrderInvoiceUrl) {
          customerData["Draft Order Invoice URL"] = resolvedOutcome.draftOrderInvoiceUrl;
        }
        if (
          resolvedOutcome.renderDurationMs !== null &&
          resolvedOutcome.renderDurationMs !== undefined &&
          !Number.isNaN(resolvedOutcome.renderDurationMs)
        ) {
          customerData["Instant Render Duration Ms"] = resolvedOutcome.renderDurationMs;
        }
        if (resolvedOutcome.errorCode) {
          customerData["Instant Error Code"] = resolvedOutcome.errorCode;
        }
        if (resolvedOutcome.errorMessage) {
          customerData["Instant Error Message"] = resolvedOutcome.errorMessage;
        }

        setInstantProofDebugMessage("");

        $.ajax({
          url: "https://firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-pdp-image/postdata.php",
          method: "POST",
          dataType: "JSON",
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify(customerData),
          success: function () {
            /* 18-May-2026 — fire form-complete tracking in BOTH
             * success paths.
             *
             * Previously the instant-proof branch redirected to the
             * proof URL without ever adding `.form-submit-success`
             * to the form. The MutationObserver in
             * `snippets/lm-form-tracking.liquid` listens for that
             * class flip to fire the `lm_form_complete` GA4 event,
             * so the entire instant-proof success population (the
             * majority of completions in practice) was invisible
             * to GA4's funnel analytics.
             *
             * Fix: add the success class FIRST (before the path
             * branch). The class flip is what we treat as "the
             * customer's submission was accepted" — true whether
             * we then redirect to a proof page or keep them on the
             * wizard for the manual-review path. A brief (200ms)
             * delay before navigation gives the dataLayer push +
             * GTM trigger + GA4 sendBeacon a chance to flush before
             * the browser tears down the page. */
            $(".secure-checkout__form").addClass("form-submit-success");
            logoWizardState.isSubmissionComplete = true;

            /* ── Proof-stage funnel events (11-Jun-2026) ───────────────
             * Extends the GA4/PostHog logo-mat funnel PAST submission.
             * `lm_form_complete` (fired by snippets/lm-form-tracking.liquid
             * when `.form-submit-success` is added above) only tells us a
             * lead was accepted — not whether the customer reached the
             * instant-proof page on design.firstmats.co.uk. These three
             * mutually-exclusive events split the post-submit population:
             *
             *   lm_proof_shown    — instant proof rendered; we're about to
             *                       redirect to the proof page. Identity is
             *                       stitched across to design.firstmats.co.uk
             *                       via PostHog cross_subdomain_cookie, so the
             *                       proof-page pageview continues the SAME
             *                       person (see snippets/posthog-init.liquid).
             *   lm_proof_skipped  — eligible lead but no instant proof
             *                       possible (multi-item / no usable logo /
             *                       no background colour). Carries the reason.
             *   lm_proof_failed   — instant proof was attempted but the
             *                       render failed or timed out (manual fallback).
             *
             * Deferred via setTimeout(0) so this lands AFTER `lm_form_complete`
             * (which fires from a MutationObserver microtask on the class flip
             * above) — keeps the funnel event order correct. Still well inside
             * the 200ms pre-redirect window below. The auto-bridge in
             * posthog-init.liquid mirrors each dataLayer push into PostHog. */
            (function () {
              var DL = (window.dataLayer = window.dataLayer || []);
              var proofStatus = safeTrim(resolvedOutcome.instantProofStatus).toLowerCase();
              var handle =
                (primaryDesign && primaryDesign.productHandle) ||
                customerData["Product Handle"] ||
                "";
              setTimeout(function () {
                if (proofStatus === "success" && safeTrim(resolvedOutcome.proofUrl) !== "") {
                  DL.push({
                    event: "lm_proof_shown",
                    lm_proof_id: resolvedOutcome.proofId || "",
                    lm_proof_mode: resolvedOutcome.proofMode || "",
                    lm_render_duration_ms: resolvedOutcome.renderDurationMs,
                    lm_product_handle: handle,
                  });
                } else if (proofStatus === "skipped") {
                  /* Skip reason can be decided client-side (multi-item /
                   * no logo / no colour — written to customerData earlier)
                   * OR server-side (the ProofCreate API judged the logo
                   * unusable / product not instant-proofable and returned
                   * status "skipped" with no client reason). Prefer the
                   * client reason; else fall back to the server's errorCode
                   * (ignoring the bare "skipped" status echo it defaults to),
                   * so server-decided skips don't all bucket as "unknown".
                   * The freeform server message rides along as a debug
                   * detail (not for low-cardinality breakdowns). */
                  var serverCode = resolvedOutcome.errorCode;
                  if (safeTrim(serverCode).toLowerCase() === proofStatus) serverCode = "";
                  DL.push({
                    event: "lm_proof_skipped",
                    lm_skip_reason:
                      customerData["Instant Proof Skip Reason"] ||
                      serverCode ||
                      "unknown",
                    lm_skip_detail: resolvedOutcome.errorMessage || "",
                    lm_product_handle: handle,
                  });
                } else {
                  DL.push({
                    event: "lm_proof_failed",
                    lm_proof_status: proofStatus || "failed",
                    lm_error_code: resolvedOutcome.errorCode || "",
                    lm_product_handle: handle,
                  });
                }
              }, 0);
            })();

            if (
              resolvedOutcome.instantProofStatus === "success" &&
              safeTrim(resolvedOutcome.proofUrl) !== ""
            ) {
              /* Ring to 100% and hold — the overlay stays up through the
                 redirect rather than flashing the form back. */
              completeProofOverlay();
              setTimeout(function () {
                window.location.href = resolvedOutcome.proofUrl;
              }, 400);
              return;
            }

            showWizardStep(logoWizardState.currentStepIndex, { skipValidation: true });
            /* Staying on the page (force-manual, or an instant proof that was
               skipped/failed): flip the band to the completion state. Must run
               AFTER showWizardStep, which would otherwise re-render the band to
               the contact step. (v3: applies to every stay-on-page success.) */
            renderManualCompletionBand();
            isCheckoutSubmitting = false;
            setCheckoutSubmitState(false);
          },
          error: function () {
            if ($(".secure-checkout__form").hasClass("form-submit-success")) {
              $(".secure-checkout__form").removeClass("form-submit-success");
            }
            logoWizardState.isSubmissionComplete = false;
            isCheckoutSubmitting = false;
            setCheckoutSubmitState(false);
          },
        });
      };

      /* NOTE: an earlier version of this code skipped the ProofCreate call
         for outdoor/circular templates on the assumption that the
         `submitLeadPayload` postdata.php endpoint would still log the lead
         in Dataverse. That was wrong — Dataverse writes happen INSIDE
         ProofCreate (see comment below). Skipping the call meant those
         leads landed in postdata.php only and never reached Dataverse,
         so M&A never saw them. The skip has been removed; ProofCreate is
         now called for every submission again. The "Missing background
         colour in payload." log noise on outdoor/circular submissions is
         being addressed on the Function App side (downgrade to info-level
         when `product_handle` contains outdoor/circular). */

      // Always call ProofCreate so every submission is logged in Dataverse,
      // even incomplete ones (missing logo / colour / multi-item). The
      // Function classifies these on its side and returns an appropriate outcome.
      const instantPayload = buildInstantProofRequestPayload(
        customerData,
        primaryDesign,
        designItems,
        designItemsObject
      );
      $.ajax({
        url: INSTANT_PROOF_API_URL,
        method: "POST",
        dataType: "JSON",
        contentType: "application/json; charset=utf-8",
        timeout: INSTANT_PROOF_CLIENT_TIMEOUT_MS,
        data: JSON.stringify(instantPayload),
        success: function (response) {
          const instantOutcome = normalizeInstantProofOutcome(response, "failed");
          submitLeadPayload(instantOutcome);
        },
        error: function (_xhr, textStatus) {
          const fallbackStatus = textStatus === "timeout" ? "timeout" : "failed";
          submitLeadPayload(
            normalizeInstantProofOutcome(
              {
                status: "manual_fallback",
                instantProofStatus: fallbackStatus,
                proofMode: "manual",
                requiresManualReview: true,
                message:
                  fallbackStatus === "timeout"
                    ? "Instant proof timed out."
                    : "Instant proof request failed.",
              },
              fallbackStatus
            )
          );
        },
      });
    }
  });

  /* get JS Work start */

  $(".custom-mats-product__tabs .tab-a").on("click", function () {
    /* Sync the panel visibility (CSS-driven .tab-active class) */
    $(".custom-mats-product__tabs .tab").removeClass("tab-active");
    $(
      ".custom-mats-product__tabs .tab[data-id='" +
        $(this).attr("data-id") +
        "']"
    ).addClass("tab-active");
    /* Sync the tab button styling + ARIA state. `aria-selected`
       added 26-May-2026 alongside the `<a>`-to-`<button>` swap so
       screen readers track which tab is current. */
    $(".custom-mats-product__tabs .tab-a")
      .removeClass("active")
      .attr("aria-selected", "false");
    $(this)
      .addClass("active")
      .attr("aria-selected", "true");
  });

  $(".custom-mats-product__video-play").click(function () {
    // Hide the banner
    $(this).parent().hide();

    const videoSrc = $("#youtubeVideo").attr("src") + "&autoplay=1";
    $("#youtubeVideo").attr("src", videoSrc);

    // Show the video container
    $("#videoContainer").css("display", "block");

    // Get the original src, add autoplay, and set it back
  });

  if (
    $(".js-product-lovedby-slider").length > 0 &&
    !$(".js-product-lovedby-slider").hasClass("slick-initialized")
  ) {
    $(".js-product-lovedby-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow:
        '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 15L17 21L23 27" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5" cy="20.5" r="20" transform="rotate(-180 20.5 20.5)" stroke="#7D86BC"/></svg></button>',
      nextArrow:
        '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 26L24 20L18 14" stroke="#7D86BC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5" cy="20.5" r="20" stroke="#7D86BC"/></svg></button>',
      responsive: [
        {
          breakpoint: 991.98,
          settings: {
            slidesToShow: 2,
            arrows: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 1,
            arrows: true,
            prevArrow:
              '<button type="button" class="prev-arrow" aria-label="Previous slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" transform="rotate(-180 20.5 21)" fill="#7D86BC" stroke="#7D86BC"/><path d="M23 15.5L17 21.5L23 27.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow:
              '<button type="button" class="next-arrow" aria-label="Next slide"><svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20.5" cy="21" r="20" fill="#7D86BC" stroke="#7D86BC"/><path d="M18 26.5L24 20.5L18 14.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          },
        },
      ],
    });
  }

  /* get JS Work start */
});

/*
Phone Number Validation (intl-tel-input)
if (iti) {
    let phoneNumber = iti.getNumber(); // Get formatted phone number

    if (phoneNumber && phoneNumber !== "+" && phoneNumber.length > 1) { // Check if there's a value and it's not just the "+" sign
        let phoneValid = iti.isValidNumber(); // Check if the phone number is valid
        if (phoneValid) {
            // Valid field: Remove error message and invalid class
            phoneNumberField.removeClass("invalid");
            $("#phoneError").hide();
        } else {
            // Invalid field: Show error message and add invalid class
            isValid = false;
            phoneNumberField.addClass("invalid");
            $("#phoneError").text("Please enter a valid phone number.").css('display','block');
        }
    } else {
        // Empty field: Show error message and add invalid class
        isValid = false;
        phoneNumberField.addClass("invalid");
        $("#phoneError").text("Phone number is required.").css('display','block');
    }

} else {
    // If iti is not initialized, show error
    isValid = false;
    phoneNumberField.addClass("invalid");
    $("#phoneError").text("Phone number is required.").css('display','block');
}

*/

/* 
Initialize the intlTelInput instance
iti = window.intlTelInput($(phoneNumberField), {
    initialCountry: "auto",  // Auto-detect the country based on the user's IP
    separateDialCode: true, // Display the dial code together with the flag
    formatOnDisplay: true,   // Format the number when displayed
    nationalMode: false,     // Force international number formatting
    geoIpLookup: function (callback) {
        $.get('https://ipinfo.io', function () {}, "jsonp").always(function (resp) {
            var countryCode = (resp && resp.country) ? resp.country : "";
            callback(countryCode);
        });
    },
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.0.3/js/utils.js", // Optional utils script for number formatting and validation
    preferredCountries: [] // Optional: you can list preferred countries here (e.g., ['us', 'gb'])

});
*/

// custom option price handler
function customPriceHandler(selectedOption) { 
  
  const widthInput = document.querySelector('input[name="width"]');
  const lengthInput = document.querySelector('input[name="length"]');
  if (!widthInput || !lengthInput) {
    return;
  }
  function calculatePrice() {
    /* Looked up on EVERY run, not once at bind time (23-Sep-2026). The
       selected-size span (`.cw-product-bundle__variant-selected .…-price`) is
       rebuilt by OptionsHandler each time an option is clicked, so a NodeList
       captured when the listeners were first bound pointed at detached spans
       after custom → standard → custom. Every later keystroke then updated the
       stale copies while the visible/payload price kept the FIRST custom
       figure — Jack hit this on the live wizard. */
    const bundlePriceDisplays = document.querySelectorAll(
      ".cw-product-bundle__variant-price"
    );
    const bundleOptionPriceDisplays = document.querySelectorAll(
      ".cw-product-bundle__variant-option"
    );
    const width = parseFloat(widthInput.value) || 0;
    const length = parseFloat(lengthInput.value) || 0;

    if (width > 0 && length > 0) {
      const area = width * length;
      // VAT-toggle aware (08-Jun-2026): always compute the EX base price,
      // derive INC (×1.2), and display whichever matches the current mode.
      // Both formatted values are stashed on the price elements so a
      // later toggle re-swaps without recomputing.
      const price = ((area / 10000) * 50.46 + 13) * 1.6;       // ex, in £
      const priceInc = price * 1.2;                            // inc, in £
      const fmIncMode = (window.fmVatMode === "inc");
      const formattedPriceEx  = Shopify.formatMoney(price * 100);
      const formattedPriceInc = Shopify.formatMoney(priceInc * 100);
      const formattedPrice    = fmIncMode ? formattedPriceInc : formattedPriceEx;

      $(".main-product__price-value")
        .attr("data-ex-price", formattedPriceEx)
        .attr("data-inc-price", formattedPriceInc)
        .text(formattedPrice);
      $(".main-product__size-option").find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price").attr('data-without-money-total', formattedPrice)
      /* Refresh the ex/inc attributes on the SELECTED size span, not just its
         text. `OptionsHandler()` seeds them from the "Custom Size" tile's
         £1.04 placeholder variant (correctly — no dimensions exist yet), and
         nothing refreshed them once the customer typed the real dimensions.
         Two consumers read the attribute rather than the text, so both saw
         £1.04 forever:
           - readExVatPriceFromSizeSelect() (~line 645) feeds productPriceEx
             into the enquiry/proof payload, so enquiries went out at £1.04/unit
             while the customer was shown the correct figure. Silent: nothing
             on screen was wrong.
           - fm-vat.js (~line 120) repaints every [data-ex-price] element from
             these attributes, so a VAT toggle after entering dimensions
             reverted the VISIBLE price to £1.04 too.

         Scoped to `.main-product__size-option` deliberately. Do NOT move this
         into the `bundlePriceDisplays.forEach` below — that NodeList is every
         `.cw-product-bundle__variant-price` on the page, including the
         quantity select's span, which shows the quantity-DISCOUNTED per-unit
         price. Stamping the undiscounted figure there would make fm-vat.js
         repaint the discount away on the next VAT toggle. That span has no
         `data-ex-price` today; leave it that way. (08-Sep-2026) */
      $(".main-product__size-option")
        .find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price")
        .attr("data-ex-price", formattedPriceEx)
        .attr("data-inc-price", formattedPriceInc);
      bundlePriceDisplays.forEach((element) => {
        element.textContent = formattedPrice;
      });
      bundleOptionPriceDisplays.forEach((ele) => {
        if (ele.getAttribute("data-text").includes("Custom Size")) {
          // data-price stays EX (display base); add data-price-inc for the
          // dropdown JS, and data-variant-price stays EX pence (calc base).
          ele.setAttribute("data-price", formattedPriceEx);
          ele.setAttribute("data-price-inc", formattedPriceInc);
          ele.setAttribute("data-variant-price", price * 100);
          var customOptPriceEl = ele.querySelector(".cw-product-bundle__option-price");
          if (customOptPriceEl) {
            customOptPriceEl.setAttribute("data-ex-price", formattedPriceEx);
            customOptPriceEl.setAttribute("data-inc-price", formattedPriceInc);
            customOptPriceEl.textContent = formattedPrice;
          }
        }
      });

      quantityPriceHandler(price * 100); // Pass raw price as a number
      $(".cw-product-bundle__variant-price").show();
      updateCustomSizeLabels();
    } else {
      $(".cw-product-bundle__variant-price").hide();
      updateCustomSizeLabels();
    }
    $('.cw-product-bundle__variant-option[data-selected-qty="1"]')
      .show()
      .addClass("active-status");
    $(
      '.cw-product-bundle__variant-option[data-selected-qty]:not([data-selected-qty="1"])'
    )
      .hide()
      .removeClass("active-status");
  }

  if (!widthInput.dataset.logoMatCustomSizeBound) {
    widthInput.addEventListener("input", calculatePrice);
    lengthInput.addEventListener("input", calculatePrice);
    widthInput.dataset.logoMatCustomSizeBound = "true";
  }

  calculatePrice();
}

function quantityPriceHandler(money) {
  
  // console.log("Base money:", money);
  const percentageOffElement = document.querySelector(
    ".main-product__quantity-option .cw-product-bundle__variant-save-percentage"
  );
  const percentageOff = percentageOffElement
    ? percentageOffElement.textContent.replace(/Save\s*/i, "").trim()
    : "";

  const PercentageFifteen = $(
    '.cw-product-bundle__variant-option[data-selected-qty="2"]'
  ).attr("data-save-percentage");
  const PercentageFifteenCleaned = PercentageFifteen.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageFifteenFormate = parseFloat(PercentageFifteenCleaned) / 100;

  const PercentageTwenty = $(
    '.cw-product-bundle__variant-option[data-selected-qty="3"]'
  ).attr("data-save-percentage");
  const PercentageTwentyCleaned = PercentageTwenty.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageTwentyFormate = parseFloat(PercentageTwentyCleaned) / 100;

  const PercentageThirty = $(
    '.cw-product-bundle__variant-option[data-selected-qty="4"]'
  ).attr("data-save-percentage");
  const PercentageThirtyCleaned = PercentageThirty.replace(
    /Save\s*/i,
    ""
  ).trim();
  const PercentageThirtyFormate = parseFloat(PercentageThirtyCleaned) / 100;
  // Calculate 15% and 20% discounts
  const fifteenPercentOff = money - money * PercentageFifteenFormate;
  const twentyPercentOff = money - money * PercentageTwentyFormate;
  const thirtyPercentOff = money - money * PercentageThirtyFormate;

  let price;
  if (percentageOff === PercentageThirty) {
    price = Shopify.formatMoney(thirtyPercentOff);
  } else if (percentageOff === PercentageTwenty) {
    price = Shopify.formatMoney(twentyPercentOff);
  } else if (percentageOff === PercentageFifteen) {
    price = Shopify.formatMoney(fifteenPercentOff);
  } else {
    price = Shopify.formatMoney(money);
  }

  // Update main quantity option price display
  const mainPriceElement = document.querySelector(
    ".main-product__quantity-option .cw-product-bundle__variant-price"
  );
  if (mainPriceElement) {
    mainPriceElement.innerHTML = price;
    // console.log("price changed along with qty!!");
  }

  // Function to update variant options
  const updateVariantOption = (qty, discountPrice) => {
    const variantOption = document.querySelector(
      `.cw-product-bundle__variant-option[data-selected-qty="${qty}"]`
    );
    if (variantOption) {
      variantOption.setAttribute("data-price", discountPrice);
      const optionPriceElement = variantOption.querySelector(
        ".cw-product-bundle__option-price"
      );
      if (optionPriceElement) {
        optionPriceElement.innerHTML = discountPrice;
      }
    }
  };

  // Update each variant option price
  updateVariantOption("4", Shopify.formatMoney(thirtyPercentOff));
  updateVariantOption("3", Shopify.formatMoney(twentyPercentOff));
  updateVariantOption("2", Shopify.formatMoney(fifteenPercentOff));
  updateVariantOption("1", Shopify.formatMoney(money));

  // console.log("20% Discounted Price:", Shopify.formatMoney(twentyPercentOff));
  // console.log("15% Discounted Price:", Shopify.formatMoney(fifteenPercentOff));
  // console.log("Original Price:", Shopify.formatMoney(money));
}

// Listen for events like afterClose, close, clickOutside after Fancybox has been opened
// Fancybox.defaults.afterClose = function() {
//   console.log("afterClose");
//   // Remove class from form after closing
//   const form = document.querySelector('.secure-checkout__form');
//   if (form && form.classList.contains('form-submit-success')) {
//     form.classList.remove('form-submit-success');
//   }
// };

// Fancybox.defaults.on = {
//   close: function() {
//     console.log("close");
//     const form = document.querySelector('.secure-checkout__form');
//     if (form && form.classList.contains('form-submit-success')) {
//       form.classList.remove('form-submit-success');
//     }
//   },
//   clickOutside: function() {
//     console.log("clickOutside");
//     const form = document.querySelector('.secure-checkout__form');
//     if (form && form.classList.contains('form-submit-success')) {
//       form.classList.remove('form-submit-success');
//     }
//   }
// };

$("#fourplusqty").on("input", function () {
  // Get the value of the changed input
  let qtyText =
    $(".main-product__quantity-option .cw-product-bundle__variant-option").attr(
      "data-text"
    ) || "";
  var inputValue = $(this).val();
  if (qtyText == "4+ Qty") {
  }
  $(".main-product__quantity-option .cw-product-bundle__variant-selected").attr(
    "currentqty",
    inputValue
  );
});

// $(document).on("click", ".js-click-step-sigh-up", function(){
//   $(this).parent('.first-screen').hide();
//   $(this).parent('.first-screen').siblings('.second-screen').show();
// })

